webpackJsonp([115],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns__);



function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var splitBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var newDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(year, month, day), formatter);
		return newDate;
	}
	return null;
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

	var newDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(date), formatter);
	return newDate;
}

function generateBlob(data) {
	var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'application/pdf';

	return new Blob([data], { type: contentType });
}

function getLocalData(key) {
	return JSON.parse(localStorage.getItem("praktiko" + '::' + key));
}

function getLocalStorage() {
	return JSON.parse(localStorage.getItem('' + "praktiko"));
}

function getLocalToken() {
	return localStorage.getItem("praktiko" + '::token');
}

function removeLocalData(key) {
	return localStorage.removeItem("praktiko" + '::' + key);
}

function setLocalData(key, data) {
	return localStorage.setItem("praktiko" + '::' + key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function showDownloadDialog(blob, name, extension) {
	var currentDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = name + '_' + currentDate + '.' + extension;
	link.href = window.URL.createObjectURL(blob);
	link.click();
}

/* eslint-disable */
function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
	var immediate = arguments[2];

	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function roundTo(number, decimalNumber) {
	var factor = Math.pow(10, decimalNumber);
	return Math.round(number * factor) / factor;
};

function calculateExperience(valueTable, code, valueInput) {
	var totalMounthTable = 60;
	var percentage = [];
	percentage.push(valueTable);
	var cont = 0;
	while (cont < totalMounthTable) {
		if (cont !== 0) {
			percentage[cont] = percentage[cont - 1] + valueTable;
		}
		cont += 1;
	}
	var exponencial = percentage.map(function (num) {
		return Math.exp(roundTo(num / 100, 4));
	});
	if (code === 'EXA') {
		percentage = percentage.map(function (num) {
			return roundTo(num, 2);
		});
		return percentage[valueInput - 1];
	} else if (code === 'EXB') {
		var typeB = exponencial.map(function (exp) {
			return roundTo((exp - 1) * 50, 2);
		});
		return typeB[valueInput - 1];
	} else if (code === 'EXC') {
		var typeC = exponencial.map(function (exp) {
			return roundTo((exp - 1) * (1 / 3) * 100, 2);
		});
		return typeC[valueInput - 1];
	}
};

function calculateTraining(valueTableTrainig, code, valueInput) {
	var totalHoursTable = 200;
	var percentage = [];
	percentage.push(valueTableTrainig);
	var cont = 0;
	while (cont < totalHoursTable) {
		if (cont !== 0) {
			percentage[cont] = percentage[cont - 1] + valueTableTrainig;
		}
		cont += 1;
	}
	var exponencial = percentage.map(function (num) {
		return Math.exp(roundTo(num / 100, 4));
	});
	if (code === 'CA') {
		percentage = percentage.map(function (num) {
			return roundTo(num, 2);
		});
		return percentage[valueInput - 1];
	} else if (code === 'CB') {
		var typeB = exponencial.map(function (exp) {
			return roundTo((exp - 1) * 50, 2);
		});
		return typeB[valueInput - 1];
	} else if (code === 'CC') {
		var typeC = exponencial.map(function (exp) {
			return roundTo((exp - 1) * (1 / 3) * 100, 2);
		});
		return typeC[valueInput - 1];
	}
};

function calculateYears(date) {
	var isInt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	var entry = new Date(date);
	var now = new Date();
	var diffInMilliseconds = now - entry;
	var diffInYears = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
	if (!isInt) {
		return parseFloat(diffInYears.toFixed(2));
	}
	return parseInt(diffInYears, 10);
}

var methods = {
	debounce: debounce,
	roundTo: roundTo,
	calculateExperience: calculateExperience,
	calculateTraining: calculateTraining,
	exactDate: exactDate,
	formatDate: formatDate,
	generateBlob: generateBlob,
	getLocalData: getLocalData,
	getLocalStorage: getLocalStorage,
	getLocalToken: getLocalToken,
	removeLocalData: removeLocalData,
	setLocalData: setLocalData,
	showDownloadDialog: showDownloadDialog,
	calculateYears: calculateYears
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export aclInstance */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return praktikoInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pollInstance; });
/* unused harmony export jobEvaluationInstance */
/* unused harmony export uploadInstance */
/* unused harmony export scrapingInstances */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var aclInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://temp-acl-praktiko.apprunn.net/api'
});

var praktikoInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://temp-praktiko.apprunn.net/'
});

var pollInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://temp-pollengine.apprunn.net/'
});

var jobEvaluationInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://temp-pollengine.apprunn.net/'
});

var uploadInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'undefined'
});
var scrapingInstances = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'http://34.204.114.234:8080/'
});

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$http = pollInstance;
	Vue.prototype.$httpAcl = aclInstance;
	Vue.prototype.$httpPraktiko = praktikoInstance;
	Vue.prototype.$httpUpLoad = uploadInstance;
	Vue.prototype.$httpJobEvaluation = jobEvaluationInstance;
	Vue.prototype.$httpScraper = scrapingInstances;
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue___default.a());

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */,
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return diff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getSlugify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addUuidName; });
/* unused harmony export getFactorIdsToCompare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFactorCombinations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return factorWeighingCompletedCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return factorWeighingIsCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combinationsAreFilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return factorWeighingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return totalSumWeighings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getPercentageByValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPercentageValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return factorIsSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return generateWeighingComparison; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getFactorsToCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addWeighWith; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return loadInformation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(17);



var diff = function diff(a, b) {
	return a.localeCompare(b);
};

var getSlugify = function getSlugify(value) {
	return __WEBPACK_IMPORTED_MODULE_0_slugify__(value, {
		lower: true,
		remove: /[^\w\s]/gi
	});
};

var addUuidName = function addUuidName(factor) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])('uuid', getSlugify(factor.name), factor);
};

var getFactorIdsToCompare = function getFactorIdsToCompare(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(function () {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["s" /* filter */])(function (item) {
			return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["y" /* has */])(factor.uuid, item);
		}, combinations || []);
	}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* keys */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["v" /* flatten */], Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_11" /* without */])(factor.uuid, __WEBPACK_IMPORTED_MODULE_1_ramda__["a" /* __ */]))(factor);
};

var getFactorCombinations = function getFactorCombinations(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["s" /* filter */])(function (item) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["y" /* has */])(factor.uuid, item);
	}, combinations || []);
};

var factorWeighingCompletedCount = function factorWeighingCompletedCount(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(function (factorItem) {
		return getFactorCombinations(factorItem, combinations);
	}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["s" /* filter */])(function (item) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* all */])(function (x) {
			return !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["F" /* isNil */])(x);
		}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_9" /* values */])(item));
	}), __WEBPACK_IMPORTED_MODULE_1_ramda__["I" /* length */])(factor);
};

var factorWeighingIsCompleted = function factorWeighingIsCompleted(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["r" /* equals */])(factorWeighingCompletedCount(factor, combinations), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["I" /* length */])(getFactorCombinations(factor, combinations)));
};

var combinationsAreFilled = function combinationsAreFilled(combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["_9" /* values */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["v" /* flatten */], Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["g" /* any */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["F" /* isNil */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["M" /* not */])(combinations);
};

var factorWeighingSum = function factorWeighingSum(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(function () {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["S" /* pluck */])(factor.uuid, combinations || []);
	}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_0" /* reject */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["F" /* isNil */]), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["Z" /* reduce */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["b" /* add */], 0))(factor);
};

var totalSumWeighings = function totalSumWeighings(combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["_9" /* values */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["v" /* flatten */], Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_0" /* reject */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["F" /* isNil */]), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["Z" /* reduce */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["b" /* add */], 0))(combinations);
};

var getPercentageByValue = function getPercentageByValue(value, total) {
	if (total > 0) {
		return (value * 100 / total).toFixed(0);
	}
	return 0;
};

var getPercentageValue = function getPercentageValue(percentage, total) {
	if (total > 0) {
		return (percentage * total / 100).toFixed(0);
	}
	return 0;
};

var factorIsSelected = function factorIsSelected(selectedFactors, factor) {
	return !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["F" /* isNil */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["t" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["W" /* propEq */])('uuid', factor.uuid), selectedFactors));
};

var existCombination = function existCombination(combination, combinationList) {
	var foundIndex = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["u" /* findIndex */])(function (combinationItem) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["r" /* equals */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_2" /* sort */])(diff, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* keys */])(combination)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_2" /* sort */])(diff, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* keys */])(combinationItem)));
	}, combinationList);
	return foundIndex > 0;
};

var generateWeighingComparison = function generateWeighingComparison(selectedList) {
	var combinationList = [];
	Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["w" /* forEach */])(function (factor) {
		Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["w" /* forEach */])(function (compareFactor) {
			var factorUuid = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* prop */])('uuid', factor);
			var compareFactorUuid = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* prop */])('uuid', compareFactor);
			if (factorUuid !== compareFactorUuid) {
				var combination = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])(factorUuid, null), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])(compareFactorUuid, null))({});
				if (!existCombination(combination, combinationList)) {
					combinationList = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* append */])(combination, combinationList);
				}
			}
		}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_4" /* tail */])(selectedList));
	}, selectedList);
	return combinationList;
};

var getFactorsToCompare = function getFactorsToCompare(factor, combinations, selectedFactors) {
	var factorToCompareIds = getFactorIdsToCompare(factor, combinations);
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["s" /* filter */])(function (factorItem) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["C" /* includes */])(factorItem.uuid, factorToCompareIds) && !factorWeighingIsCompleted(factorItem, combinations);
	}, selectedFactors);
};

var addWeighWith = function addWeighWith(selectedFactors, combinations) {
	var findElement = function findElement(uuid) {
		var foundIndex = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["u" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["W" /* propEq */])('uuid', uuid), selectedFactors);
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* prop */])(foundIndex, selectedFactors);
	};

	var restCombinations = combinations;
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(function (factor) {
		var newFactor = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])('weighWith', Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["s" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["y" /* has */])(factor.uuid)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* keys */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["v" /* flatten */], Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_0" /* reject */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["r" /* equals */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["a" /* __ */], factor.uuid)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(function (factorUuid) {
			var element = findElement(factorUuid);
			return {
				name: element.name,
				uuid: element.uuid,
				urlImage: element.urlImage
			};
		}))(restCombinations), factor);
		restCombinations = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_0" /* reject */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["y" /* has */])(factor.uuid), restCombinations);
		return newFactor;
	}, selectedFactors);
};

var fillCombinations = function fillCombinations(emptyCombinations, informationSource) {
	var combinations = emptyCombinations;
	Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["w" /* forEach */])(function (factor) {
		var parsedSubFactors = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* prop */])('relatedFactorWeights'), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(addUuidName))(factor);
		Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["w" /* forEach */])(function (fact) {
			var foundIndex = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["u" /* findIndex */])(function (ele) {
				return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["y" /* has */])(factor.uuid, ele) && Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["y" /* has */])(fact.uuid, ele);
			}, combinations);
			var foundElement = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* prop */])(foundIndex, combinations);
			combinations = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_8" /* update */])(foundIndex, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])(factor.uuid, fact.weight, foundElement), combinations);
		}, parsedSubFactors);
	}, informationSource);
	return combinations;
};

var fillFactorDegrees = function fillFactorDegrees(informationSource) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["Z" /* reduce */])(function (prev, factor) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])(factor.uuid, factor.grades, prev);
	}, {}), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(function (degree) {
		return {
			uuid: degree.code,
			name: degree.name,
			selected: !!degree.flagActive,
			rate: degree.rate
		};
	})))(informationSource);
};

var loadInformation = function loadInformation(prevInformation, factorList) {
	var prevInformationUuid = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* map */])(addUuidName, prevInformation);
	var selectedFactors = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["S" /* pluck */])('uuid'), function (ids) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["s" /* filter */])(function (factor) {
			return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["C" /* includes */])(factor.uuid, ids);
		}, factorList);
	})(prevInformationUuid);
	var combinations = generateWeighingComparison(selectedFactors);
	combinations = fillCombinations(combinations, prevInformationUuid);
	var factorDegrees = fillFactorDegrees(prevInformationUuid);
	return {
		selectedFactors: addWeighWith(selectedFactors, combinations),
		combinations: combinations,
		factorDegrees: factorDegrees
	};
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateJobProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCompletedFieldsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return verifyJobIsCompleted; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(17);


var hasValidValue = function hasValidValue(value) {
	return !Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["F" /* isNil */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["E" /* isEmpty */])(value);
};

// Nueva función para calcular el progreso de configuración del puesto
var calculateJobProgress = function calculateJobProgress(job) {
	if (!job) return 0;

	var checks = [
	// Verificar si tiene al menos un verbo seleccionado
	function () {
		var hasVerbs = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["s" /* filter */])(function (levelKey) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* any */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["r" /* equals */])(true), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["_9" /* values */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])(levelKey, job)));
		}, ['highCommand', 'mediumCommand', 'lowCommand']);
		return hasVerbs.length > 0;
	},
	// Verificar rol
	function () {
		return hasValidValue(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('role', job));
	},
	// Verificar título
	function () {
		return hasValidValue(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('title', job));
	},
	// Verificar experiencia
	function () {
		return hasValidValue(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('experience', job));
	},
	// Verificar nivel de inglés
	function () {
		return hasValidValue(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('englishLevel', job));
	},
	// Verificar cantidad de personas
	function () {
		var quantity = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('quantityPerson', job);
		return hasValidValue(quantity) && quantity > 0;
	}];

	var completedChecks = checks.filter(function (check) {
		return check();
	}).length;
	var totalChecks = checks.length;

	return Math.round(completedChecks / totalChecks * 100);
};

// Nueva función para obtener el número de campos completados
var getCompletedFieldsCount = function getCompletedFieldsCount(job) {
	if (!job) return 0;

	var checks = [
	// Verificar si tiene al menos un verbo seleccionado
	function () {
		var hasVerbs = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["s" /* filter */])(function (levelKey) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* any */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["r" /* equals */])(true), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["_9" /* values */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])(levelKey, job)));
		}, ['highCommand', 'mediumCommand', 'lowCommand']);
		return hasVerbs.length > 0;
	},
	// Verificar rol
	function () {
		return hasValidValue(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('role', job));
	},
	// Verificar título
	function () {
		return hasValidValue(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('title', job));
	},
	// Verificar experiencia
	function () {
		return hasValidValue(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('experience', job));
	},
	// Verificar nivel de inglés
	function () {
		return hasValidValue(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('englishLevel', job));
	},
	// Verificar cantidad de personas
	function () {
		var quantity = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('quantityPerson', job);
		return hasValidValue(quantity) && quantity > 0;
	}];

	return checks.filter(function (check) {
		return check();
	}).length;
};

var generateJob = function generateJob(jobName) {
	var newJob = {
		additionalInformation: {
			immediateBoss: {},
			jobHeReplaces: [],
			jobItReplaces: []
		},
		name: jobName,
		highCommand: {},
		mediumCommand: {},
		lowCommand: {},
		role: {},
		title: {},
		experience: {},
		englishLevel: {},
		quantityPerson: 1,
		completed: false,
		status: true,
		typeVerb: null
	};

	// Calcular el progreso inicial
	newJob.progress = calculateJobProgress(newJob);

	return newJob;
};

var verifyJobIsCompleted = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["e" /* allPass */])([Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(function (job) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["s" /* filter */])(function (levelKey) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* any */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["r" /* equals */])(true), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["_9" /* values */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])(levelKey, job)));
	}, ['highCommand', 'mediumCommand', 'lowCommand']);
}, __WEBPACK_IMPORTED_MODULE_0_ramda__["z" /* head */], __WEBPACK_IMPORTED_MODULE_0_ramda__["F" /* isNil */], __WEBPACK_IMPORTED_MODULE_0_ramda__["M" /* not */]), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('role'), hasValidValue), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('title'), hasValidValue), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('experience'), hasValidValue), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('englishLevel'), hasValidValue),
// pipe(prop('areaId'), hasValidValue),
// pipe(prop('immediateBoss'), hasValidValue),
// pipe(prop('jobHeReplaces'), hasValidValue),
// pipe(prop('jobItReplaces'), hasValidValue),
Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('quantityPerson'), function (value) {
	return hasValidValue(value) && value > 0;
})]);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e88f5f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(1196);
function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e88f5f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e88f5f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_toolConfigurartion__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_presents__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_levelType__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_answer__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_icons__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_job_evaluation_store_index__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_evaluation_360_state_process_index__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_job_profile_store_index__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_polls_store_index__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getters__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mutations__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_helper__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__persist__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_three_sixty_evaluation_store__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_recruitment_store_index__ = __webpack_require__(971);




















__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
	modules: {
		answer: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_6__store_modules_answer__["a" /* default */]),
		icon: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_7__store_modules_icons__["a" /* default */]),
		levelType: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_5__store_modules_levelType__["a" /* default */]),
		presentsConfiguration: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_4__store_modules_presents__["a" /* default */]),
		tool: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_3__store_modules_toolConfigurartion__["a" /* default */]),
		jobEvaluation: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_8__modules_job_evaluation_store_index__["a" /* default */]),
		evaluation360: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_9__modules_evaluation_360_state_process_index__["a" /* default */]),
		jobProfile: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_10__modules_job_profile_store_index__["a" /* default */]),
		polls: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_11__modules_polls_store_index__["a" /* default */]),
		threeSixtyEvaluation: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			namespaced: true
		}, __WEBPACK_IMPORTED_MODULE_17__modules_three_sixty_evaluation_store__["a" /* default */]),
		recruitment: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_18__modules_recruitment_store_index__["a" /* default */])
	},
	state: {
		appConfig: {
			isLoading: false,
			snackbar: {
				text: '',
				isVisible: false,
				color: 'primary'
			}
		},
		sideBarRoutes: {},
		pollData: {
			progress: 0
		},
		token: __WEBPACK_IMPORTED_MODULE_15__shared_helper__["a" /* default */].getLocalToken(),
		user: {
			email: '',
			logo: 'praktiko-logo.svg',
			profileImage: '',
			username: '',
			isEployee: false
		}
	},
	actions: __WEBPACK_IMPORTED_MODULE_12__actions__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_13__getters__["a" /* default */],
	mutations: __WEBPACK_IMPORTED_MODULE_14__mutations__["a" /* default */],
	plugins: [__WEBPACK_IMPORTED_MODULE_16__persist__["a" /* default */].plugin]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getTheeSixtyEvaluationState = function getTheeSixtyEvaluationState() {
	return {
		jobs: [],
		jobAreas: [],
		moduleConfiguration: {
			steps: {
				firstStep: {},
				dynamicSteps: [],
				lastStep: {}
			},
			videoUrl: '',
			fileUrl: 'https://go.microsoft.com/fwlink/?LinkID=521962'
		},
		evaluationFlow: {
			currentStep: 1,
			selectedAreaIds: [],
			selectedJobs: []
		}
	};
};

/* harmony default export */ __webpack_exports__["a"] = (getTheeSixtyEvaluationState);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_shared_components_ui_p_main_loader__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dynamic_css__ = __webpack_require__(978);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function indeterminate() {
	return this.$store.getters.indeterminate;
}

function snackbar() {
	return this.$store.getters.snackbar;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	components: { PMainLoader: __WEBPACK_IMPORTED_MODULE_0__modules_shared_components_ui_p_main_loader__["a" /* default */] },
	computed: {
		indeterminate: indeterminate,
		snackbar: snackbar
	},
	mounted: function mounted() {
		// injecting css helpers for ui
		Object(__WEBPACK_IMPORTED_MODULE_1__utils_dynamic_css__["a" /* injectCssVariables */])();
		Object(__WEBPACK_IMPORTED_MODULE_1__utils_dynamic_css__["b" /* injectTextColors */])();
	}
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_app_bus__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__p_main_loader_constants__ = __webpack_require__(527);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PMainLoader',
	data: function data() {
		return {
			message: '',
			showLoader: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__bus_app_bus__["a" /* default */].$on(__WEBPACK_IMPORTED_MODULE_1__p_main_loader_constants__["a" /* MAIN_LOADER_EVENT */], function (_ref) {
			var show = _ref.show,
			    message = _ref.message;

			_this.showLoader = show;
			_this.message = message;
		});
	}
});

/***/ }),
/* 462 */,
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function closeDrawer() {
	this.$emit('close-modal', false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'action-sidebar',
	methods: {
		closeDrawer: closeDrawer
	},
	model: {
		prop: 'value',
		event: 'close-modal'
	},
	props: {
		title: {
			type: String,
			required: true
		},
		value: {
			type: Boolean,
			required: true
		},
		width: {
			type: Number,
			default: 600
		},
		codeAction: {
			type: String,
			required: false
		},
		imgSrc: {
			type: String
		},
		headerColor: {
			type: String,
			default: 'white'
		},
		isLoading: {
			default: false,
			type: Boolean
		}
	}
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(39);





var loadTools = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, response;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('tools');

					case 2:
						_ref2 = _context.sent;
						response = _ref2.data;

						this.tools = response;
						setLocalData('tools', this.tools);

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadTools() {
		return _ref.apply(this, arguments);
	};
}();

var logout = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						_context2.next = 3;
						return this.$httpAcl.post('logout');

					case 3:
						_context2.next = 5;
						return this.$store.dispatch('jobEvaluation/cleanJobEvaluationState');

					case 5:
						window.localStorage.clear();
						this.showNotification('Se ha cerrado la sesión');
						this.goTo('login');
						_context2.next = 13;
						break;

					case 10:
						_context2.prev = 10;
						_context2.t0 = _context2['catch'](0);

						if (_context2.t0.status === 500) {
							this.showGenericError();
						}

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 10]]);
	}));

	return function logout() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getLocalData = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].getLocalData,
    setLocalData = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData;


function created() {
	this.loadTools();
	this.getBreadCrumbs();
}

function getBreadCrumbs() {
	var _this = this;

	var matched = this.$route.matched;

	var _matched = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray___default()(matched),
	    rest = _matched.slice(1);

	this.breadCrumbs = rest.filter(function (r) {
		return !_this.sideBarRoutes[r.name];
	});
}

function routeHandler() {
	this.getBreadCrumbs();
}

function routeParams(_ref4) {
	var toolId = _ref4.toolId;

	var toolIdValue = Number(this.toolId) || Number(toolId);
	var routeTool = this.tools.find(function (t) {
		return t.id === toolIdValue;
	});
	this.secondRoute = routeTool ? routeTool.name : '';
	setLocalData('toolSelected', this.secondRoute);
}

function mounted() {
	this.secondRoute = getLocalData('toolSelected');
}

function data() {
	return {
		breadCrumbs: [],
		secondRoute: '',
		tools: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-header',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({
		sideBarRoutes: function sideBarRoutes(state) {
			return state.sideBarRoutes;
		}
	})),
	created: created,
	data: data,
	methods: {
		getBreadCrumbs: getBreadCrumbs,
		loadTools: loadTools,
		logout: logout,
		routeHandler: routeHandler
	},
	mounted: mounted,
	props: {
		isVisible: {
			type: Boolean,
			default: false
		},
		logoUrl: String,
		title: String,
		toolId: [Number, String]
	},
	watch: {
		'$route.fullPath': routeHandler,
		'$route.params': routeParams
	}
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helper__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(122);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var params, headers, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							languages: 'es'
						};
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};
						_context.prev = 2;
						_context.next = 5;
						return this.$httpAcl.get('sidebar/' + 'praktiko-admin', { headers: headers, params: params });

					case 5:
						response = _context.sent;

						this.items = response.data.data.map(function (item) {
							_this.setRouteManifest(item);
							var newItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);
							if (item.resource.data.length === 0) {
								if (item.uri === _this.$route.path) {
									newItem.active = true;
								}
							} else {
								item.resource.data.forEach(function (src) {
									if (src.uri === _this.$route.path || '/' + src.uri === _this.$route.path) {
										newItem.active = true;
									}
								});
								item.resource.data.reverse(function (a, b) {
									return a.position - b.position;
								});
							}
							return newItem;
						}).reverse(function (a, b) {
							return a.position - b.position;
						});
						__WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].setLocalData('sidebar', this.items);
						this.$emit('active-route', this.items);
						this.$store.dispatch('setSideBarRoutes', this.routeObject);
						_context.next = 15;
						break;

					case 12:
						_context.prev = 12;
						_context.t0 = _context['catch'](2);

						this.$store.showSnackBar({
							color: 'error',
							text: 'Error interno, recargue la página e intente de nuevo'
						});

					case 15:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 12]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.loadData();
}

function data() {
	return {
		company: {
			logoOpen: 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktiko-slider.png',
			logoClose: 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-small.png'
		},
		drawer: true,
		items: [],
		mini: false,
		routeObject: {},
		user: {
			position: 'Gerente General'
		}
	};
}

function setRouteManifest(route) {
	var self = this;
	route.resource.data.forEach(function (r) {
		var uri = r.uri;

		self.routeObject[uri] = uri;
	});
}

function toggle() {
	this.mini = this.toggle;
}

function mini(value) {
	this.$emit('toggle-sidebar', value);
}

function goToUser() {
	this.goTo('profile');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-sidebar',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['fullName']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])({
		avatar: function avatar(state) {
			return state.user.urlImage ? state.user.urlImage : 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg';
		}
	})),
	created: created,
	data: data,
	methods: {
		loadData: loadData,
		goToUser: goToUser,
		setRouteManifest: setRouteManifest
	},
	props: {
		toggle: {
			type: Boolean,
			default: true
		},
		isVisible: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		toggle: toggle,
		mini: mini
	}
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-login'
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_app_header__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_sidebar__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_subheader__ = __webpack_require__(1211);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function changeToggle(value) {
	this.isVisible = value;
}

function closeNotificationsModal() {
	this.action.active = false;
	this.action.open = false;
}

function getRoutes(routes) {
	var _this = this;

	this.routes = routes;
	var module = this.routes.find(function (mod) {
		return mod.name === _this.$route.meta.title;
	}) || {};
	this.logoUrl = module.pathIcon;
}

function notifications() {
	var allNotifications = [];
	if (this.productsNotifications.length > 0) {
		this.productsNotifications.forEach(function (productNot) {
			allNotifications.push(productNot);
		});
	}
	if (this.salesNotifications.length > 0) {
		this.salesNotifications.forEach(function (saleNot) {
			allNotifications.push(saleNot);
		});
	}
	return allNotifications;
}

function openNotificationsModal() {
	this.action.active = true;
	this.action.open = true;
}

function quantityNotifications() {
	return 0;
}

function toggleSidebar() {
	this.isVisible = !this.isVisible;
}

function $route(value) {
	var module = this.routes.find(function (mod) {
		return mod.name === value.meta.title;
	}) || {};
	this.logoUrl = module.pathIcon || this.$route.meta.logo;
}

function data() {
	return {
		action: {
			active: false,
			code: 'NOT',
			open: false,
			title: 'Notificaciones',
			width: 468
		},
		isVisible: false,
		loading: false,
		logoUrl: '',
		routes: []
	};
}

function showIndeterminate() {
	return this.$store.getters.indeterminate;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-admin',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__["a" /* default */],
		appHeader: __WEBPACK_IMPORTED_MODULE_1__components_shared_app_header__["a" /* default */],
		appSidebar: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_sidebar__["a" /* default */],
		appSubheader: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_subheader__["a" /* default */]
	},
	computed: {
		notifications: notifications,
		quantityNotifications: quantityNotifications,
		showIndeterminate: showIndeterminate
	},
	data: data,
	methods: {
		closeNotificationsModal: closeNotificationsModal,
		getRoutes: getRoutes,
		openNotificationsModal: openNotificationsModal,
		toggleSidebar: toggleSidebar,
		changeToggle: changeToggle
	},
	watch: {
		$route: $route
	}
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

function created() {
	window.addEventListener('resize', this.toolbarHeight);
	this.toolbarHeight();
}

function destroyed() {
	window.removeEventListener('resize', this.toolbarHeight);
}

function toolbarHeight() {
	var windowWidth = window.innerWidth;
	if (windowWidth >= 768) {
		this.heightToolbar = 40;
	} else {
		this.heightToolbar = 80;
	}
}

function data() {
	return {
		heightToolbar: 40
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-subheader',
	created: created,
	data: data,
	destroyed: destroyed,
	methods: {
		toolbarHeight: toolbarHeight
	}
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_header__ = __webpack_require__(200);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function getRoutes(routes) {
	var _this = this;

	this.routes = routes;
	var module = this.routes.find(function (mod) {
		return mod.name === _this.$route.meta.title;
	}) || {};
	this.logoUrl = module.pathIcon;
}

function data() {
	return {
		logoUrl: '',
		routes: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-dashboard',
	components: {
		appHeader: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_header__["a" /* default */]
	},
	data: data,
	methods: {
		getRoutes: getRoutes
	},
	watch: {
		$route: function $route(to) {
			var module = this.routes.find(function (mod) {
				return mod.name === to.meta.title;
			}) || {};
			this.logoUrl = module.pathIcon || to.meta.logo;
		}
	}
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'general-filter'
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function splitDate(date) {
	return date.split('/');
}

function formatDate(date) {
	if (!date) {
		return null;
	}

	var _splitDate = splitDate(date),
	    _splitDate2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_splitDate, 3),
	    day = _splitDate2[0],
	    month = _splitDate2[1],
	    year = _splitDate2[2];

	return year + '-' + month + '-' + day;
}

function onChange($event, eventName) {
	var value = formatDate($event);
	if (value) {
		this.$emit(eventName, value);
	} else {
		this.$emit(eventName, null);
	}
}

function onInput($event) {
	this.$emit('input', $event);
	var dateValues = splitDate($event);
	if (dateValues && dateValues.length === 3) {
		this.$emit('format-date', __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(new Date(dateValues[2], dateValues[1] - 1, dateValues[0]), this.format));
	} else if (dateValues && dateValues.length < 3) {
		this.$emit('format-date', null);
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-date-mask',
	inheritAttrs: false,
	model: {
		prop: 'picker',
		event: 'input'
	},
	props: {
		format: {
			default: 'YYYY-MM-DD',
			type: String
		},
		label: {
			default: '',
			type: String
		},
		mask: {
			default: '##/##/####',
			type: String
		},
		picker: {
			default: null
		}
	},
	methods: {
		onChange: onChange,
		onInput: onInput
	}
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_column_item__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_helper__ = __webpack_require__(39);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ADD_REQUEST_EVENT = 'on-add-event';
var LOCAL_SEARCH_EVENT = 'on-local-search';
var SEARCH_EVENT = 'on-search-event';
var ON_DRAG_EVENT = 'on-drag-event';
var ON_DRAG_ENTER = 'on-drag-enter';
var ON_DRAG_LEAVE = 'on-drag-leave';
var ON_DROP_EVENT = 'on-drop-event';
var ON_PAGE_EVENT = 'on-page';
var ROW_IS_SELECTED = 'row-is-selected';
var ROW_ON_CLICK = 'row-on-click';
var SELECTED_ALL_EVENT = 'on-selected-all';
var TABLE_OPTION_EVENT = 'table-option-event';

var components = {
	TableColumnItem: __WEBPACK_IMPORTED_MODULE_1__table_column_item__["a" /* default */]
};

function addOption() {
	this.$emit(ADD_REQUEST_EVENT);
}

function pagination(pageNumber, totalRecords) {
	var current = pageNumber;
	var last = totalRecords;
	var delta = 2;
	var left = current - delta;
	var right = current + delta + 1;
	var range = [];
	var rangeWithDots = [];
	var l = null;

	for (var i = 1; i <= last; i += 1) {
		/* eslint-disable no-mixed-operators */
		if (i === 1 || i === last || i >= left && i < right) {
			range.push(i);
		}
	}

	/* eslint-disable no-restricted-syntax */
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(range), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _i = _step.value;

			if (l) {
				if (_i - l === 2) {
					rangeWithDots.push(l + 1);
				} else if (_i - l !== 1) {
					rangeWithDots.push('...');
				}
			}
			rangeWithDots.push(_i);
			l = _i;
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return rangeWithDots;
}

function data() {
	return {
		currentRow: null,
		direction: 'right',
		search: '',
		showMenu: false,
		previousRowId: null
	};
}

function mounted() {
	window.addEventListener('resize', this.optionsDirection);
	this.optionsDirection();
	var columnsInLocalStorage = __WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].getLocalData(this.$attrs.name + '::columns');
	if (columnsInLocalStorage) {
		this.columns.forEach(function (col) {
			var newCol = col;
			var colToChange = columnsInLocalStorage.find(function (c) {
				return c.id === newCol.id;
			});
			if (colToChange) {
				newCol.visible = colToChange.visible;
				newCol.checked = colToChange.checked;
			}
		});
	}
	if (this.localStorage) {
		var searchFromLocalStorage = __WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].getLocalData(this.$attrs.name + '::search');
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}
}

function toggleColumns() {
	var _this = this;

	this.selectedColumns = this.columns.filter(function (c) {
		return !c.checked;
	});
	this.columns.forEach(function (col) {
		var newCol = col;
		var colToChange = _this.selectedColumns.find(function (c) {
			return c.id === newCol.id;
		});
		newCol.visible = typeof colToChange === 'undefined';
	});
	__WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::columns', this.selectedColumns);
	this.showMenu = false;
}

function selectedAll(value) {
	// v-checkbox de Vuetify emite directamente el valor booleano
	// Para compatibilidad, también soportamos el formato de evento nativo
	var isChecked = void 0;
	if (typeof value === 'boolean') {
		isChecked = value;
	} else if (value && value.target) {
		isChecked = value.target.checked;
	} else {
		isChecked = false;
	}
	this.$emit(SELECTED_ALL_EVENT, isChecked);
}

function rowIsSelected(row) {
	var _this2 = this;

	if (this.selectable) {
		this.$set(row, 'isSelected', !row.isSelected);
		this.$emit(ROW_IS_SELECTED, row);
	} else {
		if (this.previousRowId !== null && this.previousRowId !== row.id) {
			var previousRow = this.rows.find(function (item) {
				return item.id === _this2.previousRowId;
			});
			if (previousRow) {
				this.$set(previousRow, 'isChecked', false);
			}
		}
		this.$set(row, 'isChecked', !row.isChecked);
		this.previousRowId = row.id;
		this.$emit(ROW_ON_CLICK, row);
	}
}

function totalsOnFooter() {
	return this.totalQuantity ? this.totalVisibleColumns - this.beforeColumn('quantity') : this.totalVisibleColumns;
}

function beforeColumn(colVal) {
	return this.columns.findIndex(function (c) {
		return c.value === colVal;
	}) + this.addColValue;
}

function searchRows($event) {
	var keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		var dataToLocalSearch = this.search.toLowerCase();
		__WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		__WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

function changePage(page) {
	if (page !== '...') {
		if (page !== this.currentPage) {
			this.$emit(ON_PAGE_EVENT, page);
		}
	}
}

function cleanSearch(val) {
	if (val) {
		this.search = '';
	}
}

function selectPage(page) {
	var newPage = page > this.lastPage ? this.lastPage : page;
	newPage = newPage <= 0 ? 1 : newPage;
	changePage.call(this, Number(newPage));
}

function selectLastPage() {
	changePage.call(this, this.lastPage);
}

function tableOption() {
	var action = {
		active: true,
		code: 'filter-by',
		color: '#fafafa',
		imgSrc: '/static/img/actions-list/cancel.svg',
		open: true,
		title: 'FILTRAR POR',
		width: 229
	};
	this.$emit(TABLE_OPTION_EVENT, action);
}

function optionsDirection() {
	if (window.innerWidth < 768) {
		this.direction = 'left';
	} else {
		this.direction = 'right';
	}
}

function totalVisibleColumns() {
	return this.columns.filter(function (c) {
		return c.visible;
	}).length + 1;
}

function pages() {
	return pagination(this.currentPage, this.lastPage);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table',
	components: components,
	computed: {
		pages: pages,
		totalVisibleColumns: totalVisibleColumns,
		totalsOnFooter: totalsOnFooter
	},
	data: data,
	methods: {
		addOption: addOption,
		beforeColumn: beforeColumn,
		onDrag: onDrag,
		onDragEnter: onDragEnter,
		onDragLeave: onDragLeave,
		onDrop: onDrop,
		optionsDirection: optionsDirection,
		rowIsSelected: rowIsSelected,
		searchRows: searchRows,
		selectedAll: selectedAll,
		selectPage: selectPage,
		selectLastPage: selectLastPage,
		tableOption: tableOption,
		toggleColumns: toggleColumns
	},
	mounted: mounted,
	props: {
		captionQuantity: {
			default: true,
			type: Boolean
		},
		totalQuantity: {
			type: Number,
			default: 0
		},
		iconArea: {
			default: false,
			type: Boolean
		},
		iconEmployee: {
			default: false,
			type: Boolean
		},
		addButton: {
			default: false,
			type: Boolean
		},
		checkAll: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Array,
			required: true
		},
		currentPage: {
			type: Number,
			default: 1
		},
		dispatchDetail: {
			default: false,
			type: Boolean
		},
		filterColumns: {
			default: true,
			type: Boolean
		},
		includeFilter: {
			type: Boolean,
			default: false
		},
		inputSearch: {
			default: true,
			type: Boolean
		},
		localSearch: {
			type: Boolean,
			default: false
		},
		localStorage: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Array,
			required: true
		},
		selectable: {
			type: Boolean,
			default: false
		},
		lastPage: {
			type: Number,
			default: 0
		},
		keyValue: {
			type: String,
			default: 'id'
		},
		mainList: {
			type: Boolean,
			default: true
		},
		cleanSearch: {
			default: false,
			type: Boolean
		},
		title: String,
		iconExcel: {
			default: false,
			type: Boolean
		},
		iconEmail: {
			default: false,
			type: Boolean
		},
		importExcel: {
			default: false,
			type: Boolean
		},
		iconSave: {
			default: false,
			type: Boolean
		},
		downloadFormat: {
			default: false,
			type: Boolean
		},
		btnActions: {
			default: false,
			type: Boolean
		},
		disabledAssign: {
			default: false,
			type: Boolean
		},
		flagRoute: {
			type: Boolean,
			default: false
		},
		totalQuantityLabel: String,
		itemsTotalQuantity: [Number, String],
		itemsQuantity: [Number, String],
		indexByRow: {
			type: Number,
			default: 0
		},
		downloadEmployees: {
			default: false,
			type: Boolean
		}
	},
	watch: {
		cleanSearch: cleanSearch,
		rows: function rows(newVal) {
			var _this3 = this;

			if (newVal && !this.currentRow) {
				if (newVal.length > 0) {
					this.currentRow = newVal[0];
					this.$nextTick(function () {
						if (_this3.$refs['row-0']) {
							_this3.$refs['row-0'][0].focus();
						}
					});
				}
			}
		}
	}
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var SORTABLE_COLUMN_EVENT = 'on-column-sortable';

function changeStateSort(fieldName) {
	if (this.column.color === 'gray') {
		this.direction = 'DESC';
	}
	if (this.direction === 'ASC') {
		this.direction = 'DESC';
		this.column.color = 'secondary';
		// if (this.nameColumn === fieldName) {
		// 	this.nameColumn = null;
		// }
	} else {
		this.direction = 'ASC';
		this.column.color = 'primary';
	}
	this.$emit('changeColor', fieldName);
	this.$emit('changeSort', { fieldName: fieldName, sortDirection: this.direction });
}

function data() {
	return {
		showInput: false,
		direction: 'DESC',
		nameColumn: null
	};
}

function onColumnSortable(column) {
	this.$emit(SORTABLE_COLUMN_EVENT, column);
}

function toggleInput(column) {
	var _this = this;

	this.$set(column, 'showInput', !column.showInput);
	if (column.showInput) {
		this.$nextTick(function () {
			var columnInput = _this.$refs['colheader' + column.id];
			if (columnInput) {
				columnInput.focus();
			}
		});
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'table-column-item',
	data: data,
	props: {
		column: {
			type: Object,
			required: true
		},
		onCloumnSortable: {
			type: Function
		}
	},
	methods: {
		changeStateSort: changeStateSort,
		onColumnSortable: onColumnSortable,
		toggleInput: toggleInput
	}
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function Regresar() {
	this.goTo('job-evaluation-processes');
}

function goBackToValuation() {
	this.goTo('job-supply-description-of-charges');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table-disenar-escala',
	props: {
		tablaHeaderTitulo: {
			default: true,
			type: Boolean
		},
		tablaHeaderButton__1: {
			default: true,
			type: Boolean
		}
	},
	methods: {
		Regresar: Regresar,
		goBackToValuation: goBackToValuation
	}
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table-disenar-escala-header'
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table-disenar-escala-data',
	props: {
		// puesto: String,
		rows: {
			type: Array,
			required: true
		}
	}
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table-disenar-escala-orange',
	props: {
		// puesto: String,
		rows: {
			type: Array,
			required: true
		}
	}
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table-disenar-escala-Odata',
	props: {
		// puesto: String,
		rows: {
			type: Array,
			required: true
		}
	}
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);

//
//
//
//
//
//



function data() {
	return {
		chartInstance: null
	};
}

function sortedLevels() {
	return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.levels));
}

function chartLabels() {
	return this.sortedLevels.map(function (l) {
		return l.name;
	});
}

function currentSalaries() {
	var _this = this;

	return this.sortedLevels.map(function (l) {
		if (!l.average || l.average === 0) return 0;
		var percentage = l.average / 1000;
		return Math.round(_this.currentPayroll * percentage * 100) / 100;
	});
}

function idealSalaries() {
	var _this2 = this;

	return this.sortedLevels.map(function (l) {
		if (!l.average || l.average === 0) return 0;
		var percentage = l.average / 1000;
		return Math.round(_this2.idealPayroll * percentage * 100) / 100;
	});
}

function renderChart() {
	var canvas = document.getElementById('scale-chart');
	if (!canvas || this.levels.length === 0) return;
	if (this.chartInstance) {
		this.chartInstance.destroy();
	}
	var hasData = this.sortedLevels.map(function (l) {
		return l.average && l.average > 0;
	});
	var currentColors = hasData.map(function (d) {
		return d ? '#f09c2b' : 'rgba(158, 158, 158, 0.3)';
	});
	var idealColors = hasData.map(function (d) {
		return d ? '#55ac4b' : 'rgba(158, 158, 158, 0.3)';
	});
	var currentBorders = hasData.map(function (d) {
		return d ? '#f09c2b' : 'rgba(158, 158, 158, 0.4)';
	});
	var idealBorders = hasData.map(function (d) {
		return d ? '#55ac4b' : 'rgba(158, 158, 158, 0.4)';
	});
	var datasets = [{
		label: 'Sueldo Actual',
		data: this.currentSalaries,
		backgroundColor: currentColors,
		borderColor: currentBorders,
		borderWidth: 1
	}, {
		label: 'Sueldo Ideal',
		data: this.idealSalaries,
		backgroundColor: idealColors,
		borderColor: idealBorders,
		borderWidth: 1
	}];
	this.chartInstance = new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(canvas, {
		type: 'horizontalBar',
		data: {
			labels: this.chartLabels,
			datasets: datasets
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				position: 'top',
				labels: {
					fontSize: 12,
					fontStyle: 'bold',
					padding: 20,
					generateLabels: function generateLabels(chart) {
						var palette = {
							'Sueldo Actual': '#f09c2b',
							'Sueldo Ideal': '#55ac4b'
						};
						return chart.data.datasets.map(function (ds, i) {
							var color = palette[ds.label] || '#9e9e9e';
							return {
								text: ds.label,
								fillStyle: color,
								strokeStyle: color,
								lineWidth: 0,
								hidden: !chart.isDatasetVisible(i),
								datasetIndex: i
							};
						});
					}
				}
			},
			scales: {
				xAxes: [{
					ticks: {
						beginAtZero: true,
						callback: function callback(value) {
							return '$' + value.toLocaleString();
						}
					},
					gridLines: {
						display: true
					}
				}],
				yAxes: [{
					gridLines: {
						display: false
					},
					ticks: {
						fontSize: 11
					}
				}]
			},
			tooltips: {
				callbacks: {
					label: function label(tooltipItem) {
						var dsLabel = datasets[tooltipItem.datasetIndex].label;
						var value = tooltipItem.xLabel;
						return ' ' + dsLabel + ': $' + Number(value).toLocaleString();
					}
				}
			}
		}
	});
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table-disenar-escala-grafico',
	props: {
		levels: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		currentPayroll: {
			type: Number,
			default: 0
		},
		idealPayroll: {
			type: Number,
			default: 0
		}
	},
	data: data,
	computed: {
		sortedLevels: sortedLevels,
		chartLabels: chartLabels,
		currentSalaries: currentSalaries,
		idealSalaries: idealSalaries
	},
	watch: {
		levels: {
			handler: function handler() {
				var _this3 = this;

				this.$nextTick(function () {
					return _this3.renderChart();
				});
			},

			deep: true
		}
	},
	mounted: function mounted() {
		this.renderChart();
	},
	beforeDestroy: function beforeDestroy() {
		if (this.chartInstance) {
			this.chartInstance.destroy();
		}
	},

	methods: {
		renderChart: renderChart
	}
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon($e) {
	this.$emit('click-icon', $e);
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		isListAll: isListAll
	},
	props: {
		color: {
			type: String,
			default: 'success'
		},
		icon: String,
		img: String,
		size: [Number, String],
		text: {
			type: String,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		cursor: {
			type: String,
			default: 'pointer'
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon($e) {
	this.$emit('click-icon', $e);
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-btn',
	computed: {
		isListAll: isListAll
	},
	props: {
		color: {
			type: String,
			default: 'success'
		},
		icon: String,
		img: String,
		size: [Number, String],
		text: {
			type: String,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'p-notification-bell',
	props: {
		// Icono a mostrar (por defecto campana)
		icon: {
			type: String,
			default: 'notifications'
		},
		// Color del icono
		iconColor: {
			type: String,
			default: 'grey'
		},
		// Tamaño del icono
		iconSize: {
			type: [String, Number],
			default: 24
		},
		// Número a mostrar en el badge
		count: {
			type: Number,
			default: 0
		},
		// Texto del tooltip
		tooltipText: {
			type: String,
			required: true
		},
		// Color del badge (success, warning, error, info)
		badgeColor: {
			type: String,
			default: 'warning',
			validator: function validator(value) {
				return ['success', 'warning', 'error', 'info', 'primary'].includes(value);
			}
		},
		// Máximo número a mostrar antes de usar "+"
		maxCount: {
			type: Number,
			default: 99
		}
	},
	computed: {
		displayCount: function displayCount() {
			return this.count > this.maxCount ? this.maxCount + '+' : this.count;
		},
		badgeColorClass: function badgeColorClass() {
			return 'badge-' + this.badgeColor;
		}
	},

	methods: {
		handleClick: function handleClick() {
			this.$emit('click');
		}
	}
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function columnsToExport() {
	var columnsSelected = this.columns.filter(function (column) {
		return column.visible && !column.flagVisible;
	});
	var newColumns = columnsSelected.map(function (col) {
		var newCol = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}

function dataToExport() {
	var tableDataToExport = [];
	var columnsSelected = this.columns.filter(function (column) {
		return column.visible && !column.flagVisible;
	});
	var columnsValues = columnsSelected.map(function (colVal) {
		var newColVal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map(function (dataExport) {
			var newData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, dataExport);
			var keysData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataExport);
			keysData.forEach(function (keyData) {
				if (columnsValues.every(function (keyCol) {
					return keyCol !== keyData;
				})) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function print() {
	window.print();
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'header-page',
	computed: {
		columnsToExport: columnsToExport,
		dataToExport: dataToExport
	},
	methods: {
		downloadDispatch: downloadDispatch,
		downloadDocument: downloadDocument,
		print: print
	},
	props: {
		columns: {
			type: Array
		},
		exportToPdf: {
			default: false,
			type: Boolean
		},
		name: {
			type: String
		},
		rows: {
			type: Array
		},
		showClean: {
			default: true,
			type: Boolean
		},
		showExcel: {
			default: true,
			type: Boolean
		},
		title: {
			type: String,
			required: true
		},
		toShow: {
			default: false,
			type: Boolean
		},
		quotation: {
			default: false,
			type: Boolean
		},
		sale: {
			default: false,
			type: Boolean
		}
	}
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'form-sidebar'
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function cancelModal() {
	this.$emit('cancel-button-clicked');
}

function setInfo() {
	this.$emit('accept-button-clicked');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'modal-sidebar-button',
	methods: {
		cancelModal: cancelModal,
		setInfo: setInfo
	},
	props: {
		isLoading: {
			default: false,
			type: Boolean
		},
		hidden: {
			type: Boolean,
			default: false
		},
		hiddenSaveBtn: {
			type: Boolean,
			default: false
		},
		successColor: {
			default: 'success',
			type: String
		},
		successImg: {
			default: 'icon-apply.svg',
			type: String
		},
		successText: {
			default: 'Aceptar',
			type: String
		},
		cancelText: {
			default: 'Cancelar',
			type: String
		}
	}
});

/***/ }),
/* 523 */,
/* 524 */,
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THREE_SIXTY_EVALUATION_NAMESPACE; });
var THREE_SIXTY_EVALUATION_NAMESPACE = 'threeSixtyEvaluation';

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 526 */,
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAIN_LOADER_EVENT; });
var MAIN_LOADER_EVENT = 'app-event-loader-toggle-view';

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 528 */,
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_sidebar_vue__ = __webpack_require__(500);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8445c8b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_sidebar_vue__ = __webpack_require__(1177);
function injectStyle (ssrContext) {
  __webpack_require__(1176)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8445c8b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8445c8b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__ = __webpack_require__(502);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8f0ab7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__ = __webpack_require__(1198);
function injectStyle (ssrContext) {
  __webpack_require__(1197)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8f0ab7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8f0ab7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 531 */,
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tseParseJobs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tseStepIsCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tseToSurvey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_constants__ = __webpack_require__(969);





var tseParseJobs = function tseParseJobs(rawJobs) {
	return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["U" /* project */])(['name', 'id', 'code'], rawJobs);
};

var tseStepIsCompleted = function tseStepIsCompleted(validator, jobs) {
	var completedJobsCount = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["I" /* length */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["s" /* filter */])(function (jobItem) {
		return validator(jobItem);
	}, jobs));
	return {
		completedCount: completedJobsCount,
		totalJobsCount: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["I" /* length */])(jobs),
		isComplete: completedJobsCount === Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["I" /* length */])(jobs)
	};
};

var tseToSurvey = function tseToSurvey(selectedJobs, surveyName, answerId) {
	return {
		name: surveyName,
		toolCode: __WEBPACK_IMPORTED_MODULE_3__constants_constants__["a" /* TSE_TOOL_CODE */],
		answerId: answerId,
		factorsWeight: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Z" /* reduce */])(function (accumulator, jobItem) {
			var skills = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */])(function (skillItem) {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, skillItem, {
					jobId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('id', jobItem),
					jobName: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('name', jobItem)
				});
			}, Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["X" /* propOr */])([], 'skills', jobItem));
			return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(accumulator), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(skills));
		}, []), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */])(function (skillItem) {
			return {
				id: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* path */])(['selectedLevel', 'id'], skillItem),
				name: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* path */])(['selectedLevel', 'name'], skillItem),
				typeCompetenceId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* path */])(['parent', 'id'], skillItem),
				typeCompetenceName: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* path */])(['parent', 'name'], skillItem),
				competenceId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* path */])(['id'], skillItem),
				competenceName: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* path */])(['name'], skillItem),
				jobId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* path */])(['jobId'], skillItem),
				jobName: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* path */])(['jobName'], skillItem),
				questions: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["X" /* propOr */])([], 'selectedQuestions'), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('id')))(skillItem),
				totalQuestions: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["X" /* propOr */])([], 'selectedQuestions'), __WEBPACK_IMPORTED_MODULE_2_ramda__["I" /* length */])(skillItem),
				questionsKpi: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["X" /* propOr */])([], 'selectedQuestions')(skillItem)
			};
		}))(selectedJobs)
	};
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPGM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNewDegree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPGm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assocRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseRequestValuation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(17);




var mapIndexed = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* addIndex */])(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */]);
var BASE_PG = 1000;

var getPGM = function getPGM(factor, combinations) {
	var totalSum = Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["h" /* factorWeighingSum */])(factor, combinations);
	var totalWeighing = Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["p" /* totalSumWeighings */])(combinations);
	var percentage = Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["l" /* getPercentageByValue */])(totalSum, totalWeighing);
	return Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["m" /* getPercentageValue */])(parseFloat(percentage), BASE_PG);
};

var getNewDegree = function getNewDegree(data) {
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		code: null
	}, data, {
		uuid: Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["n" /* getSlugify */])(data.name)
	});
};

var toFixed = function toFixed(value) {
	return Math.round(value) === value ? value : value.toFixed(2);
};

var getPGm = function getPGm(pgMax, degrees) {
	return toFixed(pgMax / (Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["I" /* length */])(degrees) || 1));
};

var assocRate = function assocRate(pgMax, selectedDegrees, degree) {
	var rate = 0;
	if (degree.selected) {
		var indexFound = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["u" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["W" /* propEq */])('uuid', degree.uuid), selectedDegrees);
		var progressionValue = pgMax / Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["I" /* length */])(selectedDegrees);
		rate = toFixed((indexFound + 1) * progressionValue);
	}
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, degree, {
		rate: rate
	});
};

var getFactorsWeight = function getFactorsWeight(selectedFactors, combinations, factorDegrees) {
	return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */])(function (factor) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* pick */])(['id', 'name', 'urlImage'], factor), {
			criterionId: null,
			criterionName: null,
			totalWeight: Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["h" /* factorWeighingSum */])(factor, combinations),
			totalGrade: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])(factor.uuid), __WEBPACK_IMPORTED_MODULE_2_ramda__["I" /* length */])(factorDegrees),
			grades: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])(factor.uuid), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* applySpec */])({
				code: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('uuid'),
				name: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('name'),
				flagActive: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('selected'), function (value) {
					return value ? 1 : 0;
				}),
				rate: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('rate')
			})))(factorDegrees),
			relatedFactorWeights: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["s" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["y" /* has */])(factor.uuid)), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["p" /* dissoc */])(factor.uuid)), mapIndexed(function (relatedFactor) {
				var relatedFactorUuid = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["z" /* head */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* keys */])(relatedFactor));
				var factorFound = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["t" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["W" /* propEq */])('uuid', relatedFactorUuid), selectedFactors);
				return {
					id: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('id', factorFound),
					name: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('name', factorFound),
					weight: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])(relatedFactorUuid, relatedFactor),
					criterionId: 1
				};
			}))(combinations)
		});
	}, selectedFactors);
};

var parseRequestValuation = function parseRequestValuation(state) {
	var selectedFactors = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["P" /* pathOr */])([], ['supplies', 'valuationModel', 'selectedFactors'], state);
	var combinations = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["P" /* pathOr */])([], ['supplies', 'valuationModel', 'weighing', 'combinations'], state);
	var factorDegrees = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["P" /* pathOr */])([], ['supplies', 'valuationModel', 'degree', 'factorDegrees'], state);
	return {
		name: 'Nombre de la encuesta 001',
		toolCode: 'JEV',
		languages: {
			SPA: { name: 'Nombre de la encuesta 001' },
			ENG: { name: 'Poll name 001' },
			FRA: { name: 'Nom du sondage 001' }
		},
		stageStatus: 1,
		stageDetailStatus: 3,
		factorsWeight: getFactorsWeight(selectedFactors, combinations, factorDegrees)
	};
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commandMap; });
/* unused harmony export commandMapInverted */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseJobs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parseHierarchyAssignation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseAssignationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseOrganizationChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_job_profile_helpers_helpers__ = __webpack_require__(199);







var commandMap = {
	highCommand: 'HIGH',
	mediumCommand: 'MIDDLE',
	lowCommand: 'UNDER'
};

var commandMapInverted = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["D" /* invertObj */])(commandMap);
var concatAll = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["Z" /* reduce */])(__WEBPACK_IMPORTED_MODULE_4_ramda__["n" /* concat */], []);
var getCurrentToolCode = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['mainData', 'code']);
var getDeleteJobIds = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['supplies', 'guidelineModel', 'userForm', 'deletedJobs']), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('id')));
var getCommandByTypeVerb = function getCommandByTypeVerb(job) {
	return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('typeVerb', job), commandMapInverted);
};
var matchWithLocalVerbs = function matchWithLocalVerbs(state, job) {
	return function (verbCode) {
		return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["t" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('code', verbCode), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['supplies', 'guidelineModel', 'verbsSelection', getCommandByTypeVerb(job), 'details']), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["Q" /* pick */])(['id', 'name', 'code'])))(state));
	};
};
var parseVerbs = function parseVerbs(state) {
	return function (job) {
		return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["X" /* propOr */])({}, getCommandByTypeVerb(job)), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["_0" /* reject */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["r" /* equals */])(false)), __WEBPACK_IMPORTED_MODULE_4_ramda__["G" /* keys */], Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(matchWithLocalVerbs(state, job)), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["_0" /* reject */])(__WEBPACK_IMPORTED_MODULE_4_ramda__["F" /* isNil */]))(job);
	};
};

var overrideVerbStructure = function overrideVerbStructure(usedCommand, originalJob) {
	return function (parsedJob) {
		return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["j" /* assoc */])(usedCommand, Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('verbsCode'), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["S" /* pluck */])('code'), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(function (k) {
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, k, true);
		}), __WEBPACK_IMPORTED_MODULE_4_ramda__["K" /* mergeAll */])(originalJob), parsedJob);
	};
};

var parseJobs = function parseJobs(originalJob) {
	var usedCommand = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('typeVerb', originalJob), commandMapInverted);
	return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["i" /* applySpec */])({
		additionalInformation: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('additionalInformation'),
		id: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('id'),
		name: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('name'),
		role: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('roleId'),
		title: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('titulationId'),
		typeVerb: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('typeVerb'),
		experience: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('expirienceTimeId'),
		fatherId: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('fatherId'),
		areaId: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('areaId'),
		fatherName: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('fatherName'),
		quantityPerson: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('quantityPerson'),
		englishLevel: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('englishLevelId'),
		status: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('status'),
		isAreaManager: function isAreaManager(job) {
			return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])(false, ['additionalInformation', 'isAreaManager'], job);
		},
		isHighestAuthority: function isHighestAuthority(job) {
			return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])(false, ['additionalInformation', 'isHighestAuthority'], job);
		},
		mirrorFatherIds: function mirrorFatherIds(job) {
			return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['mirrorFatherIds'], job);
		},
		highCommand: function highCommand() {
			return {};
		},
		mediumCommand: function mediumCommand() {
			return {};
		},
		lowCommand: function lowCommand() {
			return {};
		},
		verbsCode: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('verbsCode')
	}), overrideVerbStructure(usedCommand, originalJob), function (job) {
		return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["j" /* assoc */])('completed', Object(__WEBPACK_IMPORTED_MODULE_5__modules_job_profile_helpers_helpers__["d" /* verifyJobIsCompleted */])(job), job);
	})(originalJob);
};

var parseHierarchyAssignation = function parseHierarchyAssignation(assignations) {
	return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["i" /* applySpec */])({
		id: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('id'),
		job: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["N" /* path */])(['question', 'name']),
		hasError: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('flagFix'),
		jobPositions: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('details'), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(parseJobs))
	}), assignations || []);
};

var toolCommonConfig = {
	name: 'Valoración de puestos',
	languages: {
		SPA: { name: 'Nombre de la encuesta 001' },
		ENG: { name: 'Poll name 001' },
		FRA: { name: 'Nom du sondage 001' }
	},
	stageStatus: 1,
	stageDetailStatus: 1
};

var specParseJobToRequest = function specParseJobToRequest(state) {
	var validIds = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['supplies', 'guidelineModel', 'userForm', 'jobList'], state).map(function (j) {
		return j.id;
	}));
	return {
		additionalInformation: function additionalInformation(job) {
			var existing = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('additionalInformation', job) || {};
			var filtered = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, existing);
			if (Array.isArray(filtered.jobHeReplaces)) {
				filtered.jobHeReplaces = filtered.jobHeReplaces.filter(function (r) {
					var id = r && (typeof r === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(r)) === 'object' ? r.id : r;
					return id && validIds.has(id);
				});
			}
			if (Array.isArray(filtered.jobItReplaces)) {
				filtered.jobItReplaces = filtered.jobItReplaces.filter(function (r) {
					var id = r && (typeof r === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(r)) === 'object' ? r.id : r;
					return id && validIds.has(id);
				});
			}
			if (filtered.immediateBoss && filtered.immediateBoss.id && !validIds.has(filtered.immediateBoss.id)) {
				filtered.immediateBoss = {};
			}
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, filtered, {
				isAreaManager: job.isAreaManager || false,
				isHighestAuthority: job.isHighestAuthority || false
			});
		},
		father: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('fatherName'),
		id: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('id'),
		name: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('name'),
		roleId: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('role'),
		titulationId: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('title'),
		expirienceTimeId: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('experience'),
		areaId: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('areaId'),
		quantityPerson: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('quantityPerson'),
		englishLevelId: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('englishLevel'),
		typeVerb: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('typeVerb'),
		status: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('status'),
		mirrorFatherIds: function mirrorFatherIds(job) {
			return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['mirrorFatherIds'], job);
		},
		verbsCode: function verbsCode(job) {
			var parsed = parseVerbs(state)(job);
			return parsed.length > 0 ? parsed : Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["X" /* propOr */])([], 'verbsCode', job);
		}
	};
};

var parseAssignationRequest = function parseAssignationRequest(state) {
	var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    _ref2$onlyCompleted = _ref2.onlyCompleted,
	    onlyCompleted = _ref2$onlyCompleted === undefined ? false : _ref2$onlyCompleted;

	// Build a father-name lookup from `hierarchyAssignation`, the same source
	// `parseOrganizationChart` reads. The stage-2 tree-walk in
	// `getGuidelineModelStatus` corrects stale fathers there, so this is the
	// reliable source. Falls back to the job's own `fatherName` when the job is
	// not present in the assignation (e.g. evaluation-360 callers).
	var fatherNameById = {};
	Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['supplies', 'guidelineModel', 'hierarchyAssignation'], state).forEach(function (level) {
		(level.jobPositions || []).forEach(function (jp) {
			if (jp.id) {
				fatherNameById[jp.id] = jp.fatherName || null;
			}
		});
	});
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
		toolCode: getCurrentToolCode(state)
	}, toolCommonConfig, {
		deleteIds: getDeleteJobIds(state).length > 0 ? getDeleteJobIds(state) : [],
		jobs: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['supplies', 'guidelineModel', 'userForm', 'jobList']), onlyCompleted ? Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["s" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('completed', true)) : function (jobs) {
			return jobs;
		}, Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["i" /* applySpec */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, specParseJobToRequest(state), {
			father: function father(job) {
				return (job.id in fatherNameById ? fatherNameById[job.id] : Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('fatherName', job)) || null;
			}
		}))))(state)
	});
};

var parseOrganizationChart = function parseOrganizationChart(state) {
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
		toolCode: getCurrentToolCode(state)
	}, toolCommonConfig, {
		stageStatus: 1,
		stageDetailStatus: 2,
		jobs: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["P" /* pathOr */])([], ['supplies', 'guidelineModel', 'hierarchyAssignation']), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["S" /* pluck */])('jobPositions'), concatAll, Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["i" /* applySpec */])(specParseJobToRequest(state))))(state)
	});
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 539 */,
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return jobIsCompletedFilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFactorRateSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseResponseJobs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parsePayloadJobs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(17);


var jobIsCompletedFilled = function jobIsCompletedFilled(factors) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* all */])(function (factor) {
		return !Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["F" /* isNil */])(factor.selectedDegree) && !Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["E" /* isEmpty */])(factor.selectedDegree);
	}, factors);
};

var getFactorRateSum = function getFactorRateSum(factors) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["S" /* pluck */])('selectedDegree'), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["X" /* propOr */])(0, 'rate')), __WEBPACK_IMPORTED_MODULE_0_ramda__["_3" /* sum */], function (value) {
		return value.toFixed(2);
	})(factors);
};

var parseDegree = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["i" /* applySpec */])({
	uuid: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('code'),
	name: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('name'),
	rate: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('rate')
});

var parseResponseDegrees = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["J" /* map */])(parseDegree);

var parseResponseFactors = function parseResponseFactors(factors) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["i" /* applySpec */])({
		id: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('id'),
		name: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('name'),
		urlImage: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('urlImage'),
		degrees: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('grades'), parseResponseDegrees),
		selectedDegree: function selectedDegree(factor) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('gradeCode'), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["B" /* ifElse */])(function (gradeCode) {
				return !Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["E" /* isEmpty */])(gradeCode) && !Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["F" /* isNil */])(gradeCode);
			}, function (gradeCode) {
				return parseDegree(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["t" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["W" /* propEq */])('code', gradeCode), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["X" /* propOr */])([], 'grades', factor)));
			}, Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["f" /* always */])(undefined)))(factor);
		}
	}), factors);
};

var parseResponseJobs = function parseResponseJobs(jobs) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["i" /* applySpec */])({
		id: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('id'),
		name: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('name'),
		rate: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["X" /* propOr */])(0, 'summaryGrades'),
		factors: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('factors'), parseResponseFactors),
		completed: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('factors'), parseResponseFactors, jobIsCompletedFilled)
	}))(jobs);
};

var parsePayloadFactors = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["i" /* applySpec */])({
	id: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('id'),
	name: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('name'),
	gradeCode: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('selectedDegree'), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('uuid'))
}));

var parsePayloadJobs = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["i" /* applySpec */])({
	id: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('id'),
	name: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('name'),
	summaryGrades: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('rate'),
	factors: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["V" /* prop */])('factors'), parsePayloadFactors)
}));

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hchs_vue_charts__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hchs_vue_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hchs_vue_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_drag_drop__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_drag_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_format__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ckeditor_ckeditor5_vue2__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ckeditor_ckeditor5_vue2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ckeditor_ckeditor5_vue2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_shortkey__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_the_mask__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_org_tree_dist_style_css__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_org_tree_dist_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_org_tree_dist_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_normalize_css__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_charts_css_dist_charts_min_css__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_charts_css_dist_charts_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_charts_css_dist_charts_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__App__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vuetify__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__http_index__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__router__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_global__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__filters_global__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__global_components__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__shared_helper__ = __webpack_require__(39);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var route, surveyId, token, _ref2, response;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						route = window.location.pathname;
						surveyId = Number(route.split('/')[2]);

						__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$appColors = JSON.parse('{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success": "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent": "#005CAF","error": "#f42b17","warning": "#FFB74C"}');
						__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$userInfo = __WEBPACK_IMPORTED_MODULE_24__shared_helper__["a" /* default */].getLocalData('praktiko-user');
						__WEBPACK_IMPORTED_MODULE_24__shared_helper__["a" /* default */].setLocalData('surveyId', surveyId);
						this.$http.interceptors.request.use(this.httpRequestInterceptor);
						this.$http.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpAcl.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpPraktiko.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpPraktiko.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpUpLoad.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpUpLoad.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpJobEvaluation.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpJobEvaluation.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						token = __WEBPACK_IMPORTED_MODULE_24__shared_helper__["a" /* default */].getLocalToken();

						if (!token) {
							_context.next = 25;
							break;
						}

						_context.next = 19;
						return this.$httpPraktiko.get('employee/current');

					case 19:
						_ref2 = _context.sent;
						response = _ref2.data;

						__WEBPACK_IMPORTED_MODULE_24__shared_helper__["a" /* default */].setLocalData('praktiko-user', response);
						__WEBPACK_IMPORTED_MODULE_24__shared_helper__["a" /* default */].setLocalData('acl-code', response.aclCode);
						this.$store.dispatch('setUser', response);
						__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$userInfo = __WEBPACK_IMPORTED_MODULE_24__shared_helper__["a" /* default */].getLocalData('praktiko-user');

					case 25:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

/* eslint-disable no-new */





// import VueGraph from 'vue-graph';





















// Vue.use(window.VueCharts);
// Vue.use(VueGraph);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_drag_drop___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8__ckeditor_ckeditor5_vue2___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_analytics___default.a, {
	id: 'UA-XXXXXXX-1',
	autoTracking: {
		screenview: true
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'praktiko.netlify.com'
});

var userInfo = __WEBPACK_IMPORTED_MODULE_24__shared_helper__["a" /* default */].getLocalData('praktiko-user');
var router = Object(__WEBPACK_IMPORTED_MODULE_20__router__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue___default.a);
Object(__WEBPACK_IMPORTED_MODULE_22__filters_global__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue___default.a);
Object(__WEBPACK_IMPORTED_MODULE_17__vuetify__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue___default.a);
Object(__WEBPACK_IMPORTED_MODULE_19__axios__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$imageUrl = 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos';
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$userInfo = userInfo;
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$today = __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default()(new Date(), 'YYYY-MM-DD');

__WEBPACK_IMPORTED_MODULE_4_vue___default.a.mixin(__WEBPACK_IMPORTED_MODULE_21__mixins_global__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_4_vue___default.a({ // eslint-disable-line no-new
	created: created,
	el: '#app',
	methods: {
		httpRequestInterceptor: __WEBPACK_IMPORTED_MODULE_18__http_index__["a" /* httpRequestInterceptor */],
		httpResponseInterceptor: __WEBPACK_IMPORTED_MODULE_18__http_index__["b" /* httpResponseInterceptor */],
		httpResponseSuccessInterceptor: __WEBPACK_IMPORTED_MODULE_18__http_index__["c" /* httpResponseSuccessInterceptor */]
	},
	router: router,
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_16__App__["a" /* default */]);
	},
	store: __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */]
});

/***/ }),
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 216,
	"./af.js": 216,
	"./ar": 217,
	"./ar-dz": 218,
	"./ar-dz.js": 218,
	"./ar-kw": 219,
	"./ar-kw.js": 219,
	"./ar-ly": 220,
	"./ar-ly.js": 220,
	"./ar-ma": 221,
	"./ar-ma.js": 221,
	"./ar-sa": 222,
	"./ar-sa.js": 222,
	"./ar-tn": 223,
	"./ar-tn.js": 223,
	"./ar.js": 217,
	"./az": 224,
	"./az.js": 224,
	"./be": 225,
	"./be.js": 225,
	"./bg": 226,
	"./bg.js": 226,
	"./bm": 227,
	"./bm.js": 227,
	"./bn": 228,
	"./bn-bd": 229,
	"./bn-bd.js": 229,
	"./bn.js": 228,
	"./bo": 230,
	"./bo.js": 230,
	"./br": 231,
	"./br.js": 231,
	"./bs": 232,
	"./bs.js": 232,
	"./ca": 233,
	"./ca.js": 233,
	"./cs": 234,
	"./cs.js": 234,
	"./cv": 235,
	"./cv.js": 235,
	"./cy": 236,
	"./cy.js": 236,
	"./da": 237,
	"./da.js": 237,
	"./de": 238,
	"./de-at": 239,
	"./de-at.js": 239,
	"./de-ch": 240,
	"./de-ch.js": 240,
	"./de.js": 238,
	"./dv": 241,
	"./dv.js": 241,
	"./el": 242,
	"./el.js": 242,
	"./en-au": 243,
	"./en-au.js": 243,
	"./en-ca": 244,
	"./en-ca.js": 244,
	"./en-gb": 245,
	"./en-gb.js": 245,
	"./en-ie": 246,
	"./en-ie.js": 246,
	"./en-il": 247,
	"./en-il.js": 247,
	"./en-in": 248,
	"./en-in.js": 248,
	"./en-nz": 249,
	"./en-nz.js": 249,
	"./en-sg": 250,
	"./en-sg.js": 250,
	"./eo": 251,
	"./eo.js": 251,
	"./es": 252,
	"./es-do": 253,
	"./es-do.js": 253,
	"./es-mx": 254,
	"./es-mx.js": 254,
	"./es-us": 255,
	"./es-us.js": 255,
	"./es.js": 252,
	"./et": 256,
	"./et.js": 256,
	"./eu": 257,
	"./eu.js": 257,
	"./fa": 258,
	"./fa.js": 258,
	"./fi": 259,
	"./fi.js": 259,
	"./fil": 260,
	"./fil.js": 260,
	"./fo": 261,
	"./fo.js": 261,
	"./fr": 262,
	"./fr-ca": 263,
	"./fr-ca.js": 263,
	"./fr-ch": 264,
	"./fr-ch.js": 264,
	"./fr.js": 262,
	"./fy": 265,
	"./fy.js": 265,
	"./ga": 266,
	"./ga.js": 266,
	"./gd": 267,
	"./gd.js": 267,
	"./gl": 268,
	"./gl.js": 268,
	"./gom-deva": 269,
	"./gom-deva.js": 269,
	"./gom-latn": 270,
	"./gom-latn.js": 270,
	"./gu": 271,
	"./gu.js": 271,
	"./he": 272,
	"./he.js": 272,
	"./hi": 273,
	"./hi.js": 273,
	"./hr": 274,
	"./hr.js": 274,
	"./hu": 275,
	"./hu.js": 275,
	"./hy-am": 276,
	"./hy-am.js": 276,
	"./id": 277,
	"./id.js": 277,
	"./is": 278,
	"./is.js": 278,
	"./it": 279,
	"./it-ch": 280,
	"./it-ch.js": 280,
	"./it.js": 279,
	"./ja": 281,
	"./ja.js": 281,
	"./jv": 282,
	"./jv.js": 282,
	"./ka": 283,
	"./ka.js": 283,
	"./kk": 284,
	"./kk.js": 284,
	"./km": 285,
	"./km.js": 285,
	"./kn": 286,
	"./kn.js": 286,
	"./ko": 287,
	"./ko.js": 287,
	"./ku": 288,
	"./ku.js": 288,
	"./ky": 289,
	"./ky.js": 289,
	"./lb": 290,
	"./lb.js": 290,
	"./lo": 291,
	"./lo.js": 291,
	"./lt": 292,
	"./lt.js": 292,
	"./lv": 293,
	"./lv.js": 293,
	"./me": 294,
	"./me.js": 294,
	"./mi": 295,
	"./mi.js": 295,
	"./mk": 296,
	"./mk.js": 296,
	"./ml": 297,
	"./ml.js": 297,
	"./mn": 298,
	"./mn.js": 298,
	"./mr": 299,
	"./mr.js": 299,
	"./ms": 300,
	"./ms-my": 301,
	"./ms-my.js": 301,
	"./ms.js": 300,
	"./mt": 302,
	"./mt.js": 302,
	"./my": 303,
	"./my.js": 303,
	"./nb": 304,
	"./nb.js": 304,
	"./ne": 305,
	"./ne.js": 305,
	"./nl": 306,
	"./nl-be": 307,
	"./nl-be.js": 307,
	"./nl.js": 306,
	"./nn": 308,
	"./nn.js": 308,
	"./oc-lnc": 309,
	"./oc-lnc.js": 309,
	"./pa-in": 310,
	"./pa-in.js": 310,
	"./pl": 311,
	"./pl.js": 311,
	"./pt": 312,
	"./pt-br": 313,
	"./pt-br.js": 313,
	"./pt.js": 312,
	"./ro": 314,
	"./ro.js": 314,
	"./ru": 315,
	"./ru.js": 315,
	"./sd": 316,
	"./sd.js": 316,
	"./se": 317,
	"./se.js": 317,
	"./si": 318,
	"./si.js": 318,
	"./sk": 319,
	"./sk.js": 319,
	"./sl": 320,
	"./sl.js": 320,
	"./sq": 321,
	"./sq.js": 321,
	"./sr": 322,
	"./sr-cyrl": 323,
	"./sr-cyrl.js": 323,
	"./sr.js": 322,
	"./ss": 324,
	"./ss.js": 324,
	"./sv": 325,
	"./sv.js": 325,
	"./sw": 326,
	"./sw.js": 326,
	"./ta": 327,
	"./ta.js": 327,
	"./te": 328,
	"./te.js": 328,
	"./tet": 329,
	"./tet.js": 329,
	"./tg": 330,
	"./tg.js": 330,
	"./th": 331,
	"./th.js": 331,
	"./tk": 332,
	"./tk.js": 332,
	"./tl-ph": 333,
	"./tl-ph.js": 333,
	"./tlh": 334,
	"./tlh.js": 334,
	"./tr": 335,
	"./tr.js": 335,
	"./tzl": 336,
	"./tzl.js": 336,
	"./tzm": 337,
	"./tzm-latn": 338,
	"./tzm-latn.js": 338,
	"./tzm.js": 337,
	"./ug-cn": 339,
	"./ug-cn.js": 339,
	"./uk": 340,
	"./uk.js": 340,
	"./ur": 341,
	"./ur.js": 341,
	"./uz": 342,
	"./uz-latn": 343,
	"./uz-latn.js": 343,
	"./uz.js": 342,
	"./vi": 344,
	"./vi.js": 344,
	"./x-pseudo": 345,
	"./x-pseudo.js": 345,
	"./yo": 346,
	"./yo.js": 346,
	"./zh-cn": 347,
	"./zh-cn.js": 347,
	"./zh-hk": 348,
	"./zh-hk.js": 348,
	"./zh-mo": 349,
	"./zh-mo.js": 349,
	"./zh-tw": 350,
	"./zh-tw.js": 350
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 568;

/***/ }),
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */,
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(51);





/* eslint-disable no-param-reassign */

var toolConfigurationModule = {
	actions: {
		createNewTool: function createNewTool(_ref, body) {
			var _this = this;

			var dispatch = _ref.dispatch;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].post('tools', body);

							case 2:
								_context.next = 4;
								return dispatch('loadTools');

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		createLevel: function createLevel(_ref3, _ref2) {
			var _this2 = this;

			var dispatch = _ref3.dispatch;

			var toolCode = _ref2.toolCode,
			    rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['toolCode']);

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var url;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								url = 'hierarchies/' + toolCode;
								_context2.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].post(url, rest);

							case 3:
								dispatch('toolDetail', toolCode);

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		delete: function _delete(_ref4, id) {
			var _this3 = this;

			var dispatch = _ref4.dispatch;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].delete('tools/' + id);

							case 2:
								_context3.next = 4;
								return dispatch('loadTools');

							case 4:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		editLevel: function editLevel(_ref6, _ref5) {
			var _this4 = this;

			var dispatch = _ref6.dispatch;

			var toolCode = _ref5.toolCode,
			    id = _ref5.id,
			    rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['toolCode', 'id']);

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var url;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								url = 'hierarchies/' + id;
								_context4.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].patch(url, rest);

							case 3:
								dispatch('toolDetail', toolCode);

							case 4:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		editTool: function editTool(_ref8, _ref7) {
			var _this5 = this;

			var dispatch = _ref8.dispatch;

			var id = _ref7.id,
			    body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref7, ['id']);

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var url;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								url = 'tools/' + id;
								_context5.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].patch(url, body);

							case 3:
								_context5.next = 5;
								return dispatch('loadTools');

							case 5:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		loadTool: function loadTool(_ref9, code) {
			var _this6 = this;

			var commit = _ref9.commit,
			    dispatch = _ref9.dispatch;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var url, _ref10, response, answerId, description, id, images, name, templateId, urlImage, videos, toolData;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								url = 'tools/' + code;
								_context6.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get(url);

							case 3:
								_ref10 = _context6.sent;
								response = _ref10.data;
								answerId = response.answerId, description = response.description, id = response.id, images = response.images, name = response.name, templateId = response.templateId, urlImage = response.urlImage.web, videos = response.videos;
								toolData = {
									code: code,
									description: description,
									id: id,
									image: '',
									images: images,
									name: name,
									templateId: templateId,
									urlImage: urlImage,
									videos: videos,
									videoLink: ''
								};

								commit('SET_EDITING_TOOL_ID', toolData.id);
								commit('SET_EDITING_TOOL', toolData);
								commit('NEW_TOOL_TEMPLATE_ID', templateId);
								dispatch('answer/selectedTypeAnswer', answerId, { root: true });
								dispatch('icon/callingIconsAndSelectingIt', urlImage, { root: true });

							case 12:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		loadTools: function loadTools(_ref11) {
			var _this7 = this;

			var commit = _ref11.commit;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
				var _ref12, response, responseFilter;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_context7.next = 2;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get('tools');

							case 2:
								_ref12 = _context7.sent;
								response = _ref12.data;
								responseFilter = response.filter(function (t) {
									return t.id !== 22 && t.id !== 23;
								});

								commit('SET_TOOLS', responseFilter);

							case 6:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},
		loadToolType: function loadToolType(_ref13) {
			var _this8 = this;

			var commit = _ref13.commit;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
				var _ref14, res;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								_context8.next = 2;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get('templates');

							case 2:
								_ref14 = _context8.sent;
								res = _ref14.data;

								commit('SET_TOOLS_TEMPLATES', res);

							case 5:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, _this8);
			}))();
		},
		selectTemplate: function selectTemplate(_ref15, template) {
			var commit = _ref15.commit;

			commit('NEW_TOOL_TEMPLATE_ID', template.id);
		},
		setFlagEditTool: function setFlagEditTool(_ref16, id) {
			var commit = _ref16.commit;

			commit('SET_EDITING_TOOL_ID', id);
		},
		setNewToolData: function setNewToolData(_ref17, newTool) {
			var commit = _ref17.commit;

			commit('NEW_TOOL_TEMPLATE_ID', newTool.templateId);
			commit('NEW_TOOL_DESCRIPTION', newTool.description);
			commit('NEW_TOOL_NAME', newTool.name);
			commit('NEW_TOOL_CODE', newTool.code);
		},
		toolDetail: function toolDetail(_ref18, toolCode) {
			var _this9 = this;

			var commit = _ref18.commit;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
				var url, _ref19, res;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								url = 'hierarchies/' + toolCode;
								_context9.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get(url);

							case 3:
								_ref19 = _context9.sent;
								res = _ref19.data;

								commit('SET_TOOLS_DETAIL', res);

							case 6:
							case 'end':
								return _context9.stop();
						}
					}
				}, _callee9, _this9);
			}))();
		}
	},
	state: {
		details: null,
		editing: {
			id: 0,
			toolData: {}
		},
		templateId: 0,
		templates: [],
		newToolCode: '',
		newToolDescription: '',
		newToolName: '',
		tools: [],
		urlImage: null
	},
	mutations: {
		NEW_TOOL_TEMPLATE_ID: function NEW_TOOL_TEMPLATE_ID(state, id) {
			state.templateId = id;
		},
		NEW_TOOL_CODE: function NEW_TOOL_CODE(state, code) {
			state.newToolCode = code;
		},
		NEW_TOOL_DESCRIPTION: function NEW_TOOL_DESCRIPTION(state, description) {
			state.newToolDescription = description;
		},
		NEW_TOOL_NAME: function NEW_TOOL_NAME(state, name) {
			state.newToolName = name;
		},
		SET_EDITING_TOOL: function SET_EDITING_TOOL(state, data) {
			state.editing.toolData = data;
		},
		SET_EDITING_TOOL_ID: function SET_EDITING_TOOL_ID(state, id) {
			state.editing.id = id;
		},
		SET_TOOLS: function SET_TOOLS(state, tools) {
			state.tools = tools;
		},
		SET_TOOLS_DETAIL: function SET_TOOLS_DETAIL(state, toolsDetail) {
			state.details = toolsDetail;
		},
		SET_TOOLS_TEMPLATES: function SET_TOOLS_TEMPLATES(state, templates) {
			state.templates = templates;
		}
	},
	getters: {
		getDetails: function getDetails(state) {
			return state.details;
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (toolConfigurationModule);

/***/ }),
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axios__ = __webpack_require__(51);







/* eslint-disable no-param-reassign */

var presentsConfigurationModule = {
	actions: {
		clearPresentsByEmployee: function clearPresentsByEmployee(_ref) {
			var commit = _ref.commit;

			commit('SET_GOTIT_PRESENTS', []);
		},
		createPresent: function createPresent(_ref2, body) {
			var _this = this;

			var dispatch = _ref2.dispatch;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].post('awards', body);

							case 2:
								dispatch('resetingPresentData');

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		deletePresent: function deletePresent(_ref3, id) {
			var _this2 = this;

			var dispatch = _ref3.dispatch;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].delete('awards/' + id);

							case 2:
								dispatch('loadAllPresents');

							case 3:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		loadAllPresents: function loadAllPresents(_ref4) {
			var _this3 = this;

			var commit = _ref4.commit;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var _ref5, response;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].get('awards');

							case 2:
								_ref5 = _context3.sent;
								response = _ref5.data;

								commit('SET_PRESENTS', response);

							case 5:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		loadPresentsByEmployee: function loadPresentsByEmployee(_ref6, employeeId) {
			var _this4 = this;

			var commit = _ref6.commit;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var requests, _ref7, _ref8, avaliablePresents, myPresents;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								requests = [__WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].get('/awards/employee/' + employeeId), __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].get('/employee/' + employeeId + '/award')];
								_context4.next = 3;
								return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(requests);

							case 3:
								_ref7 = _context4.sent;
								_ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);
								avaliablePresents = _ref8[0].data;
								myPresents = _ref8[1].data;

								commit('SET_PENDING_PRESENTS', avaliablePresents);
								commit('SET_GOTIT_PRESENTS', myPresents.awards);

							case 9:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		loadWonPresentsByEmployee: function loadWonPresentsByEmployee(_ref9) {
			var _this5 = this;

			var commit = _ref9.commit;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var _ref10, response;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].get('employee-role/award');

							case 2:
								_ref10 = _context5.sent;
								response = _ref10.data;

								commit('SET_GOTIT_PRESENTS', response);

							case 5:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		redeemPresent: function redeemPresent(_ref11, _ref12) {
			var _this6 = this;

			var dispatch = _ref11.dispatch;
			var presentId = _ref12.presentId,
			    employeeId = _ref12.employeeId;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var url, body;
				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								url = 'employee-award';
								body = { awardId: presentId, employeeId: employeeId };
								_context6.next = 4;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].post(url, body);

							case 4:
								dispatch('loadPresentsByEmployee', employeeId);

							case 5:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		resetingPresentData: function resetingPresentData(_ref13) {
			var dispatch = _ref13.dispatch;

			dispatch('loadAllPresents');
			dispatch('setNewPresentData', null);
		},
		setEditingPresentId: function setEditingPresentId(_ref14, presentId) {
			var commit = _ref14.commit;

			commit('SET_EDITING_PRESENT_ID', presentId);
		},
		setNewPresentData: function setNewPresentData(_ref15, newPresentData) {
			var commit = _ref15.commit;

			commit('SET_NEW_PRESENT_DATA', newPresentData);
		},
		updatePresent: function updatePresent(_ref17, _ref16) {
			var _this7 = this;

			var dispatch = _ref17.dispatch;

			var id = _ref16.id,
			    rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref16, ['id']);

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_context7.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].patch('awards/' + id, rest);

							case 2:
								dispatch('resetingPresentData');
								dispatch('setEditingPresentId', 0);

							case 4:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},
		updatePresentAction: function updatePresentAction(_ref18, present) {
			var dispatch = _ref18.dispatch;

			if (present) {
				var name = present.name,
				    points = present.points,
				    id = present.id;

				dispatch('setNewPresentData', { name: name, points: points });
				dispatch('setEditingPresentId', id);
			} else {
				dispatch('setNewPresentData', null);
				dispatch('setEditingPresentId', 0);
			}
		}
	},
	state: {
		editingPresentId: 0,
		newPresentData: null,
		presents: [],
		presentsByEmployee: {
			pending: [],
			gotIt: []
		}
	},
	mutations: {
		SET_EDITING_PRESENT_ID: function SET_EDITING_PRESENT_ID(state, id) {
			state.editingPresentId = id;
		},
		SET_GOTIT_PRESENTS: function SET_GOTIT_PRESENTS(state, presents) {
			state.presentsByEmployee.gotIt = presents;
		},
		SET_NEW_PRESENT_DATA: function SET_NEW_PRESENT_DATA(state, newPresentData) {
			state.newPresentData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newPresentData);
		},
		SET_PENDING_PRESENTS: function SET_PENDING_PRESENTS(state, presents) {
			state.presentsByEmployee.pending = presents;
		},
		SET_PRESENTS: function SET_PRESENTS(state, presents) {
			state.presents = presents;
		}
	},
	getters: {
		presentName: function presentName(state) {
			return state.newPresentData ? state.newPresentData.name : '';
		},
		presentPoints: function presentPoints(state) {
			return state.newPresentData ? state.newPresentData.points : 0;
		},
		flagEdit: function flagEdit(state) {
			return !!state.editingPresentId;
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (presentsConfigurationModule);

/***/ }),
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(51);




/* eslint-disable no-param-reassign */

var levelTypeModule = {
	actions: {
		create: function create(_ref2, _ref) {
			var _this = this;

			var dispatch = _ref2.dispatch;

			var toolCode = _ref.toolCode,
			    rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['toolCode']);

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var url;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								url = 'tools-type';
								_context.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].post(url, rest);

							case 3:
								dispatch('load', toolCode);

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		load: function load(_ref3, toolCode) {
			var _this2 = this;

			var commit = _ref3.commit;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var url, _ref4, levels;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								url = 'tools-type/' + toolCode;
								_context2.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get(url);

							case 3:
								_ref4 = _context2.sent;
								levels = _ref4.data;

								commit('SET_LEVELS_BY_TOOL', levels);

							case 6:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		}
	},
	getters: {
		levels: function levels(state) {
			return [].concat({ name: 'Nuevo tipo' }, state.list);
		}
	},
	mutations: {
		SET_LEVELS_BY_TOOL: function SET_LEVELS_BY_TOOL(state, levels) {
			state.list = levels;
		}
	},
	state: {
		list: []
	}
};

/* harmony default export */ __webpack_exports__["a"] = (levelTypeModule);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(51);





/* eslint-disable no-param-reassign */

function answersConstructor(n, state) {
	var answer = state.answersDefinition;
	var arr = new Array(n);
	var len = arr.length;
	for (var i = 0; i < len; i += 1) {
		var currentAnswer = state.partial.answers[i];
		arr[i] = currentAnswer || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, answer);
	}
	return arr;
}

function formatingAnswers(answers) {
	return answers.map(function (a) {
		var name = a.name,
		    value = a.value;

		var b = {
			name: name,
			value: value,
			urlImage: { web: a.icon.urlImage }
		};
		return b;
	});
}

function formattingEditingAnswerData(answer) {
	return answer.map(function (a) {
		var name = a.name,
		    value = a.value,
		    web = a.urlImage.web;

		return { name: name, value: value, icon: { urlImage: web } };
	});
}

/* harmony default export */ __webpack_exports__["a"] = ({
	actions: {
		createAnswer: function createAnswer(_ref) {
			var _this = this;

			var dispatch = _ref.dispatch,
			    state = _ref.state;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _state$partial, name, number, type, flagNoUse, answers, body;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_state$partial = state.partial, name = _state$partial.name, number = _state$partial.number, type = _state$partial.type, flagNoUse = _state$partial.flagNoUse, answers = _state$partial.answers;
								body = {
									name: name,
									quantityAnswer: number,
									typeAnswerId: type.id,
									mode: 1,
									apply: flagNoUse,
									details: formatingAnswers(answers)
								};
								_context.next = 4;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].post('answers', body);

							case 4:
								dispatch('loadAnswers');

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		editAnswer: function editAnswer(_ref2) {
			var _this2 = this;

			var dispatch = _ref2.dispatch,
			    state = _ref2.state,
			    commit = _ref2.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var id, partial, name, number, type, flagNoUse, answers, body;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								id = state.editingAnswerId, partial = state.partial;
								name = partial.name, number = partial.number, type = partial.type, flagNoUse = partial.flagNoUse, answers = partial.answers;
								body = {
									name: name,
									quantityAnswer: number,
									typeAnswerId: type,
									mode: 1,
									apply: flagNoUse,
									details: formatingAnswers(answers)
								};
								_context2.next = 5;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].patch('answers/' + id, body);

							case 5:
								dispatch('loadAnswers');
								commit('SET_EDITING_ANSWER_ID', 0);

							case 7:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		loadAnswersByType: function loadAnswersByType(_ref3) {
			var _this3 = this;

			var commit = _ref3.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var _ref4, res;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].get('answers');

							case 2:
								_ref4 = _context3.sent;
								res = _ref4.data;

								commit('SET_ANSWERS_BY_TYPE', res);

							case 5:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		loadAnswers: function loadAnswers(_ref5) {
			var _this4 = this;

			var commit = _ref5.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var _ref6, res;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.next = 2;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].get('answers');

							case 2:
								_ref6 = _context4.sent;
								res = _ref6.data;

								commit('SET_ANSWERS', res);

							case 5:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		loadEditingAnswerData: function loadEditingAnswerData(_ref7, id) {
			var _this5 = this;

			var dispatch = _ref7.dispatch,
			    commit = _ref7.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var _ref8, res;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].get('answers/' + id);

							case 2:
								_ref8 = _context5.sent;
								res = _ref8.data;

								commit('SET_EDITING_ANSWER_ID', id);
								dispatch('setAnswerData', res);

							case 6:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		deleteAnswer: function deleteAnswer(_ref9, _ref10) {
			var _this6 = this;

			var dispatch = _ref9.dispatch;
			var answerId = _ref10.answerId;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.next = 2;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].get('answers/' + answerId);

							case 2:
								dispatch('loadAnswers');

							case 3:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		setAnswerData: function setAnswerData(_ref11, res) {
			var commit = _ref11.commit;
			var name = res.name,
			    type = res.typeAnswerId,
			    answers = res.details,
			    number = res.quantityAnswer;

			var formattedAnswers = formattingEditingAnswerData(answers);
			commit('SET_BASIC_DATA', { answers: formattedAnswers, name: name, type: type, number: number });
		},
		selectedTypeAnswer: function selectedTypeAnswer(_ref12, id) {
			var commit = _ref12.commit;

			commit('SET_TYPE_ANSWER_SELECTED', id);
		},
		setBasicData: function setBasicData(_ref13, answerData) {
			var commit = _ref13.commit,
			    state = _ref13.state;

			var answer = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, answerData);
			answer.type = answerData.type[0];
			answer.answers = answersConstructor(answer.number, state);
			commit('SET_BASIC_DATA', answer);
		},
		cleanBasicData: function cleanBasicData(_ref14) {
			var commit = _ref14.commit,
			    state = _ref14.state;

			var answer = {
				answers: [state.answersDefinition],
				name: '',
				number: 1,
				type: {}
			};
			commit('SET_BASIC_DATA', answer);
		},
		setFlagNoUse: function setFlagNoUse(_ref15, flag) {
			var commit = _ref15.commit;

			commit('SET_FLAG_NO_USE', flag);
		},
		updateAnswers: function updateAnswers(_ref16, _ref17) {
			var commit = _ref16.commit;
			var icon = _ref17.icon,
			    index = _ref17.index;

			commit('UPDATE_PARTIAL_ANSWERS', { icon: icon, index: index });
		}
	},
	getters: {
		invalidAnswer: function invalidAnswer(state) {
			var _state$partial2 = state.partial,
			    name = _state$partial2.name,
			    type = _state$partial2.type;

			return !(name && type);
		}
	},
	mutations: {
		SET_ANSWERS: function SET_ANSWERS(state, answersNumber) {
			state.answers.list = answersNumber;
		},
		SET_ANSWERS_BY_TYPE: function SET_ANSWERS_BY_TYPE(state, answers) {
			state.answers.answersByType = answers;
		},
		SET_BASIC_DATA: function SET_BASIC_DATA(state, data) {
			state.partial = data;
		},
		SET_EDITING_ANSWER_ID: function SET_EDITING_ANSWER_ID(state, id) {
			state.editingAnswerId = id;
		},
		SET_FLAG_NO_USE: function SET_FLAG_NO_USE(state, flag) {
			state.partial.flagNoUse = flag;
		},
		SET_TYPE_ANSWER_SELECTED: function SET_TYPE_ANSWER_SELECTED(state, id) {
			state.answers.typeAnswerSelectedId = id;
		},
		UPDATE_PARTIAL_ANSWERS: function UPDATE_PARTIAL_ANSWERS(state, _ref18) {
			var icon = _ref18.icon,
			    index = _ref18.index;

			__WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.partial.answers[index], 'icon', icon);
		}
	},
	state: {
		answers: {
			answersByType: [],
			list: [],
			listBy: [],
			typeAnswerSelectedId: 0
		},
		answersDefinition: { name: '', value: 0, icon: { urlImage: '' } },
		partial: {
			answers: [{ name: '', value: 0, icon: { urlImage: '' } }],
			flagNoUse: false,
			name: '',
			number: 1,
			type: null
		},
		editingAnswerId: null
	}
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(51);



/* eslint-disable no-param-reassign */

function searchIconByUrl(urlIcon, iconList) {
	return iconList.find(function (i) {
		return i.urlImage === urlIcon;
	});
}

var iconModule = {
	actions: {
		create: function create(_ref, body) {
			var _this = this;

			var dispatch = _ref.dispatch;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __WEBPACK_IMPORTED_MODULE_2__axios__["c" /* praktikoInstance */].post('icons', body);

							case 2:
								dispatch('load');

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		load: function load(_ref2) {
			var _this2 = this;

			var commit = _ref2.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var _ref3, res;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return __WEBPACK_IMPORTED_MODULE_2__axios__["c" /* praktikoInstance */].get('icons');

							case 2:
								_ref3 = _context2.sent;
								res = _ref3.data;

								commit('SET_ICON_LIST', res);

							case 5:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		selectIconAction: function selectIconAction(_ref4, icon) {
			var commit = _ref4.commit;

			commit('SET_SELECTED_ICON', icon);
		},
		callingIconsAndSelectingIt: function callingIconsAndSelectingIt(_ref5, urlImage) {
			var _this3 = this;

			var dispatch = _ref5.dispatch,
			    state = _ref5.state,
			    commit = _ref5.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var icon;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return dispatch('load');

							case 2:
								icon = searchIconByUrl(urlImage, state.icon.list);

								commit('SET_SELECTED_ICON', icon);

							case 4:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		}
	},
	getters: {
		iconSelectedId: function iconSelectedId(state) {
			return state.selectedIcon ? state.selectedIcon.id : 0;
		},
		iconSelectedName: function iconSelectedName(state) {
			return state.selectedIcon ? state.selectedIcon.name : '';
		},
		urlIcon: function urlIcon(state) {
			return state.selectedIcon ? state.selectedIcon.urlImage : '';
		}
	},
	mutations: {
		SET_ICON_LIST: function SET_ICON_LIST(state, icons) {
			state.icon.list = icons;
		},
		SET_SELECTED_ICON: function SET_SELECTED_ICON(state, icon) {
			state.selectedIcon = icon;
		}
	},
	state: {
		selectedIcon: null,
		icon: {
			list: []
		}
	}
};
/* harmony default export */ __webpack_exports__["a"] = (iconModule);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guideline_model_actions__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guideline_model_mutations__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__valuation_model_actions__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__valuation_model_mutations__ = __webpack_require__(849);








var globalMutations = {
	// eslint-disable-next-line no-unused-vars
	CLEAR_STATE: function CLEAR_STATE(mutationState) {
		// eslint-disable-next-line no-param-reassign
		mutationState = Object(__WEBPACK_IMPORTED_MODULE_1__state__["b" /* getJobEvaluationState */])();
	}
};

var globalActions = {
	cleanJobEvaluationState: function cleanJobEvaluationState(_ref) {
		var commit = _ref.commit;

		commit('CLEAR_STATE');
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	mutations: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["K" /* mergeAll */])([__WEBPACK_IMPORTED_MODULE_3__guideline_model_mutations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__valuation_model_mutations__["a" /* default */], globalMutations]),
	actions: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["K" /* mergeAll */])([__WEBPACK_IMPORTED_MODULE_2__guideline_model_actions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__valuation_model_actions__["a" /* default */], globalActions]),
	state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]
});

/***/ }),
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getJobEvaluationState; });
var getJobEvaluationState = function getJobEvaluationState() {
	return {
		mainData: {},
		supplies: {
			guidelineModel: {
				hasInformationJobEvaluation: false,
				informationJobEvaluation: {},
				hasPreviewValues: false,
				verbsSelection: {
					highCommand: {},
					mediumCommand: {},
					lowCommand: {}
				},
				levelSelection: {
					role: {},
					title: {},
					experience: {},
					englishLevel: {},
					quantityPerson: 0
				},
				hierarchyAssignation: [],
				organizationChart: [],
				groups: [], // Campo para almacenar grupos centralizadamente
				userForm: {
					jobList: [],
					filteredJobs: [],
					deletedJobs: [],
					idsFilterJobs: null
				}
			},
			valuationModel: {
				factorList: [],
				degreesListByFactor: {},
				selectedFactors: [],
				weighing: {
					selectedFactor: {},
					combinations: []
				},
				degree: {
					selectedFactor: {},
					factorDegrees: {}
				}
			},
			generalData: {
				platforms: {}
			}
		}
	};
};

/* harmony default export */ __webpack_exports__["a"] = (getJobEvaluationState());

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bus_app_bus__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_job_profile_utils_helpers__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_job_profile_helpers_helpers__ = __webpack_require__(199);










var LOADER_EVENT = 'app-event-loader-toggle-view';
var LOADER_MESSAGE = 'Praktiko esta asignando las jerarquias.';
var LOADER_MESSAGE_ORGANIZATIONAL_CHART = 'Praktiko esta generando el organizagrama.';

// Pending promise for loadGroups deduplication
var pendingLoadGroups = null;

/* harmony default export */ __webpack_exports__["a"] = ({
	getJobValuationStatus: function getJobValuationStatus(_ref) {
		var _this = this;

		var commit = _ref.commit;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _ref2, status, data, hasInformation;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.prev = 0;
							_context.next = 3;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$http.get('/polls/JEV');

						case 3:
							_ref2 = _context.sent;
							status = _ref2.status;
							data = _ref2.data;
							hasInformation = status === 200;

							commit('UPDATE_HAS_INFORMATION', hasInformation);
							if (hasInformation) {
								commit('UPDATE_INFORMATION_JOB_EVALUATION', data);
							}
							return _context.abrupt('return', true);

						case 12:
							_context.prev = 12;
							_context.t0 = _context['catch'](0);
							throw _context.t0;

						case 15:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this, [[0, 12]]);
		}))();
	},
	updateJobList: function updateJobList(_ref3, jobList) {
		var commit = _ref3.commit;

		// Asegurar que todos los jobs tengan el progreso calculado
		var jobsWithProgress = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(function (job) {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, job, {
				progress: Object(__WEBPACK_IMPORTED_MODULE_8__modules_job_profile_helpers_helpers__["a" /* calculateJobProgress */])(job)
			});
		}, jobList);
		commit('UPDATE_JOB_LIST', jobsWithProgress);
	},
	updateJobItem: function updateJobItem(_ref4, job) {
		var commit = _ref4.commit,
		    state = _ref4.state;

		var jobWithProgress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, job, {
			progress: Object(__WEBPACK_IMPORTED_MODULE_8__modules_job_profile_helpers_helpers__["a" /* calculateJobProgress */])(job)
		});

		var currentList = state.supplies.guidelineModel.userForm.jobList;
		var jobList = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["_10" /* when */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('id', job.id), function () {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, jobWithProgress);
		}), currentList);

		commit('UPDATE_JOB_LIST', jobList);
	},
	loadJobEvaluationConfig: function loadJobEvaluationConfig(_ref5) {
		var _this2 = this;

		var commit = _ref5.commit;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
			var JOB_EVALUATION_TOOL_CODE, _ref6, data;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							JOB_EVALUATION_TOOL_CODE = 'JEV';
							_context2.next = 3;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$http.get('/tools/' + JOB_EVALUATION_TOOL_CODE);

						case 3:
							_ref6 = _context2.sent;
							data = _ref6.data;

							commit('UPDATE_MAIN_DATA', data);

						case 6:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2);
		}))();
	},
	loadRoles: function loadRoles(_ref7) {
		var _this3 = this;

		var commit = _ref7.commit,
		    state = _ref7.state;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
			var _ref8, data, payload;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							if (!(state.supplies.guidelineModel.levelSelection.role && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(state.supplies.guidelineModel.levelSelection.role) === 'object' && state.supplies.guidelineModel.levelSelection.role.data && Array.isArray(state.supplies.guidelineModel.levelSelection.role.data) && state.supplies.guidelineModel.levelSelection.role.data.length > 0)) {
								_context3.next = 2;
								break;
							}

							return _context3.abrupt('return', state.supplies.guidelineModel.levelSelection.role);

						case 2:
							_context3.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.get('/general-data/ROL');

						case 4:
							_ref8 = _context3.sent;
							data = _ref8.data;
							payload = {
								name: 'Rol',
								data: data
							};

							commit('UPDATE_LEVEL_SELECTION_ROLE', payload);
							return _context3.abrupt('return', payload);

						case 9:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, _this3);
		}))();
	},
	loadTitles: function loadTitles(_ref9) {
		var _this4 = this;

		var commit = _ref9.commit,
		    state = _ref9.state;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
			var _ref10, data, payload;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							if (!(state.supplies.guidelineModel.levelSelection.title && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(state.supplies.guidelineModel.levelSelection.title) === 'object' && state.supplies.guidelineModel.levelSelection.title.data && Array.isArray(state.supplies.guidelineModel.levelSelection.title.data) && state.supplies.guidelineModel.levelSelection.title.data.length > 0)) {
								_context4.next = 2;
								break;
							}

							return _context4.abrupt('return', state.supplies.guidelineModel.levelSelection.title);

						case 2:
							_context4.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.get('/general-data/TIT');

						case 4:
							_ref10 = _context4.sent;
							data = _ref10.data;
							payload = {
								name: 'Título',
								data: data
							};

							commit('UPDATE_LEVEL_SELECTION_TITLE', payload);
							return _context4.abrupt('return', payload);

						case 9:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, _this4);
		}))();
	},
	loadPlatforms: function loadPlatforms(_ref11) {
		var _this5 = this;

		var commit = _ref11.commit;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
			var _ref12, data;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.get('/general-data/PLTF');

						case 2:
							_ref12 = _context5.sent;
							data = _ref12.data;

							commit('UPDATE_PLATFORMS', {
								name: 'Plataformas',
								data: data
							});

						case 5:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, _this5);
		}))();
	},
	loadExperiences: function loadExperiences(_ref13) {
		var _this6 = this;

		var commit = _ref13.commit,
		    state = _ref13.state;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
			var params, _ref14, data, payload;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							if (!(state.supplies.guidelineModel.levelSelection.experience && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(state.supplies.guidelineModel.levelSelection.experience) === 'object' && state.supplies.guidelineModel.levelSelection.experience.data && Array.isArray(state.supplies.guidelineModel.levelSelection.experience.data) && state.supplies.guidelineModel.levelSelection.experience.data.length > 0)) {
								_context6.next = 2;
								break;
							}

							return _context6.abrupt('return', state.supplies.guidelineModel.levelSelection.experience);

						case 2:
							params = {
								sortField: 'name',
								sortDirection: 'ASC'
							};
							_context6.next = 5;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.get('/general-data/EXP', { params: params });

						case 5:
							_ref14 = _context6.sent;
							data = _ref14.data;
							payload = {
								name: 'Experiencia',
								data: data
							};

							commit('UPDATE_LEVEL_SELECTION_EXPERIENCE', payload);
							return _context6.abrupt('return', payload);

						case 10:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, _this6);
		}))();
	},
	loadEnglishLevels: function loadEnglishLevels(_ref15) {
		var _this7 = this;

		var commit = _ref15.commit,
		    state = _ref15.state;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
			var _ref16, data, payload;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							if (!(state.supplies.guidelineModel.levelSelection.englishLevel && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(state.supplies.guidelineModel.levelSelection.englishLevel) === 'object' && state.supplies.guidelineModel.levelSelection.englishLevel.data && Array.isArray(state.supplies.guidelineModel.levelSelection.englishLevel.data) && state.supplies.guidelineModel.levelSelection.englishLevel.data.length > 0)) {
								_context7.next = 2;
								break;
							}

							return _context7.abrupt('return', state.supplies.guidelineModel.levelSelection.englishLevel);

						case 2:
							_context7.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.get('/general-data/NDI');

						case 4:
							_ref16 = _context7.sent;
							data = _ref16.data;
							payload = {
								name: 'Nivel de Inglés',
								data: data
							};

							commit('UPDATE_LEVEL_SELECTION_ENGLISH_LEVEL', payload);
							return _context7.abrupt('return', payload);

						case 9:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, _this7);
		}))();
	},
	loadVerbs: function loadVerbs(_ref17) {
		var _this8 = this;

		var commit = _ref17.commit,
		    state = _ref17.state;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
			var params, _ref18, data;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							_context8.prev = 0;

							if (!(state.supplies.guidelineModel.verbsSelection.highCommand && state.supplies.guidelineModel.verbsSelection.highCommand.details && Array.isArray(state.supplies.guidelineModel.verbsSelection.highCommand.details) && state.supplies.guidelineModel.verbsSelection.highCommand.details.length > 0 && state.supplies.guidelineModel.verbsSelection.mediumCommand && state.supplies.guidelineModel.verbsSelection.mediumCommand.details && Array.isArray(state.supplies.guidelineModel.verbsSelection.mediumCommand.details) && state.supplies.guidelineModel.verbsSelection.mediumCommand.details.length > 0 && state.supplies.guidelineModel.verbsSelection.lowCommand && state.supplies.guidelineModel.verbsSelection.lowCommand.details && Array.isArray(state.supplies.guidelineModel.verbsSelection.lowCommand.details) && state.supplies.guidelineModel.verbsSelection.lowCommand.details.length > 0)) {
								_context8.next = 3;
								break;
							}

							return _context8.abrupt('return', true);

						case 3:
							params = {
								sortField: 'name',
								sortDirection: 'ASC'
							};
							_context8.next = 6;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.get('/general-data/VER', { params: params });

						case 6:
							_ref18 = _context8.sent;
							data = _ref18.data;

							data = data.map(function (d) {
								var newD = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, d);
								newD.details = d.details.sort(function (a, b) {
									if (a.description.toLowerCase() > b.description.toLowerCase()) {
										return 1;
									}
									return -1;
								});
								return newD;
							});
							commit('UPDATE_COMMAND_DATA', {
								command: 'highCommand',
								data: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["t" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('code', __WEBPACK_IMPORTED_MODULE_7__modules_job_profile_utils_helpers__["a" /* commandMap */].highCommand), data)
							});
							commit('UPDATE_COMMAND_DATA', {
								command: 'mediumCommand',
								data: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["t" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('code', __WEBPACK_IMPORTED_MODULE_7__modules_job_profile_utils_helpers__["a" /* commandMap */].mediumCommand), data)
							});
							commit('UPDATE_COMMAND_DATA', {
								command: 'lowCommand',
								data: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["t" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('code', __WEBPACK_IMPORTED_MODULE_7__modules_job_profile_utils_helpers__["a" /* commandMap */].lowCommand), data)
							});
							return _context8.abrupt('return', true);

						case 15:
							_context8.prev = 15;
							_context8.t0 = _context8['catch'](0);
							throw new Error(_context8.t0);

						case 18:
						case 'end':
							return _context8.stop();
					}
				}
			}, _callee8, _this8, [[0, 15]]);
		}))();
	},
	getGuidelineModelStatus: function getGuidelineModelStatus(_ref19) {
		var _this9 = this;

		var commit = _ref19.commit;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
			var response, _response$data, details, jobs, additionalInformation, jobList, jobsWithProgress, fatherByChildId, mirrorsByChildId, walkTree, parsedAssignations, assignationsWithFathers;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
				while (1) {
					switch (_context9.prev = _context9.next) {
						case 0:
							_context9.next = 2;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$http.get('/polls/JEV?organizationChart=true');

						case 2:
							response = _context9.sent;
							_response$data = response.data, details = _response$data.details, jobs = _response$data.jobs, additionalInformation = _response$data.additionalInformation;
							jobList = additionalInformation && additionalInformation.jobs || [];

							// syncing job list from api - agregando cálculo de progreso

							jobsWithProgress = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(function (job) {
								var parsedJob = Object(__WEBPACK_IMPORTED_MODULE_7__modules_job_profile_utils_helpers__["d" /* parseJobs */])(job);
								return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, parsedJob, {
									progress: Object(__WEBPACK_IMPORTED_MODULE_8__modules_job_profile_helpers_helpers__["a" /* calculateJobProgress */])(parsedJob)
								});
							}, jobList);

							commit('UPDATE_JOB_LIST', jobsWithProgress);
							// syncing organization chart info from api
							commit('UPDATE_ORGANIZATION_CHART', jobs || []);
							// Derive the REAL father of each job from the stage-2 tree (the same tree the
							// org chart renders). `details` (stage 1) keeps stale default fathers; the tree
							// encodes the true reporting line by nesting. Mirror appearances are emitted by
							// the backend as leaf clones flagged `isMirror`; they are collected separately
							// so the primary father (from the non-mirror edge) is never overwritten. Only
							// record an edge when both parent and child expose an id, so this can never wipe
							// an existing father: a job not found as a child in the tree keeps its `details`
							// father (no regression).
							fatherByChildId = {};
							mirrorsByChildId = {};

							walkTree = function walkTree(node) {
								var children = node && node.details || [];
								for (var i = 0; i < children.length; i += 1) {
									var child = children[i];
									if (node.id && child.id) {
										if (child.isMirror) {
											if (!mirrorsByChildId[child.id]) {
												mirrorsByChildId[child.id] = [];
											}
											if (mirrorsByChildId[child.id].indexOf(node.id) === -1) {
												mirrorsByChildId[child.id].push(node.id);
											}
										} else {
											fatherByChildId[child.id] = { fatherId: node.id, fatherName: node.name };
										}
									}
									// Mirror clones are leaves; do not descend into them.
									if (!child.isMirror) {
										walkTree(child);
									}
								}
							};

							(jobs || []).forEach(walkTree);
							if (details) {
								parsedAssignations = Object(__WEBPACK_IMPORTED_MODULE_7__modules_job_profile_utils_helpers__["c" /* parseHierarchyAssignation */])(details);
								assignationsWithFathers = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(function (level) {
									return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, level, {
										jobPositions: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(function (jp) {
											var real = fatherByChildId[jp.id];
											var treeMirrors = mirrorsByChildId[jp.id];
											// Prefer tree-reconstructed mirrors; fall back to the value parsed
											// from stage-1 details when the tree has no mirror data.
											var mirrorFatherIds = treeMirrors || jp.mirrorFatherIds || [];
											var withFather = real ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, jp, { fatherId: real.fatherId, fatherName: real.fatherName }) : jp;
											return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, withFather, { mirrorFatherIds: mirrorFatherIds });
										}, level.jobPositions || [])
									});
								}, parsedAssignations);

								commit('UPDATE_HIERARCHY_ASSIGNATION', assignationsWithFathers);
							}

						case 13:
						case 'end':
							return _context9.stop();
					}
				}
			}, _callee9, _this9);
		}))();
	},
	assignHierarchy: function assignHierarchy(_ref20) {
		var _this10 = this;

		var state = _ref20.state;
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
			var payloadRequest;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
				while (1) {
					switch (_context10.prev = _context10.next) {
						case 0:
							__WEBPACK_IMPORTED_MODULE_6__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: true, message: LOADER_MESSAGE });
							_context10.prev = 1;
							payloadRequest = Object(__WEBPACK_IMPORTED_MODULE_7__modules_job_profile_utils_helpers__["b" /* parseAssignationRequest */])(state, options);
							_context10.next = 5;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.post('/polles/unique', payloadRequest);

						case 5:
							return _context10.abrupt('return', true);

						case 6:
							_context10.prev = 6;

							__WEBPACK_IMPORTED_MODULE_6__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: false });
							return _context10.finish(6);

						case 9:
						case 'end':
							return _context10.stop();
					}
				}
			}, _callee10, _this10, [[1,, 6, 9]]);
		}))();
	},
	generateOrganizationChart: function generateOrganizationChart(_ref21) {
		var _this11 = this;

		var state = _ref21.state;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
				while (1) {
					switch (_context11.prev = _context11.next) {
						case 0:
							__WEBPACK_IMPORTED_MODULE_6__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: true, message: LOADER_MESSAGE_ORGANIZATIONAL_CHART });
							_context11.prev = 1;
							_context11.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.post('/polles/unique', Object(__WEBPACK_IMPORTED_MODULE_7__modules_job_profile_utils_helpers__["e" /* parseOrganizationChart */])(state));

						case 4:
							return _context11.abrupt('return', true);

						case 7:
							_context11.prev = 7;
							_context11.t0 = _context11['catch'](1);
							throw _context11.t0;

						case 10:
							_context11.prev = 10;

							__WEBPACK_IMPORTED_MODULE_6__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: false });
							return _context11.finish(10);

						case 13:
						case 'end':
							return _context11.stop();
					}
				}
			}, _callee11, _this11, [[1, 7, 10, 13]]);
		}))();
	},
	updateAssignation: function updateAssignation(_ref22, _ref23) {
		var state = _ref22.state,
		    commit = _ref22.commit;
		var jobPosition = _ref23.jobPosition,
		    assignationId = _ref23.assignationId;

		var hierarchyAssignation = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["N" /* path */])(['supplies', 'guidelineModel', 'hierarchyAssignation'], state);
		var assignationIndex = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["u" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('id', assignationId), hierarchyAssignation);
		var jobPositionIndex = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["u" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('id', jobPosition.id), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["N" /* path */])([assignationIndex, 'jobPositions'], hierarchyAssignation));
		commit('UPDATE_JOB_POSITION_ASSIGNATION', { assignationIndex: assignationIndex, jobPositionIndex: jobPositionIndex, jobPosition: jobPosition });
	},
	filterJobsByGroupId: function filterJobsByGroupId(_ref24, groupId) {
		var commit = _ref24.commit,
		    state = _ref24.state;

		// Validar que groupId sea un array válido
		var validGroupId = Array.isArray(groupId) ? groupId : [];
		var filteredJobs = state.supplies.guidelineModel.userForm.jobList.filter(function (job) {
			return (validGroupId.length === 0 || validGroupId.includes(job.areaId)) && job.status;
		});
		var idsJobs = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["S" /* pluck */])('id', filteredJobs);
		commit('SET_FILTERED_JOBS_IDS', idsJobs);
		commit('SET_FILTERED_JOBS', filteredJobs);
	},
	filterJobActive: function filterJobActive(_ref25, jobs) {
		var commit = _ref25.commit;

		var jobsActive = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["s" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["W" /* propEq */])('status', true), jobs);
		var jobFilter = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('id'), jobsActive);
		commit('SET_FILTERED_JOBS_IDS', jobFilter);
	},
	updateFilterJobList: function updateFilterJobList(_ref26, filterJobList) {
		var commit = _ref26.commit;

		commit('UPDATE_FILTER_JOB_LIST', filterJobList);
	},
	jobsDeleteinJobList: function jobsDeleteinJobList(_ref27, jobSelected) {
		var commit = _ref27.commit,
		    state = _ref27.state;

		jobSelected.forEach(function (obj) {
			var index = state.supplies.guidelineModel.userForm.deletedJobs.findIndex(function (item) {
				return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["r" /* equals */])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('id', item), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["V" /* prop */])('id', obj));
			});
			if (index === -1) {
				commit('JOBS_DELETE_IN_JOB_LIST', obj);
			}
		});
	},
	loadGroups: function loadGroups(_ref28) {
		var _this12 = this;

		var commit = _ref28.commit,
		    state = _ref28.state;

		var _ref29 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref29$forceRefresh = _ref29.forceRefresh,
		    forceRefresh = _ref29$forceRefresh === undefined ? false : _ref29$forceRefresh;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
			var params;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
				while (1) {
					switch (_context12.prev = _context12.next) {
						case 0:
							if (!(!forceRefresh && state.supplies.guidelineModel.groups && state.supplies.guidelineModel.groups.length > 0)) {
								_context12.next = 2;
								break;
							}

							return _context12.abrupt('return', state.supplies.guidelineModel.groups);

						case 2:
							if (!pendingLoadGroups) {
								_context12.next = 4;
								break;
							}

							return _context12.abrupt('return', pendingLoadGroups);

						case 4:
							params = {
								sortField: 'name',
								sortDirection: 'ASC'
							};

							pendingLoadGroups = __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$httpPraktiko.get('groups', { params: params }).then(function (_ref30) {
								var response = _ref30.data;

								commit('UPDATE_GROUPS', response);
								return response;
							}).finally(function () {
								pendingLoadGroups = null;
							});

							return _context12.abrupt('return', pendingLoadGroups);

						case 7:
						case 'end':
							return _context12.stop();
					}
				}
			}, _callee12, _this12);
		}))();
	},


	// ✅ NUEVO: Método para invalidar cache de grupos
	refreshGroups: function refreshGroups(_ref31) {
		var _this13 = this;

		var dispatch = _ref31.dispatch;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
				while (1) {
					switch (_context13.prev = _context13.next) {
						case 0:
							return _context13.abrupt('return', dispatch('loadGroups', { forceRefresh: true }));

						case 1:
						case 'end':
							return _context13.stop();
					}
				}
			}, _callee13, _this13);
		}))();
	}
});

/***/ }),
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = ({
	UPDATE_HAS_INFORMATION: function UPDATE_HAS_INFORMATION(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hasInformationJobEvaluation = payload;
	},
	UPDATE_INFORMATION_JOB_EVALUATION: function UPDATE_INFORMATION_JOB_EVALUATION(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.informationJobEvaluation = payload;
	},
	UPDATE_JOB_LIST: function UPDATE_JOB_LIST(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.jobList = payload;
	},
	UPDATE_MAIN_DATA: function UPDATE_MAIN_DATA(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.mainData = payload;
	},
	UPDATE_LEVEL_SELECTION_ROLE: function UPDATE_LEVEL_SELECTION_ROLE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.role = payload;
	},
	UPDATE_LEVEL_SELECTION_TITLE: function UPDATE_LEVEL_SELECTION_TITLE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.title = payload;
	},
	UPDATE_PLATFORMS: function UPDATE_PLATFORMS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.generalData.platforms = payload;
	},
	UPDATE_LEVEL_SELECTION_EXPERIENCE: function UPDATE_LEVEL_SELECTION_EXPERIENCE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.experience = payload;
	},
	UPDATE_LEVEL_SELECTION_ENGLISH_LEVEL: function UPDATE_LEVEL_SELECTION_ENGLISH_LEVEL(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.englishLevel = payload;
	},
	UPDATE_COMMAND_DATA: function UPDATE_COMMAND_DATA(state, _ref) {
		var command = _ref.command,
		    data = _ref.data;

		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.verbsSelection[command] = data;
	},
	UPDATE_HIERARCHY_ASSIGNATION: function UPDATE_HIERARCHY_ASSIGNATION(state, payload) {
		if (Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["I" /* length */])(payload) > 0) {
			// eslint-disable-next-line no-param-reassign
			state.supplies.guidelineModel.hasPreviewValues = true;
		}
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hierarchyAssignation = payload;
	},
	UPDATE_ORGANIZATION_CHART: function UPDATE_ORGANIZATION_CHART(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.organizationChart = payload;
	},
	UPDATE_JOB_POSITION_ASSIGNATION: function UPDATE_JOB_POSITION_ASSIGNATION(state, _ref2) {
		var assignationIndex = _ref2.assignationIndex,
		    jobPositionIndex = _ref2.jobPositionIndex,
		    jobPosition = _ref2.jobPosition;

		var hierarchyAssignation = state.supplies.guidelineModel.hierarchyAssignation;
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hierarchyAssignation = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["k" /* assocPath */])([assignationIndex, 'jobPositions', jobPositionIndex], jobPosition, hierarchyAssignation);
	},
	SET_FILTERED_JOBS: function SET_FILTERED_JOBS(state, filteredJobs) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.filteredJobs = filteredJobs;
	},
	UPDATE_FILTER_JOB_LIST: function UPDATE_FILTER_JOB_LIST(state, filterJobList) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.filteredJobs = filterJobList;
	},
	JOBS_DELETE_IN_JOB_LIST: function JOBS_DELETE_IN_JOB_LIST(state, jobSelected) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.deletedJobs.push(jobSelected);
	},
	CLEAN_DELETE_DATA: function CLEAN_DELETE_DATA(state) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.deletedJobs = [];
	},
	SET_FILTERED_JOBS_IDS: function SET_FILTERED_JOBS_IDS(state, idsFilterJobs) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.idsFilterJobs = idsFilterJobs;
	},
	UPDATE_GROUPS: function UPDATE_GROUPS(state, groups) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.groups = groups;
	}
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_job_evaluation_utils_valuation_model_degree__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);







var findIndexFactor = function findIndexFactor(factor, factorList) {
	return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["u" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["W" /* propEq */])('uuid', factor.uuid), factorList);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	resetValuationModelState: function resetValuationModelState(_ref) {
		var commit = _ref.commit;

		commit('RESET_VALUATION_MODEL');
	},
	updateSelectedFactors: function updateSelectedFactors(_ref2, selectedFactors) {
		var commit = _ref2.commit;

		var combinations = Object(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["i" /* generateWeighingComparison */])(selectedFactors);
		commit('UPDATE_COMBINATIONS', combinations);
		commit('UPDATE_SELECTED_FACTORS', Object(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["b" /* addWeighWith */])(selectedFactors, combinations));
	},
	setSelectedFactors: function setSelectedFactors(_ref3, selectedFactors) {
		var commit = _ref3.commit;

		commit('UPDATE_SELECTED_FACTORS', selectedFactors);
	},
	setCombinations: function setCombinations(_ref4, combinations) {
		var commit = _ref4.commit;

		commit('UPDATE_COMBINATIONS', combinations);
	},
	setFactorDegrees: function setFactorDegrees(_ref5, factorDegrees) {
		var commit = _ref5.commit;

		commit('SET_FACTOR_DEGREES', factorDegrees);
	},
	updateSelectedFactor: function updateSelectedFactor(_ref6, selectedFactor) {
		var commit = _ref6.commit;

		commit('UPDATE_SELECTED_FACTOR', selectedFactor);
	},
	updateSelectedFactorDegree: function updateSelectedFactorDegree(_ref7, selectedFactor) {
		var commit = _ref7.commit;

		commit('UPDATE_SELECTED_FACTOR_DEGREE', selectedFactor);
	},
	updateFactorInSelectedFactors: function updateFactorInSelectedFactors(_ref8, itemToReplace) {
		var state = _ref8.state,
		    commit = _ref8.commit;

		var selectedFactors = state.supplies.valuationModel.selectedFactors;
		var indexFound = findIndexFactor(itemToReplace, selectedFactors);
		commit('UPDATE_SELECTED_FACTORS', Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["_8" /* update */])(indexFound, itemToReplace, selectedFactors));
	},
	getFactors: function getFactors(_ref9) {
		var _this = this;

		var state = _ref9.state,
		    commit = _ref9.commit;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _ref10, factors;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							if (!(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["I" /* length */])(state.supplies.valuationModel.factorList) < 1)) {
								_context.next = 6;
								break;
							}

							_context.next = 3;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$http.get('/hierarchies/JEV?flagLevel=true&level=3');

						case 3:
							_ref10 = _context.sent;
							factors = _ref10.data;

							commit('UPDATE_FACTORS', Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */])(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["a" /* addUuidName */], factors));

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	},
	updateCombination: function updateCombination(_ref11, newCombination) {
		var commit = _ref11.commit,
		    state = _ref11.state;

		var currentCombinations = state.supplies.valuationModel.weighing.combinations;
		var sortKeys = function sortKeys(combinationItem) {
			return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["_2" /* sort */])(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["d" /* diff */], Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* keys */])(combinationItem));
		};
		var indexFound = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["u" /* findIndex */])(function (combinationItem) {
			return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["r" /* equals */])(sortKeys(newCombination), sortKeys(combinationItem));
		}, currentCombinations);
		commit('UPDATE_COMBINATIONS', Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["_8" /* update */])(indexFound, newCombination, currentCombinations));
	},
	updateCombinations: function updateCombinations(_ref12, newCombinations) {
		var commit = _ref12.commit;

		commit('UPDATE_COMBINATIONS', newCombinations);
	},
	getDegrees: function getDegrees(_ref13) {
		var _this2 = this;

		var commit = _ref13.commit,
		    state = _ref13.state;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			var _state$supplies$valua, selectedFactors, _ref14, degrees, degreesByFactors;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_state$supplies$valua = state.supplies.valuationModel.selectedFactors, selectedFactors = _state$supplies$valua === undefined ? [] : _state$supplies$valua;
							_context2.prev = 1;
							_context2.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$http.get('/hierarchies/JEV?flagLevel=true&level=4');

						case 4:
							_ref14 = _context2.sent;
							degrees = _ref14.data;
							degreesByFactors = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Z" /* reduce */])(function (acc, factor) {
								return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["j" /* assoc */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('uuid', factor), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["s" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["O" /* pathEq */])(['kindEntity', 'code'], Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* prop */])('code', factor))), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* pipe */])(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["a" /* addUuidName */], Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* pick */])(['uuid', 'name', 'code']))))(degrees), acc);
							}, {}, selectedFactors);

							commit('UPDATE_DEGREES_BY_FACTOR', degreesByFactors);
							return _context2.abrupt('return', true);

						case 11:
							_context2.prev = 11;
							_context2.t0 = _context2['catch'](1);
							throw _context2.t0;

						case 14:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2, [[1, 11]]);
		}))();
	},
	updateFactorDegrees: function updateFactorDegrees(_ref15, factorDegrees) {
		var commit = _ref15.commit;

		commit('UPDATE_FACTOR_DEGREES', factorDegrees);
	},
	createValuation: function createValuation(_ref16) {
		var _this3 = this;

		var state = _ref16.state;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
			var payloadRequest;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							payloadRequest = Object(__WEBPACK_IMPORTED_MODULE_4__modules_job_evaluation_utils_valuation_model_degree__["e" /* parseRequestValuation */])(state);
							_context3.prev = 1;
							_context3.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$http.post('/polls', payloadRequest);

						case 4:
							return _context3.abrupt('return', true);

						case 7:
							_context3.prev = 7;
							_context3.t0 = _context3['catch'](1);
							throw _context3.t0;

						case 10:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, _this3, [[1, 7]]);
		}))();
	},
	savePayrollProposal: function savePayrollProposal(_, payload) {
		var _this4 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
			var currentPayroll, idealPayroll;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							currentPayroll = payload.currentPayroll, idealPayroll = payload.idealPayroll;
							_context4.prev = 1;
							_context4.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$http.patch('/polls/JEV', {
								additionalInformation: {
									currentPayroll: parseFloat(currentPayroll),
									idealPayroll: parseFloat(idealPayroll)
								},
								stageStatus: 2,
								stageDetailStatus: 1
							});

						case 4:
							return _context4.abrupt('return', true);

						case 7:
							_context4.prev = 7;
							_context4.t0 = _context4['catch'](1);
							throw _context4.t0;

						case 10:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, _this4, [[1, 7]]);
		}))();
	}
});

/***/ }),
/* 848 */,
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
	RESET_VALUATION_MODEL: function RESET_VALUATION_MODEL(state) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel = {
			factorList: [],
			degreesListByFactor: [],
			selectedFactors: [],
			weighing: {
				selectedFactor: {},
				combinations: []
			},
			degree: {
				selectedFactor: {},
				factorDegrees: {}
			}
		};
	},
	UPDATE_SELECTED_FACTORS: function UPDATE_SELECTED_FACTORS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.selectedFactors = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload));
	},
	UPDATE_SELECTED_FACTOR: function UPDATE_SELECTED_FACTOR(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.weighing.selectedFactor = payload;
	},
	UPDATE_FACTORS: function UPDATE_FACTORS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.factorList = payload;
	},
	UPDATE_DEGREES_BY_FACTOR: function UPDATE_DEGREES_BY_FACTOR(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degreesListByFactor = payload;
	},
	UPDATE_COMBINATIONS: function UPDATE_COMBINATIONS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.weighing.combinations = payload;
	},
	UPDATE_SELECTED_FACTOR_DEGREE: function UPDATE_SELECTED_FACTOR_DEGREE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degree.selectedFactor = payload;
	},
	UPDATE_FACTOR_DEGREES: function UPDATE_FACTOR_DEGREES(state, factorDegrees) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degree.factorDegrees = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.supplies.valuationModel.degree.factorDegrees, factorDegrees);
	},
	SET_FACTOR_DEGREES: function SET_FACTOR_DEGREES(state, factorDegrees) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degree.factorDegrees = factorDegrees;
	}
});

/***/ }),
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helper__ = __webpack_require__(39);





/* eslint-disable no-param-reassign */

var processModule = {
	actions: {
		loadEvaluation360: function loadEvaluation360(_ref) {
			var _this = this;

			var commit = _ref.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var EVALUATION_360_CODE, _ref2, data;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								EVALUATION_360_CODE = 'E360';
								_context.next = 3;
								return __WEBPACK_IMPORTED_MODULE_2__axios__["b" /* pollInstance */].get('/tools/' + EVALUATION_360_CODE);

							case 3:
								_ref2 = _context.sent;
								data = _ref2.data;

								commit('UPDATE_MAIN_DATA', data);

							case 6:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		assignProcess: function assignProcess(_ref3, process) {
			var _this2 = this;

			var commit = _ref3.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								__WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].setLocalData('process', process);
								commit('SAVE_PROCESS', process);

							case 2:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		selectedEmployee: function selectedEmployee(_ref4, employee) {
			var commit = _ref4.commit;

			__WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].setLocalData('selectedEmployee', employee);
			commit('SAVE_EMPLOYEE_SELECTED', employee);
		},
		setEmployeeAndEvaluators: function setEmployeeAndEvaluators(_ref5, _ref6) {
			var commit = _ref5.commit;
			var employeeId = _ref6.employeeId,
			    evaluators = _ref6.evaluators;

			commit('SET_EMPLOYEE_EVALUATORS', { employeeId: employeeId, evaluators: evaluators });
		},
		updateEmployeesByArea: function updateEmployeesByArea(_ref7, _ref8) {
			var commit = _ref7.commit;
			var _ref8$idArea = _ref8.idArea,
			    idArea = _ref8$idArea === undefined ? null : _ref8$idArea,
			    _ref8$employees = _ref8.employees,
			    employees = _ref8$employees === undefined ? [] : _ref8$employees;

			var employeesFilter = employees.filter(function (empleado) {
				return empleado.groupId === idArea;
			});
			commit('SET_EMPLOYEES_BY_AREA', { idArea: idArea, employeesFilter: employeesFilter });
		},
		saveJobIds: function saveJobIds(_ref9) {
			var commit = _ref9.commit;
			var jobIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

			__WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].setLocalData('jobIds', jobIds);
			commit('SAVE_JOB_IDS', jobIds);
		},
		updateEvaluationScale: function updateEvaluationScale(_ref10, evaluationScale) {
			var commit = _ref10.commit;

			commit('SAVE_EVALUATION_SCALE', evaluationScale);
		}
	},
	state: {
		mainData: {},
		process: null,
		selectedEmployee: null,
		employeesByAreas: [],
		jobIds: []
	},
	mutations: {
		UPDATE_MAIN_DATA: function UPDATE_MAIN_DATA(state, data) {
			state.mainData = data;
		},
		SAVE_PROCESS: function SAVE_PROCESS(state, process) {
			state.process = process;
		},
		SET_EMPLOYEE_EVALUATORS: function SET_EMPLOYEE_EVALUATORS(state, _ref11) {
			var employeeId = _ref11.employeeId,
			    evaluators = _ref11.evaluators;

			__WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.employeesAndEvaluators, employeeId, evaluators);
		},
		SET_EMPLOYEES_BY_AREA: function SET_EMPLOYEES_BY_AREA(state, _ref12) {
			var idArea = _ref12.idArea,
			    employeesFilter = _ref12.employeesFilter;

			if (employeesFilter.length > 0) {
				var index = state.employeesByAreas.findIndex(function (area) {
					return area.idArea === idArea;
				});
				if (index !== -1) {
					state.employeesByAreas[index].employeesFilter = employeesFilter;
				} else {
					state.employeesByAreas.push({ idArea: idArea, employeesFilter: employeesFilter });
				}
			} else {
				state.employeesByAreas = [];
			}
		},
		SAVE_JOB_IDS: function SAVE_JOB_IDS(state, jobIds) {
			state.jobIds = jobIds;
		},
		SAVE_EMPLOYEE_SELECTED: function SAVE_EMPLOYEE_SELECTED(state, employee) {
			state.selectedEmployee = employee;
		},
		SAVE_EVALUATION_SCALE: function SAVE_EVALUATION_SCALE(state, evaluationScale) {
			state.mainData.config.evaluationScale = evaluationScale;
		}
	},
	getters: {}
};

/* harmony default export */ __webpack_exports__["a"] = (processModule);

/***/ }),
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(39);




// import { pollInstance } from '@/axios';


/* eslint-disable no-param-reassign */

var profileModule = {
	actions: {
		loadJobProfileConfig: function loadJobProfileConfig(_ref) {
			var _this = this;

			var commit = _ref.commit,
			    state = _ref.state;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
				var JOB_PROFILE_TOOL_CODE, _ref2, data;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(state.mainData && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(state.mainData) === 'object' && state.mainData.config && state.mainData.config.stages && Array.isArray(state.mainData.config.stages) && state.mainData.config.stages.length > 0)) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return', state.mainData);

							case 2:
								JOB_PROFILE_TOOL_CODE = 'JPF';
								_context.next = 5;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$http.get('/tools/' + JOB_PROFILE_TOOL_CODE);

							case 5:
								_ref2 = _context.sent;
								data = _ref2.data;

								commit('UPDATE_MAIN_DATA', data);
								return _context.abrupt('return', data);

							case 9:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		loadKnowledges: function loadKnowledges(_ref3) {
			var _this2 = this;

			var commit = _ref3.commit,
			    state = _ref3.state;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var _ref4, data, payload;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!(state.descriptionData.knowledge && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(state.descriptionData.knowledge) === 'object' && state.descriptionData.knowledge.data && Array.isArray(state.descriptionData.knowledge.data) && state.descriptionData.knowledge.data.length > 0)) {
									_context2.next = 2;
									break;
								}

								return _context2.abrupt('return', state.descriptionData.knowledge);

							case 2:
								_context2.next = 4;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('/general-data/KNW');

							case 4:
								_ref4 = _context2.sent;
								data = _ref4.data;
								payload = {
									name: 'Conocimientos',
									data: data
								};

								commit('UPDATE_LEVEL_SELECTION_KNOWLEDGE', payload);
								return _context2.abrupt('return', payload);

							case 9:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		loadCareers: function loadCareers(_ref5) {
			var _this3 = this;

			var commit = _ref5.commit,
			    state = _ref5.state;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var _ref6, data;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (!(state.descriptionData.careers && Array.isArray(state.descriptionData.careers) && state.descriptionData.careers.length > 0)) {
									_context3.next = 2;
									break;
								}

								return _context3.abrupt('return', state.descriptionData.careers);

							case 2:
								_context3.next = 4;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('/general-data/CAR');

							case 4:
								_ref6 = _context3.sent;
								data = _ref6.data;

								commit('UPDATE_LEVEL_SELECTION_CAREER', data);
								return _context3.abrupt('return', data);

							case 8:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		loadTimes: function loadTimes(_ref7) {
			var _this4 = this;

			var commit = _ref7.commit,
			    state = _ref7.state;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var _ref8, data;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								if (!(state.descriptionData.times && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(state.descriptionData.times) === 'object' && state.descriptionData.times.data && Array.isArray(state.descriptionData.times.data) && state.descriptionData.times.data.length > 0)) {
									_context4.next = 2;
									break;
								}

								return _context4.abrupt('return', state.descriptionData.times);

							case 2:
								_context4.next = 4;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('/general-data/TMP');

							case 4:
								_ref8 = _context4.sent;
								data = _ref8.data;

								commit('UPDATE_LEVEL_SELECTION_TIME', data);
								return _context4.abrupt('return', data);

							case 8:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		loadMeasureOfTime: function loadMeasureOfTime(_ref9) {
			var _this5 = this;

			var commit = _ref9.commit,
			    state = _ref9.state;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var _ref10, data;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								if (!(state.descriptionData.measureOfTime && Array.isArray(state.descriptionData.measureOfTime) && state.descriptionData.measureOfTime.length > 0)) {
									_context5.next = 2;
									break;
								}

								return _context5.abrupt('return', state.descriptionData.measureOfTime);

							case 2:
								_context5.next = 4;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('/general-data/MTP');

							case 4:
								_ref10 = _context5.sent;
								data = _ref10.data;

								commit('UPDATE_LEVEL_SELECTION_MEASURE_TIME', data);
								return _context5.abrupt('return', data);

							case 8:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		loadResponsabilities: function loadResponsabilities(_ref11) {
			var _this6 = this;

			var commit = _ref11.commit,
			    state = _ref11.state;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var _ref12, data;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								if (!(state.descriptionData.responsabilities && Array.isArray(state.descriptionData.responsabilities) && state.descriptionData.responsabilities.length > 0)) {
									_context6.next = 2;
									break;
								}

								return _context6.abrupt('return', state.descriptionData.responsabilities);

							case 2:
								_context6.next = 4;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('/general-data/RSTY');

							case 4:
								_ref12 = _context6.sent;
								data = _ref12.data;

								commit('UPDATE_LEVEL_SELECTION_RESPONSABILITIES', data);
								return _context6.abrupt('return', data);

							case 8:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		loadRelevance: function loadRelevance(_ref13) {
			var _this7 = this;

			var commit = _ref13.commit,
			    state = _ref13.state;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
				var _ref14, data;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								if (!(state.descriptionData.relevance && Array.isArray(state.descriptionData.relevance) && state.descriptionData.relevance.length > 0)) {
									_context7.next = 2;
									break;
								}

								return _context7.abrupt('return', state.descriptionData.relevance);

							case 2:
								_context7.next = 4;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('/general-data/RLVC');

							case 4:
								_ref14 = _context7.sent;
								data = _ref14.data;

								commit('UPDATE_LEVEL_SELECTION_RELEVANCE', data);
								return _context7.abrupt('return', data);

							case 8:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},
		loadSortJobList: function loadSortJobList(_ref15) {
			var _this8 = this;

			var commit = _ref15.commit;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
				var params, _ref16, data;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								params = {
									sortField: 'name',
									sortDirection: 'ASC'
								};
								_context8.next = 3;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('groups/jobs', { params: params });

							case 3:
								_ref16 = _context8.sent;
								data = _ref16.data;

								commit('LOAD_SORT_JOBLIST', data);

							case 6:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, _this8);
			}))();
		},

		// ✅ NUEVO: Acción para cargar job description con cache
		loadJobDescription: function loadJobDescription(_ref17, _ref18) {
			var _this9 = this;

			var commit = _ref17.commit,
			    state = _ref17.state;
			var codeStep = _ref18.codeStep,
			    jobId = _ref18.jobId,
			    _ref18$forceRefresh = _ref18.forceRefresh,
			    forceRefresh = _ref18$forceRefresh === undefined ? false : _ref18$forceRefresh;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
				var cacheKey, CACHE_DURATION, cacheEntry, now, isCacheValid, _ref19, data;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								cacheKey = codeStep + '_' + jobId;

								// ✅ CACHE INTELIGENTE: Verificar si el cache existe y no ha expirado

								CACHE_DURATION = 15 * 60 * 1000; // 15 minutos

								cacheEntry = state.jobDescriptionCache[cacheKey];
								now = Date.now();
								isCacheValid = cacheEntry && now - cacheEntry.timestamp < CACHE_DURATION;

								// Evitar cargar si cache es válido y no se fuerza refresh

								if (!(!forceRefresh && isCacheValid)) {
									_context9.next = 7;
									break;
								}

								return _context9.abrupt('return', cacheEntry.data);

							case 7:
								_context9.prev = 7;
								_context9.next = 10;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('job-description/detail/' + codeStep + '/' + jobId);

							case 10:
								_ref19 = _context9.sent;
								data = _ref19.data;


								// Guardar en cache
								commit('SET_JOB_DESCRIPTION_CACHE', { cacheKey: cacheKey, data: data });

								return _context9.abrupt('return', data);

							case 16:
								_context9.prev = 16;
								_context9.t0 = _context9['catch'](7);
								throw _context9.t0;

							case 19:
							case 'end':
								return _context9.stop();
						}
					}
				}, _callee9, _this9, [[7, 16]]);
			}))();
		},


		// ✅ NUEVO: Acción para limpiar cache de job descriptions
		clearJobDescriptionCache: function clearJobDescriptionCache(_ref20) {
			var commit = _ref20.commit;
			var jobId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			commit('CLEAR_JOB_DESCRIPTION_CACHE', jobId);
		},


		// ✅ NUEVO: Limpiar todos los caches (para casos extremos)
		clearAllCaches: function clearAllCaches(_ref21) {
			var commit = _ref21.commit;

			commit('CLEAR_JOB_DESCRIPTION_CACHE', null); // Limpiar cache de descriptions
			commit('UPDATE_MAIN_DATA', {}); // Limpiar cache de config
			// Limpiar otros caches si es necesario
		},


		// ✅ NUEVO: Acción para invalidar cache después de guardar
		saveJobDescriptionAndInvalidateCache: function saveJobDescriptionAndInvalidateCache(_ref22, _ref23) {
			var _this10 = this;

			var dispatch = _ref22.dispatch;
			var url = _ref23.url,
			    body = _ref23.body,
			    jobId = _ref23.jobId,
			    successMessage = _ref23.successMessage;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
					while (1) {
						switch (_context10.prev = _context10.next) {
							case 0:
								_context10.prev = 0;
								_context10.next = 3;
								return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.post(url, body);

							case 3:

								// Invalidar cache del job específico
								dispatch('clearJobDescriptionCache', jobId);

								return _context10.abrupt('return', { success: true, message: successMessage });

							case 7:
								_context10.prev = 7;
								_context10.t0 = _context10['catch'](0);
								throw _context10.t0;

							case 10:
							case 'end':
								return _context10.stop();
						}
					}
				}, _callee10, _this10, [[0, 7]]);
			}))();
		},
		saveJobSelected: function saveJobSelected(_ref24, selectedJob) {
			var commit = _ref24.commit;

			__WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData('selectedJob', selectedJob);
			commit('SAVE_JOB_SELECTED', selectedJob);
		}
	},
	state: {
		selectedJob: {},
		mainData: {},
		descriptionData: {
			knowledge: null, // Cambiar de {} a null para mejor detección de cache
			careers: null, // Cambiar de {} a null para mejor detección de cache
			times: null, // Cambiar de {} a null para mejor detección de cache
			measureOfTime: null, // Cambiar de {} a null para mejor detección de cache
			responsabilities: null, // Cambiar de {} a null para mejor detección de cache
			relevance: null // Cambiar de {} a null para mejor detección de cache
		},
		// ✅ NUEVO: Cache para job descriptions por código y jobId
		jobDescriptionCache: {},
		jobList: []
	},
	mutations: {
		SAVE_JOB_SELECTED: function SAVE_JOB_SELECTED(state, selectedJob) {
			state.selectedJob = selectedJob;
		},
		UPDATE_LEVEL_SELECTION_KNOWLEDGE: function UPDATE_LEVEL_SELECTION_KNOWLEDGE(state, payload) {
			state.descriptionData.knowledge = payload;
		},
		UPDATE_LEVEL_SELECTION_CAREER: function UPDATE_LEVEL_SELECTION_CAREER(state, payload) {
			state.descriptionData.careers = payload;
		},
		UPDATE_LEVEL_SELECTION_TIME: function UPDATE_LEVEL_SELECTION_TIME(state, payload) {
			state.descriptionData.times = payload;
		},
		UPDATE_LEVEL_SELECTION_MEASURE_TIME: function UPDATE_LEVEL_SELECTION_MEASURE_TIME(state, payload) {
			state.descriptionData.measureOfTime = payload;
		},
		UPDATE_LEVEL_SELECTION_RESPONSABILITIES: function UPDATE_LEVEL_SELECTION_RESPONSABILITIES(state, payload) {
			state.descriptionData.responsabilities = payload;
		},
		UPDATE_LEVEL_SELECTION_RELEVANCE: function UPDATE_LEVEL_SELECTION_RELEVANCE(state, payload) {
			state.descriptionData.relevance = payload;
		},
		LOAD_SORT_JOBLIST: function LOAD_SORT_JOBLIST(state, payload) {
			state.jobList = payload;
		},
		UPDATE_MAIN_DATA: function UPDATE_MAIN_DATA(state, data) {
			state.mainData = data;
		},

		// ✅ NUEVO: Mutaciones para cache de job descriptions
		SET_JOB_DESCRIPTION_CACHE: function SET_JOB_DESCRIPTION_CACHE(state, _ref25) {
			var cacheKey = _ref25.cacheKey,
			    data = _ref25.data;

			state.jobDescriptionCache[cacheKey] = {
				data: data,
				timestamp: Date.now()
			};
		},
		CLEAR_JOB_DESCRIPTION_CACHE: function CLEAR_JOB_DESCRIPTION_CACHE(state) {
			var jobId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (jobId) {
				// Limpiar cache específico de un job
				__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.jobDescriptionCache).forEach(function (key) {
					if (key.includes('_' + jobId)) {
						delete state.jobDescriptionCache[key];
					}
				});
			} else {
				// Limpiar todo el cache
				state.jobDescriptionCache = {};
			}
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (profileModule);

/***/ }),
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__custom_job_evaluation_poll_actions__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__custom_job_evaluation_poll_mutations__ = __webpack_require__(959);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
	actions: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["K" /* mergeAll */])([__WEBPACK_IMPORTED_MODULE_2__custom_job_evaluation_poll_actions__["a" /* default */]]),
	mutations: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["K" /* mergeAll */])([__WEBPACK_IMPORTED_MODULE_3__custom_job_evaluation_poll_mutations__["a" /* default */]])
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	custom: {
		jobEvaluationPoll: {
			diagnosticId: null,
			pollId: null,
			jobs: [],
			selectedJob: {}
		}
	}
});

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_polls_utils_custom_job_evaluation__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(39);







var getLocalData = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].getLocalData;


/* harmony default export */ __webpack_exports__["a"] = ({
	updateSelectedJob: function updateSelectedJob(_ref, payload) {
		var commit = _ref.commit;

		commit('UPDATE_SELECTED_JOB', payload);
	},
	updateJob: function updateJob(_ref2, _ref3) {
		var commit = _ref2.commit,
		    state = _ref2.state;
		var job = _ref3.job,
		    index = _ref3.index;

		commit('UPDATE_JOBS', Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["_8" /* update */])(index, job, state.custom.jobEvaluationPoll.jobs));
		commit('UPDATE_SELECTED_JOB', job);
	},
	getSurveyData: function getSurveyData(_ref4, _ref5) {
		var _this = this;

		var commit = _ref4.commit;
		var surveyId = _ref5.surveyId;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _ref6, _ref6$data, _ref6$data$jobs, jobs, diagnosticId, id, configRelation, jobsFilter;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.prev = 0;
							_context.next = 3;
							return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$http.get('/poll-employees/' + surveyId + '/detail');

						case 3:
							_ref6 = _context.sent;
							_ref6$data = _ref6.data;
							_ref6$data$jobs = _ref6$data.jobs;
							jobs = _ref6$data$jobs === undefined ? [] : _ref6$data$jobs;
							diagnosticId = _ref6$data.diagnosticId;
							id = _ref6$data.id;
							configRelation = _ref6$data.commitee.configRelation;
							jobsFilter = jobs.filter(function (job) {
								return configRelation.jobs.includes(job.id);
							});

							commit('UPDATE_JOBS', Object(__WEBPACK_IMPORTED_MODULE_4__modules_polls_utils_custom_job_evaluation__["d" /* parseResponseJobs */])(jobsFilter));
							commit('UPDATE_DIAGNOSTIC_ID', diagnosticId);
							commit('UPDATE_POLL_ID', id);
							return _context.abrupt('return', true);

						case 17:
							_context.prev = 17;
							_context.t0 = _context['catch'](0);
							throw _context.t0;

						case 20:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this, [[0, 17]]);
		}))();
	},
	saveSurveyData: function saveSurveyData(_ref7, _ref8) {
		var _this2 = this;

		var state = _ref7.state;
		var isFinalSave = _ref8.isFinalSave;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			var _state$custom$jobEval, jobs, diagnosticId, pollId, param, employeeId;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_state$custom$jobEval = state.custom.jobEvaluationPoll, jobs = _state$custom$jobEval.jobs, diagnosticId = _state$custom$jobEval.diagnosticId, pollId = _state$custom$jobEval.pollId;
							param = isFinalSave ? '?finalSave=true' : '';
							employeeId = getLocalData('praktiko-user').id;
							_context2.prev = 3;
							_context2.next = 6;
							return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$http.post('/poll-employees/unique/' + diagnosticId + '/' + pollId + '/' + employeeId + param, Object(__WEBPACK_IMPORTED_MODULE_4__modules_polls_utils_custom_job_evaluation__["c" /* parsePayloadJobs */])(jobs));

						case 6:
							_context2.next = 11;
							break;

						case 8:
							_context2.prev = 8;
							_context2.t0 = _context2['catch'](3);
							throw _context2.t0;

						case 11:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2, [[3, 8]]);
		}))();
	}
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	UPDATE_SELECTED_JOB: function UPDATE_SELECTED_JOB(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.custom.jobEvaluationPoll.selectedJob = payload;
	},
	UPDATE_JOBS: function UPDATE_JOBS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.custom.jobEvaluationPoll.jobs = payload;
	},
	UPDATE_DIAGNOSTIC_ID: function UPDATE_DIAGNOSTIC_ID(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.custom.jobEvaluationPoll.diagnosticId = payload;
	},
	UPDATE_POLL_ID: function UPDATE_POLL_ID(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.custom.jobEvaluationPoll.pollId = payload;
	}
});

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function clearUser(context) {
	context.commit('clearUser');
}

function toggleLoading(context, value) {
	context.commit('toggleLoading', value);
}

function showSnackBar(context, snackbar) {
	var visibleSnackBar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, snackbar);
	visibleSnackBar.isVisible = true;
	visibleSnackBar.color = visibleSnackBar.color || 'primary';
	context.commit('showSnackBar', visibleSnackBar);
}

function setToken(context, token) {
	context.commit('setToken', token);
}

function setUser(context, user) {
	context.commit('setUser', user);
	context.commit('isEmployee', user.flagAdmin);
}

function setSideBarRoutes(_ref, routes) {
	var commit = _ref.commit;

	commit('SET_SIDE_BAR_ROUTES', routes);
}

var methods = {
	clearUser: clearUser,
	setSideBarRoutes: setSideBarRoutes,
	setToken: setToken,
	setUser: setUser,
	showSnackBar: showSnackBar,
	toggleLoading: toggleLoading
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function indeterminate(state) {
	return state.appConfig.isLoading;
}

function companyLogo(state) {
	return state.user ? state.user.logo : '';
}

function user(state) {
	return state.user;
}

function userName(state) {
	return state.user ? state.user.name + ' ' + state.user.lastName : '';
}

function token(state) {
	return state.token;
}

function snackbar(state) {
	return state.appConfig.snackbar;
}

function themeColors() {
	return JSON.parse(localStorage.getItem("praktiko" + '::theme'));
}

function pollData(state) {
	return state.pollData;
}

function fullName(state) {
	var _state$user = state.user,
	    name = _state$user.name,
	    lastName = _state$user.lastName;

	return name + ' ' + lastName;
}

var methods = {
	companyLogo: companyLogo,
	fullName: fullName,
	indeterminate: indeterminate,
	pollData: pollData,
	snackbar: snackbar,
	themeColors: themeColors,
	token: token,
	user: user,
	userName: userName
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


function clearUser(state) {
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state, 'token', null);
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state, 'user', null);
}

function setToken(state, token) {
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state, 'token', token);
}

function setUser(state, user) {
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state, 'user', user);
}

function isEmployee(state, flagAdmin) {
	var flag = typeof flagAdmin === 'string' ? Number(flagAdmin) : flagAdmin;
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state.user, 'isEmployee', !flag);
}

function showSnackBar(state, snackbar) {
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state.appConfig, 'snackbar', snackbar);
}

function toggleLoading(state, value) {
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state.appConfig, 'isLoading', value);
}

function UPDATE_POLL_PROGRESS(state, number) {
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state.pollData, 'progress', state.pollData.progress + number);
}

function RESET_POLL_PROGRESS(state) {
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state.pollData, 'progress', 0);
}

function SET_SIDE_BAR_ROUTES(state, routes) {
	__WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state, 'sideBarRoutes', routes);
}

var methods = {
	clearUser: clearUser,
	isEmployee: isEmployee,
	setToken: setToken,
	setUser: setUser,
	showSnackBar: showSnackBar,
	toggleLoading: toggleLoading,
	RESET_POLL_PROGRESS: RESET_POLL_PROGRESS,
	SET_SIDE_BAR_ROUTES: SET_SIDE_BAR_ROUTES,
	UPDATE_POLL_PROGRESS: UPDATE_POLL_PROGRESS
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_persist__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_three_sixty_evaluation_store_store_constant__ = __webpack_require__(525);




var SELECTED_FACTORS_PATH = ['jobEvaluation', 'supplies', 'valuationModel', 'selectedFactors'];
var SELECTED_FACTOR = ['jobEvaluation', 'supplies', 'valuationModel', 'weighing', 'selectedFactor'];
var SELECTED_FACTOR_DEGREE = ['jobEvaluation', 'supplies', 'valuationModel', 'degree', 'selectedFactor'];
var FACTOR_DEGREES = ['jobEvaluation', 'supplies', 'valuationModel', 'degree', 'factorDegrees'];
var COMBINATIONS = ['jobEvaluation', 'supplies', 'valuationModel', 'weighing', 'combinations'];

// Three Sixty Evaluation module
var TSE_JOBS_PATH = [__WEBPACK_IMPORTED_MODULE_2__modules_three_sixty_evaluation_store_store_constant__["a" /* THREE_SIXTY_EVALUATION_NAMESPACE */], 'evaluationFlow'];

var storeReducer = function storeReducer(state) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(SELECTED_FACTORS_PATH, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* path */])(SELECTED_FACTORS_PATH, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(SELECTED_FACTOR, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* path */])(SELECTED_FACTOR, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(COMBINATIONS, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* path */])(COMBINATIONS, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(SELECTED_FACTOR_DEGREE, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* path */])(SELECTED_FACTOR_DEGREE, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(FACTOR_DEGREES, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* path */])(FACTOR_DEGREES, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(TSE_JOBS_PATH, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* path */])(TSE_JOBS_PATH, state)))({});
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex_persist__["a" /* default */]({
	key: 'praktiko:store',
	storage: window.localStorage,
	reducer: storeReducer
}));

/***/ }),
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__evaluation_actions__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__evaluation_mutations__ = __webpack_require__(970);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
	actions: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["K" /* mergeAll */])([__WEBPACK_IMPORTED_MODULE_2__evaluation_actions__["a" /* default */]]),
	mutations: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["K" /* mergeAll */])([__WEBPACK_IMPORTED_MODULE_3__evaluation_mutations__["a" /* default */]])
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tse_utils__ = __webpack_require__(532);







var THREE_SIXTY_CODE = 'E360';

/* harmony default export */ __webpack_exports__["a"] = ({
	resetState: function resetState(_ref) {
		var commit = _ref.commit;

		commit('RESET_TSE_STATE');
	},
	getJobsAreas: function getJobsAreas(_ref2) {
		var _this = this;

		var commit = _ref2.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _ref3, _ref3$data, data, parsedGroups;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('groups');

						case 2:
							_ref3 = _context.sent;
							_ref3$data = _ref3.data;
							data = _ref3$data === undefined ? [] : _ref3$data;
							parsedGroups = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["J" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["Q" /* pick */])(['id', 'code', 'name']), data);

							commit('UPDATE_JOBS_AREAS', parsedGroups);

						case 7:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	},
	getFilteredJobs: function getFilteredJobs(_ref4, selectedIds) {
		var _this2 = this;

		var commit = _ref4.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
			var params, _ref5, _ref5$data, data;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							if (!Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["E" /* isEmpty */])(selectedIds)) {
								_context2.next = 3;
								break;
							}

							commit('UPDATE_JOBS', []);
							return _context2.abrupt('return');

						case 3:
							params = selectedIds.join(',');
							_context2.next = 6;
							return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$httpPraktiko.get('groups/jobs?areaIds=' + params);

						case 6:
							_ref5 = _context2.sent;
							_ref5$data = _ref5.data;
							data = _ref5$data === undefined ? [] : _ref5$data;

							commit('UPDATE_JOBS', Object(__WEBPACK_IMPORTED_MODULE_5__utils_tse_utils__["a" /* tseParseJobs */])(data));

						case 10:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2);
		}))();
	},
	getToolConfiguration: function getToolConfiguration(_ref6) {
		var _this3 = this;

		var commit = _ref6.commit,
		    state = _ref6.state;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
			var _ref7, _ref7$data, data, stepsConfiguration;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$http.get('tools/' + THREE_SIXTY_CODE);

						case 2:
							_ref7 = _context3.sent;
							_ref7$data = _ref7.data;
							data = _ref7$data === undefined ? [] : _ref7$data;
							stepsConfiguration = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["P" /* pathOr */])({}, ['config', 'newEvaluation'], data);

							commit('UPDATE_FLOW_CONFIGURATION', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.moduleConfiguration, stepsConfiguration));

						case 7:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, _this3);
		}))();
	},
	createSurvey: function createSurvey(_ref8, _ref9) {
		var _this4 = this;

		var state = _ref8.state;
		var surveyName = _ref9.surveyName,
		    answerId = _ref9.answerId;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
			var selectedJobs, surveyPayload;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							selectedJobs = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["P" /* pathOr */])([], ['evaluationFlow', 'selectedJobs'], state);
							surveyPayload = Object(__WEBPACK_IMPORTED_MODULE_5__utils_tse_utils__["c" /* tseToSurvey */])(selectedJobs, surveyName, answerId);
							_context4.next = 4;
							return __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$http.post('polls', surveyPayload);

						case 4:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, _this4);
		}))();
	},
	updateSelectedJob: function updateSelectedJob(_ref10, job) {
		var commit = _ref10.commit,
		    state = _ref10.state;
		var selectedJobs = state.evaluationFlow.selectedJobs;

		var index = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["u" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["W" /* propEq */])('id', job.id), selectedJobs);
		var updatedList = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["_8" /* update */])(index, job, selectedJobs);
		commit('UPDATE_SELECTED_JOBS', updatedList);
	},
	updateSelectedAreasIds: function updateSelectedAreasIds(_ref11, ids) {
		var commit = _ref11.commit;

		commit('UPDATE_SELECTED_AREAS_IDS', ids);
	},
	toggleJobSelection: function toggleJobSelection(_ref12, job) {
		var commit = _ref12.commit,
		    state = _ref12.state;
		var selectedJobs = state.evaluationFlow.selectedJobs;

		var selectedJob = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["t" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["W" /* propEq */])('id', job.id), selectedJobs);
		var updateJobs = [];
		if (selectedJob) {
			updateJobs = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["_0" /* reject */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["W" /* propEq */])('id', job.id), selectedJobs);
		} else {
			updateJobs = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["h" /* append */])(job, selectedJobs);
		}
		commit('UPDATE_SELECTED_JOBS', updateJobs);
	},
	nextStep: function nextStep(_ref13) {
		var commit = _ref13.commit,
		    state = _ref13.state;

		commit('UPDATE_CURRENT_STEP', state.evaluationFlow.currentStep + 1);
	},
	prevStep: function prevStep(_ref14) {
		var commit = _ref14.commit,
		    state = _ref14.state;

		commit('UPDATE_CURRENT_STEP', state.evaluationFlow.currentStep - 1);
	}
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TSE_TOOL_CODE; });
var TSE_TOOL_CODE = 'E360';

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(459);



/* harmony default export */ __webpack_exports__["a"] = ({
	// eslint-disable-next-line no-unused-vars
	RESET_TSE_STATE: function RESET_TSE_STATE(state) {
		// eslint-disable-next-line no-param-reassign
		var initialState = Object(__WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */])();
		// eslint-disable-next-line no-param-reassign
		state.evaluationFlow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialState.evaluationFlow);
	},
	UPDATE_JOBS: function UPDATE_JOBS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.jobs = payload;
	},
	UPDATE_JOBS_AREAS: function UPDATE_JOBS_AREAS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.jobAreas = payload;
	},
	UPDATE_SELECTED_AREAS_IDS: function UPDATE_SELECTED_AREAS_IDS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.evaluationFlow.selectedAreaIds = payload;
	},
	UPDATE_SELECTED_JOBS: function UPDATE_SELECTED_JOBS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.evaluationFlow.selectedJobs = payload;
	},
	UPDATE_FLOW_CONFIGURATION: function UPDATE_FLOW_CONFIGURATION(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.moduleConfiguration = payload;
	},
	UPDATE_CURRENT_STEP: function UPDATE_CURRENT_STEP(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.evaluationFlow.currentStep = payload;
	}
});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_helper__ = __webpack_require__(39);




/* eslint-disable no-param-reassign */

var recruitmentModule = {
	actions: {
		loadRecruitmentConfig: function loadRecruitmentConfig(_ref) {
			var _this = this;

			var commit = _ref.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var RECRUITMENT_TOOL_CODE, _ref2, data;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								RECRUITMENT_TOOL_CODE = 'RCM';
								_context.next = 3;
								return __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$http.get('/tools/' + RECRUITMENT_TOOL_CODE);

							case 3:
								_ref2 = _context.sent;
								data = _ref2.data;

								commit('UPDATE_MAIN_DATA', data);

							case 6:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		loadJobs: function loadJobs(_ref3, items) {
			var _this2 = this;

			var commit = _ref3.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var params, _ref4, response;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								params = {
									sortField: 'name',
									sortDirection: 'ASC',
									areaIds: items.selectedId,
									search: items.searchJob
								};
								_context2.prev = 1;
								_context2.next = 4;
								return __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$httpPraktiko.get('groups/jobs', { params: params });

							case 4:
								_ref4 = _context2.sent;
								response = _ref4.data;

								commit('UPDATE_JOBS', response);
								_context2.next = 12;
								break;

							case 9:
								_context2.prev = 9;
								_context2.t0 = _context2['catch'](1);

								_this2.showGenericError();

							case 12:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[1, 9]]);
			}))();
		},
		loadGroups: function loadGroups(_ref5) {
			var _this3 = this;

			var commit = _ref5.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var params, _ref6, response;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								params = {
									sortField: 'name',
									sortDirection: 'ASC'
								};
								_context3.next = 3;
								return __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$httpPraktiko.get('groups', { params: params });

							case 3:
								_ref6 = _context3.sent;
								response = _ref6.data;

								commit('LOAD_GROUPS_DATA', response);

							case 6:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		toggleJobSelection: function toggleJobSelection(_ref7, job) {
			var commit = _ref7.commit;

			__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData('jobSelected', job);
			commit('UPDATE_SELECTED_JOBS', job);
		},
		clearSelectedJobs: function clearSelectedJobs(_ref8) {
			var commit = _ref8.commit;

			__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData('jobSelected', null);
			commit('CLEAR_SELECTED_JOBS');
		},
		saveIdConfigProcess: function saveIdConfigProcess(_ref9, id) {
			var commit = _ref9.commit;

			__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData('idConfigProcess', id);
			commit('SAVE_ID_CONGIF_PROCESS', id);
		},
		loadConfigProcess: function loadConfigProcess(_ref10, code) {
			var _this4 = this;

			var commit = _ref10.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var idConfigProcess, _ref11, response;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								idConfigProcess = __WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].getLocalData('idConfigProcess');
								_context4.prev = 1;

								if (!idConfigProcess) {
									_context4.next = 11;
									break;
								}

								_context4.next = 5;
								return __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$httpPraktiko.get('/recruitment/detail/' + code + '/' + idConfigProcess);

							case 5:
								_ref11 = _context4.sent;
								response = _ref11.data;

								__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData('dataConfigProcess', response);
								commit('UPDATE_DATA_CONFIG', response);
								_context4.next = 13;
								break;

							case 11:
								__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData('dataConfigProcess', []);
								commit('UPDATE_DATA_CONFIG', []);

							case 13:
								_context4.next = 18;
								break;

							case 15:
								_context4.prev = 15;
								_context4.t0 = _context4['catch'](1);

								console.error(_context4.t0);

							case 18:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4, [[1, 15]]);
			}))();
		},
		dataProcessSelected: function dataProcessSelected(_ref12, data) {
			var commit = _ref12.commit;

			__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData('dataProcessSelected', data);
			commit('DATA_PROCESS_SELECTED', data);
		},
		flagDisabledButton: function flagDisabledButton(_ref13, value) {
			var commit = _ref13.commit;

			commit('FLAG_EDIT_PROCESS', value);
		},
		loadCivilStatus: function loadCivilStatus(_ref14) {
			var _this5 = this;

			var commit = _ref14.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var _ref15, data;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$httpPraktiko.get('/general-data/ESCV');

							case 2:
								_ref15 = _context5.sent;
								data = _ref15.data;

								commit('UPDATE_LEVEL_SELECTION_CIVIL_STATUS', {
									name: 'Estado Civil',
									data: data
								});

							case 5:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		loadTypeApplicants: function loadTypeApplicants(_ref16) {
			var _this6 = this;

			var commit = _ref16.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var _ref17, data;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.next = 2;
								return __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$httpPraktiko.get('/general-data/TDPS');

							case 2:
								_ref17 = _context6.sent;
								data = _ref17.data;

								commit('UPDATE_LEVEL_SELECTION_TYPE_APPLICANT', {
									name: 'Tipo de Postulante',
									data: data
								});

							case 5:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		loadTypeProcess: function loadTypeProcess(_ref18) {
			var _this7 = this;

			var commit = _ref18.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
				var _ref19, data;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_context7.next = 2;
								return __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$httpPraktiko.get('/general-data/ESTPROCS');

							case 2:
								_ref19 = _context7.sent;
								data = _ref19.data;

								commit('UPDATE_LEVEL_SELECTION_TYPE_PROCESS', {
									name: 'Tipos de Procesos',
									data: data
								});

							case 5:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},
		dataInterview: function dataInterview(_ref20, value) {
			var commit = _ref20.commit;

			__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData('dataInterview', value);
			commit('SAVE_DATA_INTERVIEW', value);
		},
		applicantSelected: function applicantSelected(_ref21, value) {
			var commit = _ref21.commit;

			__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData('applicantSelected', value);
			commit('SAVE_APPLICANT_SELECTED', value);
		}
	},
	state: {
		mainData: {},
		jobs: [],
		groups: [],
		idConfigProcess: null,
		recruitmentFlow: {
			selectedJobs: {},
			flagEditProcess: false,
			dataProcessSelected: [],
			dataInterview: [],
			applicantSelected: {}
		},
		dataConfigProcess: [],
		dataSelection: {
			civilStatus: [],
			typeApplicant: [],
			typeProcess: []
		}
	},
	mutations: {
		UPDATE_MAIN_DATA: function UPDATE_MAIN_DATA(state, data) {
			state.mainData = data;
		},
		UPDATE_JOBS: function UPDATE_JOBS(state, payload) {
			state.jobs = payload;
		},
		LOAD_GROUPS_DATA: function LOAD_GROUPS_DATA(state, payload) {
			state.groups = payload;
		},
		UPDATE_SELECTED_JOBS: function UPDATE_SELECTED_JOBS(state, payload) {
			state.recruitmentFlow.selectedJobs = payload;
		},
		CLEAR_SELECTED_JOBS: function CLEAR_SELECTED_JOBS(state) {
			state.recruitmentFlow.selectedJobs = [];
		},
		SAVE_ID_CONGIF_PROCESS: function SAVE_ID_CONGIF_PROCESS(state, payload) {
			state.idConfigProcess = payload;
		},
		UPDATE_DATA_CONFIG: function UPDATE_DATA_CONFIG(state, payload) {
			state.dataConfigProcess = payload;
		},
		FLAG_EDIT_PROCESS: function FLAG_EDIT_PROCESS(state, payload) {
			state.recruitmentFlow.flagEditProcess = payload;
		},
		DATA_PROCESS_SELECTED: function DATA_PROCESS_SELECTED(state, payload) {
			state.recruitmentFlow.dataProcessSelected = payload;
		},
		UPDATE_LEVEL_SELECTION_CIVIL_STATUS: function UPDATE_LEVEL_SELECTION_CIVIL_STATUS(state, payload) {
			state.dataSelection.civilStatus = payload;
		},
		UPDATE_LEVEL_SELECTION_TYPE_APPLICANT: function UPDATE_LEVEL_SELECTION_TYPE_APPLICANT(state, payload) {
			state.dataSelection.typeApplicant = payload;
		},
		UPDATE_LEVEL_SELECTION_TYPE_PROCESS: function UPDATE_LEVEL_SELECTION_TYPE_PROCESS(state, payload) {
			state.dataSelection.typeProcess = payload;
		},
		SAVE_DATA_INTERVIEW: function SAVE_DATA_INTERVIEW(state, payload) {
			state.recruitmentFlow.dataInterview = payload;
		},
		SAVE_APPLICANT_SELECTED: function SAVE_APPLICANT_SELECTED(state, payload) {
			state.recruitmentFlow.applicantSelected = payload;
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (recruitmentModule);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0669481a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(979);
function injectStyle (ssrContext) {
  __webpack_require__(973)
  __webpack_require__(974)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0669481a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_main_loader_vue__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea837126_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_main_loader_vue__ = __webpack_require__(977);
function injectStyle (ssrContext) {
  __webpack_require__(976)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea837126"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_main_loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea837126_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_main_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('div',{staticClass:"main-loader"},[_c('div',{staticClass:"main-loader-content"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return injectCssVariables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectTextColors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(17);


var getColors = function getColors() {
	return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["_7" /* tryCatch */])(function (colorString) {
		return JSON.parse(colorString);
	}, Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["f" /* always */])({}))('{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success": "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent": "#005CAF","error": "#f42b17","warning": "#FFB74C"}');
};

var injectCssVariables = function injectCssVariables() {
	var colors = getColors();
	var root = document.documentElement;
	Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["x" /* forEachObjIndexed */])(function (color, key) {
		root.style.setProperty('--app-color-' + key, color);
	}, colors);
};

var injectTextColors = function injectTextColors() {
	var colors = getColors();
	var style = document.createElement('style');
	var cssTextClasses = '';
	style.type = 'text/css';
	Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["x" /* forEachObjIndexed */])(function (color, key) {
		cssTextClasses += ' .text-' + key + ' { color: ' + color + ' !important; }';
	}, colors);
	style.innerHTML = cssTextClasses;
	document.getElementsByTagName('head')[0].appendChild(style);
};

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.indeterminate)?_c('v-progress-linear',{staticClass:"progress-bar",attrs:{"color":"success","indeterminate":_vm.indeterminate}}):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('p-main-loader'),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":5000,"color":_vm.snackbar.color,"top":"","right":""},model:{value:(_vm.snackbar.isVisible),callback:function ($$v) {_vm.$set(_vm.snackbar, "isVisible", $$v)},expression:"snackbar.isVisible"}},[_vm._v("\n\t\t"+_vm._s(_vm.snackbar.text)+"\n\t\t"),(_vm.snackbar.html)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.snackbar.html)}}):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"flat":""},nativeOn:{"click":function($event){_vm.snackbar.isVisible = false}}},[_vm._v("\n\t\t\tCerrar\n\t\t")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VProgressCircular__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VProgressCircular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VProgressCircular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTabs__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTextarea__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTextarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTextarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VTreeview__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VTreeview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VTreeview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VAvatar__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VAvatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VAvatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VInput__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vuetify_es5_components_VPagination__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vuetify_es5_components_VPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_vuetify_es5_components_VPagination__);












































/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify___default.a, {
		components: {
			VAvatar: __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VAvatar___default.a,
			VAlert: __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert___default.a,
			VApp: __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp___default.a,
			VAutocomplete: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete___default.a,
			VBtn: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default.a,
			VBtnToggle: __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default.a,
			VCheckbox: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default.a,
			VChip: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default.a,
			VCard: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default.a,
			VDataIterator: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator___default.a,
			VDatePicker: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker___default.a,
			VDialog: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog___default.a,
			VDivider: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider___default.a,
			VForm: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm___default.a,
			VGrid: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid___default.a,
			VIcon: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon___default.a,
			VInput: __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VInput___default.a,
			VList: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList___default.a,
			VMenu: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default.a,
			VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer___default.a,
			VRadioGroup: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup___default.a,
			VSelect: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect___default.a,
			VSlider: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider___default.a,
			VSnackbar: __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar___default.a,
			VSubheader: __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default.a,
			VTextField: __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField___default.a,
			VTimePicker: __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker___default.a,
			VToolbar: __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar___default.a,
			VTooltip: __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip___default.a,
			transitions: __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions___default.a,
			VExpansionPanel: __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel___default.a,
			VDataTable: __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable___default.a,
			VProgressLinear: __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear___default.a,
			VProgressCircular: __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VProgressCircular___default.a,
			VTabs: __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTabs___default.a,
			VTextarea: __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTextarea___default.a,
			VStepper: __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper___default.a,
			VSwitch: __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch___default.a,
			VTreeview: __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VTreeview___default.a,
			VPagination: __WEBPACK_IMPORTED_MODULE_41_vuetify_es5_components_VPagination___default.a
		},
		theme: JSON.parse('{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success": "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent": "#005CAF","error": "#f42b17","warning": "#FFB74C"}')
	});
});

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */,
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */,
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */,
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */,
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */,
/* 1024 */,
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */,
/* 1027 */,
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */,
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */,
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */,
/* 1040 */,
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */,
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */,
/* 1050 */,
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */,
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */,
/* 1065 */,
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */,
/* 1072 */,
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */,
/* 1080 */,
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */,
/* 1084 */,
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */,
/* 1092 */,
/* 1093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */,
/* 1104 */,
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */,
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */,
/* 1109 */,
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */,
/* 1112 */,
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */,
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */,
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */,
/* 1120 */,
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */,
/* 1128 */,
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */,
/* 1142 */,
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */,
/* 1164 */,
/* 1165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = httpRequestInterceptor;
/* harmony export (immutable) */ __webpack_exports__["c"] = httpResponseSuccessInterceptor;
/* harmony export (immutable) */ __webpack_exports__["b"] = httpResponseInterceptor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors__ = __webpack_require__(1171);




function httpRequestInterceptor(config) {
	var headers = config.headers;
	if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token) {
		headers.common.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token;
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', true);
	} else if (config.url === 'external-api/password/email' || config.url === 'external-api/password/reset' || config.url === 'recruitment/detail-no-auth' || config.url === 'external-api/upload-file-applicant' || config.url.startsWith('applicants-recruitment') || config.url.startsWith('temporary-token/detail') || config.url.startsWith('certificates-applicant')) {
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', true);
	} else {
		this.$router.push('login');
	}
	return config;
}

function httpResponseSuccessInterceptor(response) {
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', false);
	return response;
}

function httpResponseInterceptor(error) {
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', false);

	// Manejo mejorado de errores con mensajes específicos
	var loginRoute = { name: 'login' };
	var status = error.response && error.response.status;
	var parsedError = Object(__WEBPACK_IMPORTED_MODULE_2__errors__["b" /* parseError */])(error);

	var text = 'Ocurrió un error inesperado.';

	if (status === 401 && this.$route.name !== 'reset-password') {
		// Mantener lógica original de redirección para 401
		text = 'Su sesión expiró.';
		this.$router.push(loginRoute);
	} else if (status === 400) {
		// Usar nueva función de errores para mensajes específicos
		text = Object(__WEBPACK_IMPORTED_MODULE_2__errors__["a" /* default */])(error.response);
	} else if (status === 403) {
		text = 'No tiene suficientes permisos para realizar ésta acción.';
	} else if (status === 404) {
		text = 'El recurso solicitado no existe.';
	} else if (status === 422) {
		// Error de validación - mostrar mensaje específico
		text = Object(__WEBPACK_IMPORTED_MODULE_2__errors__["a" /* default */])(error.response);
	} else if (status === 500) {
		text = 'No se logró completar la acción. Por favor intente nuevamente.';
	} else if (status === 502 || status === 503 || status === 504) {
		text = 'El servidor no está disponible. Por favor intente más tarde.';
	} else if (!status) {
		// Error de red/conexión
		text = 'Error de conexión. Por favor verifique su conexión a internet.';
	} else {
		// Para otros códigos de estado, intentar usar mensaje del servidor
		text = parsedError.message || text;
	}

	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('showSnackBar', { text: text, color: 'error' });

	// Log en consola para debugging (opcional en desarrollo)
	if (false) {
		/* eslint-disable no-console */
		console.error('HTTP Error:', {
			status: status,
			message: text,
			details: parsedError.details,
			code: parsedError.code,
			error: error
		});
		/* eslint-enable no-console */
	}

	// Mantener error.response para compatibilidad con componentes que acceden error.data/error.status
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
}

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseError;
/* unused harmony export isValidationError */
/* unused harmony export isNetworkError */
/**
 * Manejo centralizado de errores HTTP
 * Proporciona mensajes de error específicos basados en códigos de error
 * y en la respuesta del servidor
 */

/* harmony default export */ __webpack_exports__["a"] = (function (response) {
	// Si no hay respuesta, retornar mensaje genérico
	if (!response) {
		return 'Error de conexión. Por favor verifique su conexión a internet.';
	}

	var data = response.data,
	    status = response.status;

	// Si el servidor envía un mensaje de error, usarlo

	if (data && data.message) {
		return data.message;
	}

	// Si hay un código de error específico, manejarlo
	if (data && data.code) {
		var errorCode = data.code;

		// Errores de usuario
		if (errorCode === 'USER_EXISTS') {
			return 'El usuario ya existe en el sistema.';
		}
		if (errorCode === 'USER_NOT_FOUND') {
			return 'Usuario no encontrado.';
		}
		if (errorCode === 'INVALID_CREDENTIALS') {
			return 'Credenciales inválidas.';
		}

		// Errores de validación
		if (errorCode === 'VALIDATION_ERROR') {
			return data.error || 'Error de validación. Verifique los datos ingresados.';
		}
		if (errorCode === 'REQUIRED_FIELDS') {
			return 'Faltan campos requeridos. Por favor complete todos los campos obligatorios.';
		}

		// Errores de negocio
		if (errorCode === 'PROCESS_NOT_EDITABLE') {
			return 'El proceso no puede ser editado en su estado actual.';
		}
		if (errorCode === 'PROCESS_ALREADY_PUBLISHED') {
			return 'El proceso ya ha sido publicado y no puede ser modificado.';
		}
		if (errorCode === 'INVALID_DATE_RANGE') {
			return 'El rango de fechas no es válido.';
		}

		// Errores de permisos
		if (errorCode === 'INSUFFICIENT_PERMISSIONS') {
			return 'No tiene permisos suficientes para realizar esta acción.';
		}
		if (errorCode === 'RESOURCE_LOCKED') {
			return 'El recurso está siendo utilizado por otro usuario.';
		}
	}

	// Si hay errores de validación específicos en la respuesta
	if (data && data.errors && Array.isArray(data.errors)) {
		var firstError = data.errors[0];
		if (firstError.message) {
			return firstError.message;
		}
		if (firstError.field && firstError.msg) {
			return 'Error en campo ' + firstError.field + ': ' + firstError.msg;
		}
	}

	// Mensajes según el código de estado HTTP
	switch (status) {
		case 400:
			return 'Solicitud inválida. Verifique los datos enviados.';
		case 401:
			return 'Su sesión ha expirado. Por favor inicie sesión nuevamente.';
		case 403:
			return 'No tiene permisos para realizar esta acción.';
		case 404:
			return 'El recurso solicitado no existe.';
		case 409:
			return 'Conflicto de datos. El recurso ya existe o está en conflicto.';
		case 422:
			return 'Error de validación. Verifique los datos ingresados.';
		case 429:
			return 'Ha excedido el límite de solicitudes. Por favor espere unos minutos.';
		case 500:
			return 'Error interno del servidor. Por favor intente nuevamente.';
		case 502:
			return 'El servidor no está disponible. Por favor intente más tarde.';
		case 503:
			return 'Servicio no disponible. Por favor intente más tarde.';
		case 504:
			return 'Tiempo de espera agotado. Por favor intente nuevamente.';
		default:
			return 'Ocurrió un error inesperado. Por contacte al soporte técnico.';
	}
});

/**
 * Función auxiliar para extraer mensajes de error específicos
 * Útil cuando se necesita mostrar errores detallados en componentes
 *
 * @param {object} error - Error de axios
 * @returns {object} { message: string, details: any, status: number }
 */
function parseError(error) {
	if (!error) {
		return {
			message: 'Error desconocido',
			details: null,
			status: null
		};
	}

	var response = error.response || {};
	var data = response.data || {};
	var status = response.status || null;

	return {
		message: data.message || data.error || 'Error al procesar la solicitud',
		details: data.details || data.errors || null,
		status: status,
		code: data.code || null
	};
}

/**
 * Función auxiliar para determinar si un error es de validación
 *
 * @param {object} error - Error de axios
 * @returns {boolean}
 */
function isValidationError(error) {
	var status = error.response && error.response.status;
	var code = error.response && error.response.data && error.response.data.code;
	return status === 422 || status === 400 || code === 'VALIDATION_ERROR';
}

/**
 * Función auxiliar para determinar si un error es de red/conexión
 *
 * @param {object} error - Error de axios
 * @returns {boolean}
 */
function isNetworkError(error) {
	return !error.response && !!error.message;
}

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_app_bus__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_configuration__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polls__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__diagnosis__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_job_evaluation_router__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_evaluation_360_router__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_job_profile_router__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__awards__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_three_sixty_evaluation_router__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_recruitment_router__ = __webpack_require__(1203);













// import professionaProfile from './profiles';

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]);
	var config = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
		mode: 'history',
		routes: [{
			path: '/',
			name: 'page-home',
			component: function component() {
				return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 1359));
			},
			redirect: 'working-environment',
			meta: {
				title: 'Clima Laboral'
			},
			children: [{
				name: 'working-environment',
				path: 'working-environment',
				component: function component() {
					return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 1360));
				},
				redirect: 'working-environment/surveys',
				meta: {
					title: 'Clima Laboral'
				},
				props: true,
				children: [{
					name: 'working-environment-surveys',
					path: 'surveys',
					component: function component() {
						return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1361));
					},
					meta: {
						title: 'Clima Laboral'
					},
					children: [{
						name: 'working-environment-surveys-new',
						path: 'new',
						component: function component() {
							return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1362));
						},
						meta: {
							title: 'Clima Laboral'
						}
					}]
				}]
			}, {
				name: 'organizational-diagnosis',
				path: 'organizational',
				component: function component() {
					return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 1363));
				},
				meta: {
					title: 'Diagnóstico Organizacional Praktiko'
				},
				props: true,
				children: [{
					name: 'surveys-organizational-diagnosis',
					path: 'surveys',
					component: function component() {
						return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1364));
					},
					meta: {
						title: 'Diagnóstico Organizacional Praktiko'
					}
				}, {
					name: 'new-organizational-diagnosis',
					path: 'new',
					component: function component() {
						return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1365));
					},
					meta: {
						title: 'Diagnóstico Organizacional Praktiko'
					}
				}]
			}, {
				name: 'culture-inventory',
				path: 'inventory',
				component: function component() {
					return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 1366));
				},
				meta: {
					title: 'Inventario de Cultura Organizacional'
				},
				props: true,
				children: [{
					name: 'surveys-inventory',
					path: 'surveys',
					component: function component() {
						return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1367));
					},
					meta: {
						title: 'Inventario de Cultura Organizacional'
					}
				}, {
					name: 'new-inventory',
					path: 'new-surveys',
					component: function component() {
						return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1368));
					},
					meta: {
						title: 'Inventario de Cultura Organizacional'
					}
				}]
			}, __WEBPACK_IMPORTED_MODULE_5__diagnosis__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__polls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router_configuration__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modules_evaluation_360_router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modules_job_evaluation_router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modules_job_profile_router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__user__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__awards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__modules_three_sixty_evaluation_router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__modules_recruitment_router__["a" /* default */]]
		}, {
			path: '/reset-password',
			name: 'reset-password',
			meta: {
				title: 'Recuperar Contraseña'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 1369));
			}
		}, {
			path: '/applications-form/:id/:code/:idCompany',
			name: 'applications-form',
			meta: {
				title: 'Postulaciones'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1370));
			}
		}, {
			name: 'create-profile-applicants',
			path: '/create-profile-applicants/:id/:temporaryToken',
			meta: {
				title: 'Crear Perfil'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1371));
			}
		}, __WEBPACK_IMPORTED_MODULE_3__login__["a" /* default */]]
	});
	config.beforeEach(function (to, from, next) {
		if (to.name !== 'login') {
			var token = window.localStorage.getItem("praktiko" + '::token');
			if (token || to.name === 'reset-password' || to.name === 'applications-form' || to.name === 'create-profile-applicants') {
				return next();
			}
			if (to.name.startsWith('applications-form')) {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});

	// Safety net: every navigation hides the loader so it can never get stuck.
	var LOADER_EVENT = 'app-event-loader-toggle-view';
	config.afterEach(function () {
		__WEBPACK_IMPORTED_MODULE_1__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: false });
	});

	return config;
});

/***/ }),
/* 1173 */,
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_configuration_tools__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_configuration_types__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_configuration_presents__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_configuration_answers__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_configuration_subsidiaries__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_configuration_generalData__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_configuration_companies__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_configuration_reports__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_configuration_entities__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_configuration_messaging_templates__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_configuration_external_integrations__ = __webpack_require__(1187);












var configurationRoute = {
	name: 'configuration',
	path: 'configuration',
	component: function component() {
		return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1287));
	},
	meta: {
		title: 'Configuración'
	},
	props: true,
	children: [{
		name: 'employees',
		path: 'employees',
		component: function component() {
			return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1288));
		},
		meta: {
			title: 'Configuración'
		},
		children: [{
			name: 'present-assignment',
			path: 'presents/:employeeId',
			components: {
				presentAssignment: function presentAssignment() {
					return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1289));
				}
			}
		}]
	}, {
		name: 'areas',
		path: 'areas',
		component: function component() {
			return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1290));
		},
		meta: {
			title: 'Configuración'
		}
	}, __WEBPACK_IMPORTED_MODULE_1__router_configuration_types__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router_configuration_presents__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__router_configuration_tools__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router_configuration_answers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router_configuration_subsidiaries__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router_configuration_generalData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router_configuration_companies__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__router_configuration_reports__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__router_configuration_entities__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router_configuration_messaging_templates__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__router_configuration_external_integrations__["a" /* default */]]
};
/* harmony default export */ __webpack_exports__["a"] = (configurationRoute);

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var toolsRoute = {
	name: 'tools',
	path: 'tools',
	redirect: 'tools/list',
	meta: {
		title: 'Herramientas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 1267));
	},
	children: [{
		name: 'tools-list',
		path: 'list',
		meta: {
			title: 'Listado de herramientas'
		},
		components: {
			toolList: function toolList() {
				return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1268));
			}
		},
		children: [{
			name: 'development-plan-by-competence',
			path: 'development-plan/:nodeId/:toolCode?/:toolId?',
			meta: {
				title: 'Plan de Desarrollo por Competencia'
			},
			components: {
				toolList: function toolList() {
					return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1269));
				}
			}
		}, {
			name: 'levels-tool',
			path: ':toolCode/:toolId/levels',
			meta: {
				title: 'Niveles'
			},
			components: {
				toolType: function toolType() {
					return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1270));
				}
			},
			children: [{
				name: 'new-type-form',
				path: 'new-type',
				components: {
					newType: function newType() {
						return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1271));
					}
				}
			}, {
				name: 'new-level-form',
				path: 'new-level/:number/:hierarchyFatherId?/:id?/:name?/:flagQuestion?',
				components: {
					newLevel: function newLevel() {
						return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1272));
					}
				},
				props: true
			}]
		}, {
			name: 'new-tool',
			path: 'new',
			meta: {
				title: 'Nueva Herramienta'
			},
			components: {
				newToolForm: function newToolForm() {
					return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 542));
				}
			},
			children: [{
				name: 'tool-type',
				path: 'type',
				meta: {
					title: 'Tipo de herramienta'
				},
				components: {
					toolType: function toolType() {
						return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 543));
					}
				}
			}, {
				name: 'tool-icons',
				path: 'icons/:type',
				meta: {
					title: 'Seleccionar ícono'
				},
				components: {
					toolIcons: function toolIcons() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 88));
					}
				}
			}, {
				name: 'answer-selection',
				path: 'answer-selection',
				meta: {
					title: 'Tipo de respuesta'
				},
				components: {
					answerSelection: function answerSelection() {
						return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 544));
					}
				}
			}]
		}, {
			name: 'edit-tool',
			path: 'edit/:code',
			meta: {
				title: 'Edición de Herramienta'
			},
			components: {
				newToolForm: function newToolForm() {
					return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 542));
				}
			},
			children: [{
				name: 'tool-type',
				path: 'type',
				meta: {
					title: 'Tipo de herramienta'
				},
				components: {
					toolType: function toolType() {
						return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 543));
					}
				}
			}, {
				name: 'tool-icons',
				path: 'icons/:type',
				meta: {
					title: 'Seleccionar ícono'
				},
				components: {
					toolIcons: function toolIcons() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 88));
					}
				}
			}, {
				name: 'answer-selection',
				path: 'answer-selection',
				meta: {
					title: 'Tipo de respuesta'
				},
				components: {
					answerSelection: function answerSelection() {
						return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 544));
					}
				}
			}]
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (toolsRoute);

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{attrs:{"width":_vm.width,"right":"","temporary":"","fixed":"","stateless":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('section',{staticClass:"header-modal",style:(("background-color: " + _vm.headerColor + ";border:1px solid " + (_vm.$appColors.info) + ";"))},[_c('header',{staticClass:"header-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","disabled":_vm.isLoading},on:{"click":_vm.closeDrawer}},[(_vm.imgSrc)?_c('img',{attrs:{"src":_vm.imgSrc,"alt":"Cerrar Filtro","width":"20"}}):_c('v-icon',[_vm._v("arrow_forward")])],1)],1)]),_vm._v(" "),_c('section',{staticClass:"content-modal"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var typeRoute = {
	name: 'level-types',
	path: 'level-types',
	component: function component() {
		return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1273));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (typeRoute);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var presentsRoute = {
	name: 'award',
	path: 'award',
	component: function component() {
		return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1274));
	},
	meta: {
		title: 'Lista de regalos'
	},
	children: [{
		name: 'new-present',
		path: 'new',
		meta: {
			title: 'Nuevo Regalo'
		},
		components: {
			newPresentForm: function newPresentForm() {
				return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1275));
			}
		},
		children: [{
			name: 'present-icons',
			path: 'icons/:type',
			meta: {
				title: 'Selecciona ícono'
			},
			components: {
				selectingIcon: function selectingIcon() {
					return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 88));
				}
			}
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (presentsRoute);

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var answerRoute = {
	name: 'answers',
	path: 'answers',
	meta: {
		title: 'Respuestas'
	},
	redirect: 'answers/list',
	component: function component() {
		return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 1276));
	},
	children: [{
		name: 'list',
		path: 'list',
		meta: {
			title: 'Listado de respuestas'
		},
		components: {
			answerList: function answerList() {
				return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1277));
			}
		},
		children: [{
			name: 'new-answer',
			path: 'new',
			meta: {
				title: 'Nueva respuesta'
			},
			components: {
				answerNew: function answerNew() {
					return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 545));
				}
			},
			children: [{
				name: 'answer-icon',
				path: 'answer-icon/:index/:type',
				components: {
					modalAnswerIcon: function modalAnswerIcon() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 88));
					}
				}
			}]
		}, {
			name: 'edit-answer',
			path: 'edit/:id',
			meta: {
				title: 'Edición de respuesta'
			},
			components: {
				answerEdit: function answerEdit() {
					return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 545));
				}
			},
			children: [{
				name: 'answer-icon',
				path: 'answer-icon/:index/:type',
				components: {
					modalAnswerIcon: function modalAnswerIcon() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 88));
					}
				}
			}]
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (answerRoute);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var subsidiariesRoute = {
	name: 'subsidiaries',
	path: 'subsidiaries',
	// redirect: 'subsidiaries/list',
	meta: {
		title: 'Agencias'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1278));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (subsidiariesRoute);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var generalDataRoute = {
	name: 'general-data',
	path: 'general-data',
	meta: {
		title: 'Datos Generales'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1279));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (generalDataRoute);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var companiesRoute = {
	name: 'companies',
	path: 'companies',
	meta: {
		title: 'Compañías'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1280));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (companiesRoute);

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var reportsRoute = {
	name: 'report-template',
	path: 'report-template',
	meta: {
		title: 'Reportes'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1281));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (reportsRoute);

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var entitiesRoute = {
	name: 'entities',
	path: 'entities',
	meta: {
		title: 'Entidades'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1282));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (entitiesRoute);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var messagingTemplatesRoute = {
	name: 'messaging-templates',
	path: 'messaging-templates',
	meta: {
		title: 'Plantillas de Mensajería'
	},
	redirect: 'messaging-templates/list',
	component: function component() {
		return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 1283));
	},
	children: [{
		name: 'list',
		path: 'list',
		component: function component() {
			return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1284));
		}
	}, {
		name: 'new',
		path: 'new',
		component: function component() {
			return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1285));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (messagingTemplatesRoute);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var integrationsRoute = {
	name: 'external-integrations',
	path: 'external-integrations',
	meta: {
		title: 'Integraciones Externas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1286));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (integrationsRoute);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/login/:token?',
	name: 'login',
	meta: {
		title: 'Iniciar Sesión'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 1291));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_polls_router_index__ = __webpack_require__(1190);


var route = {
	name: 'survey',
	path: 'survey',
	meta: {
		title: 'Estudios'
	},
	redirect: 'survey/list',
	component: function component() {
		return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 1293));
	},
	children: [{
		name: 'survey-list',
		path: 'list',
		component: function component() {
			return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1294));
		},
		meta: {
			title: 'Listado de Estudios'
		},
		props: true,
		children: [{
			name: 'page-polls',
			path: ':id',
			meta: {
				title: 'Resolver Estudio'
			},
			components: {
				pollResolve: function pollResolve() {
					return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 1295));
				}
			}
		}, __WEBPACK_IMPORTED_MODULE_0__modules_polls_router_index__["a" /* PollModuleChild */]]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PollModuleChild; });
var PollModuleChild = {
	name: 'page-poll-custom-job-evaluation',
	path: 'custom-job-evaluation/:id',
	meta: {
		title: 'Resolver encuesta'
	},
	components: {
		customPoll: function customPoll() {
			return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1292));
		}
	}
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'diagnosis',
	path: 'diagnosis',
	component: function component() {
		return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 1296));
	},
	meta: {
		title: 'Diagnóstico'
	},
	props: true,
	children: [{
		name: 'diagnoses',
		path: 'diagnoses',
		component: function component() {
			return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1297));
		},
		meta: {
			title: 'Diagnóstico'
		},
		props: true,
		children: [{
			name: 'detail-diagnoses',
			path: ':toolId?/detail/:id',
			component: function component() {
				return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1298));
			},
			meta: {
				title: 'Diagnóstico'
			},
			props: true,
			children: [{
				name: 'detail-summary-inventory',
				path: ':toolId?/inventory/:idsummary',
				component: function component() {
					return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1299));
				},
				meta: {
					title: 'Diagnóstico'
				},
				props: true
			}, {
				name: 'detail-diagnosis-weather',
				path: ':toolId?/weather/:idsummary',
				component: function component() {
					return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1300));
				},
				meta: {
					title: 'Diagnóstico clima laboral'
				},
				props: true
			}, {
				name: 'detail-summary-diagnoses',
				path: ':toolId?/diagnoses/:detailId',
				component: function component() {
					return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1301));
				},
				meta: {
					title: 'Diagnóstico'
				},
				props: true
			}, {
				name: 'detail-summary-graphic-inventory',
				path: ':toolId?/graphic-inventory/:idsummary/:areaId?/:subsidiaryId?',
				component: function component() {
					return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1302));
				},
				meta: {
					title: 'Diagnóstico'
				},
				props: true
			}]
		}]
	}, {
		name: 'new-diagnosis',
		path: 'new-diagnosis/:toolCode?/:pollId?',
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1303));
		},
		meta: {
			title: 'Diagnóstico'
		}
	}]
};
/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'job-evaluation',
	path: 'job-evaluation',
	component: function component() {
		return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 1304));
	},
	meta: {
		title: 'Valoración de Puestos'
	},
	props: true,
	redirect: '/job-evaluation/onboarding',
	children: [{
		name: 'job-evaluation-onboarding',
		path: 'onboarding',
		component: function component() {
			return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 1305));
		}
	}, {
		name: 'job-evaluation-new',
		path: 'new',
		component: function component() {
			return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1306));
		},
		children: [{
			name: 'job-evaluation-supplies',
			path: 'supplies',
			component: function component() {
				return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1307));
			},
			meta: {
				title: 'Insumos'
			},
			children: [{
				name: 'job-supply-guideline-model',
				path: 'guideline-model',
				component: function component() {
					return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1308));
				},
				meta: {
					title: 'Modelo Directriz'
				}
			}, {
				name: 'job-supply-guideline-model-hierarchy',
				path: 'guideline-model-hierarchy',
				component: function component() {
					return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1309));
				},
				meta: {
					title: 'Modelo Directriz'
				}
			}, {
				name: 'job-supply-organization-chart',
				path: 'organization-chart',
				component: function component() {
					return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1310));
				},
				meta: {
					title: 'Organigrama'
				}
			}, {
				name: 'job-supply-valuation-model',
				path: 'valuation-model',
				component: function component() {
					return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 1311));
				},
				meta: {
					title: 'Modelo de Valoración'
				},
				redirect: '/job-evaluation/new/supplies/valuation-model/factors-choice',
				children: [{
					name: 'job-supply-valuation-model-factors-choice',
					path: 'factors-choice',
					component: function component() {
						return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1312));
					},
					meta: {
						title: 'Nuevo'
					}
				}, {
					name: 'job-supply-valuation-model-factors-weighting',
					path: 'factors-weighting',
					component: function component() {
						return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1313));
					},
					meta: {
						title: 'Nuevo'
					}
				}, {
					name: 'job-supply-valuation-model-degrees',
					path: 'degrees',
					component: function component() {
						return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1314));
					},
					meta: {
						title: 'Nuevo'
					}
				}, {
					name: 'job-supply-valuation-model-payroll-proposal',
					path: 'payroll-proposal',
					component: function component() {
						return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1315));
					},
					meta: {
						title: 'Nuevo'
					}
				}]
			}]
		}, {
			name: 'job-evaluation-processes',
			path: 'processes',
			component: function component() {
				return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1316));
			},
			meta: {
				title: 'Procesos'
			},
			children: [{
				name: 'job-evaluation-processes-commitees',
				path: 'organize-committee',
				component: function component() {
					return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1317));
				},
				meta: {
					title: 'Comités'
				},
				children: [{
					name: 'new-commitees',
					path: 'new/:name?/:id?',
					components: {
						newCommiteeForm: function newCommiteeForm() {
							return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 1318));
						}
					},
					meta: {
						title: 'Nuevo Comité'
					}
				}]
			}, {
				name: 'job-evaluation-process-disenar-escala',
				path: 'disenar-escala',
				component: function component() {
					return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1319));
				},
				meta: {
					title: 'Diseñar escala'
				}
			}, {
				name: 'job-supply-description-of-charges',
				path: 'job-valuation',
				component: function component() {
					return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1320));
				},
				meta: {
					title: 'Valoración de puestos'
				}
			}]
		}]
	}]
};
/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'evaluation-360',
	path: 'evaluation',
	component: function component() {
		return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 1321));
	},
	meta: {
		title: 'Evaluación'
	},
	redirect: 'evaluation-360/list-process',
	props: true,
	children: [
	// {
	// 	name: 'list-process',
	// 	path: 'list-process',
	// 	component: () => import('@/modules/evaluation-360/pages/page-list-process'),
	// 	meta: {
	// 		title: 'Lista de Proceso',
	// 	},
	// },
	{
		name: 'process',
		path: 'process',
		component: function component() {
			return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 1322));
		},
		meta: {
			title: 'Procesos'
		},
		redirect: 'process/list-process',
		children: [{
			name: 'list-process',
			path: 'list-process',
			component: function component() {
				return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1323));
			},
			meta: {
				title: 'Lista de Procesos'
			}
		}, {
			name: 'new-process',
			path: 'new-process',
			component: function component() {
				return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 546));
			},
			meta: {
				title: 'Nuevo Proceso'
			},
			redirect: '/process/new-process/configuration-process',
			children: [{
				name: 'process-configuration-process',
				path: 'configuration-process',
				component: function component() {
					return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 547));
				},
				meta: {
					title: 'Configurar Proceso'
				}
			}, {
				name: 'process-choose-employees',
				path: 'choose-employees',
				component: function component() {
					return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 548));
				},
				meta: {
					title: 'Escoger Empleado'
				}
			}, {
				name: 'process-choose-evaluators',
				path: 'choose-evaluators',
				component: function component() {
					return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 549));
				},
				meta: {
					title: 'Escoger Evaluadores'
				}
			}]
		}, {
			name: 'edit-process',
			path: 'edit-process/:id',
			component: function component() {
				return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 546));
			},
			meta: {
				title: 'Editar Proceso'
			},
			redirect: '/process/edit-process/configuration-process',
			children: [{
				name: 'edit-configuration-process',
				path: 'configuration-process',
				component: function component() {
					return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 547));
				},
				meta: {
					title: 'Editar Configuración'
				}
			}, {
				name: 'edit-choose-employees',
				path: 'choose-employees',
				component: function component() {
					return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 548));
				},
				meta: {
					title: 'Editar Empleados'
				}
			}, {
				name: 'edit-choose-evaluators',
				path: 'choose-evaluators',
				component: function component() {
					return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 549));
				},
				meta: {
					title: 'Editar Evaluadores'
				}
			}]
		}]
	}, {
		name: 'report',
		path: 'report',
		component: function component() {
			return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 1324));
		},
		meta: {
			title: 'Reportes'
		},
		props: true,
		redirect: 'report/report-evaluation',
		children: [{
			name: 'report-evaluation',
			path: 'report-evaluation/:id',
			component: function component() {
				return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1325));
			},
			meta: {
				title: 'Reporte de Evaluación'
			}
		}, {
			name: 'evaluation-summary',
			path: 'evaluation-summary',
			component: function component() {
				return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1326));
			},
			meta: {
				title: 'Evaluación'
			}
		}, {
			name: 'dashboard',
			path: 'dashboard/:processId/:pollId',
			component: function component() {
				return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1327));
			},
			meta: {
				title: 'Dashboard',
				layout: 'layout-dashboard'
			}
		}]
	}, {
		name: 'evaluation360-polls',
		path: 'evaluation360-polls',
		component: function component() {
			return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 1328));
		},
		meta: {
			title: 'Evaluaciones'
		},
		redirect: 'evaluation360-polls/list-polls-evaluation360',
		children: [{
			name: 'list-polls-evaluation360',
			path: 'list-polls-evaluation360',
			component: function component() {
				return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1329));
			},
			meta: {
				title: 'Evaluaciones'
			}
		}]
	}]
};
/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */,
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"media-print main-header-page align-center",class:{ 'toggle': _vm.isVisible },attrs:{"app":"","height":"40"}},[_c('div',{staticClass:"title-header"}),_vm._v(" "),_vm._l((_vm.breadCrumbs),function(route,indexRoute){return _c('div',{key:indexRoute,staticClass:"d-flex tw-mr-4",style:(("color:" + (_vm.$appColors.info)))},[(route.name === _vm.$route.name || indexRoute === 0)?_c('h1',{staticClass:"header-page-title"},[(route.meta.title)?_c('router-link',{staticClass:"header-page-title",style:(("color:" + (_vm.$appColors.primary) + ";text-decoration:none")),attrs:{"to":{ name: route.name }}},[_vm._v("\n\t\t\t"+_vm._s(route.meta.title)+"\n\t\t\t")]):_vm._e()],1):[(route.meta.title)?_c('router-link',{staticClass:"header-page-title",style:(("color:" + (_vm.$appColors.primary) + ";text-decoration:none")),attrs:{"to":{ name: route.name }}}):_vm._e()]],2)}),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"logout-btn",attrs:{"slot":"activator","icon":""},on:{"click":_vm.logout},slot:"activator"},[_c('img',{attrs:{"src":"/static/img/login/logout.svg","alt":"Log out"}})]),_vm._v(" "),_c('span',[_vm._v("Cerrar Sesión")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"sidebar-border media-print",style:(("background-color:" + (_vm.$appColors.white))),attrs:{"app":"","hide-overlay":"","fixed":"","stateless":"","height":"100vh","mini-variant":_vm.mini,"width":"200"},on:{"update:miniVariant":function($event){_vm.mini=$event}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{style:(("background-color:" + (_vm.$appColors.white))),attrs:{"flatd":""}},[_c('v-list',{staticClass:"bars-align"},[_c('v-list-tile',{staticClass:"logo-company"},[_c('img',{staticClass:"logo-open",attrs:{"src":_vm.company.logoOpen,"alt":"logo compañia"}}),_vm._v(" "),_c('img',{staticClass:"logo-close",attrs:{"src":_vm.company.logoClose,"alt":"logo compañia"}})]),_vm._v(" "),_c('div',{staticClass:"btn-menu"},[_c('button',{staticClass:"btn-toggle",on:{"click":function($event){_vm.$emit('open')}}},[_c('img',{attrs:{"src":"/static/img/toggle.svg","alt":"","width":"25"}})])]),_vm._v(" "),_c('v-list-tile-avatar',{staticClass:"avatar-image"},[_c('img',{staticClass:"icon-avatar",attrs:{"src":_vm.avatar},on:{"click":_vm.goToUser}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"avatar-name"},[_vm._v(_vm._s(_vm.fullName))]),_vm._v(" "),_c('v-list-tile-title',{staticClass:"avatar-position"},[_vm._v("Bienvenido")])],1)],1)],1),_vm._v(" "),_c('v-list',{staticClass:"py-0 sidebar-bg mgt-1",style:(("background-color:" + (_vm.$appColors.sidebar)))},_vm._l((_vm.items),function(item){return _c('v-list-group',{key:item.id,attrs:{"no-action":""}},[(item.resource.data.length === 0 )?_c('v-list-tile',{class:{ 'v-list__group__header--active' : item.name === _vm.$route.meta.title },attrs:{"slot":"activator","to":item.uri,"color":"secondary","active-class":"white--text"},slot:"activator"},[_c('div',{staticClass:"item-select",style:(("background-color:" + (_vm.$appColors.secondary) + " !important"))}),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"right":""}},[_c('img',{attrs:{"slot":"activator","src":item.pathIcon},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])],1)],1):_c('v-list-tile',{staticClass:"padding-items",class:{ 'v-list__group__header--active' : item.name === _vm.$route.meta.title },attrs:{"slot":"activator","color":"white"},slot:"activator"},[_c('div',{staticClass:"item-select",style:(("background-color:" + (_vm.$appColors.secondary) + " !important"))}),_vm._v(" "),_c('v-list-tile-action',{staticClass:"item-action-sidebar"},[_c('v-tooltip',{attrs:{"right":""}},[_c('img',{attrs:{"slot":"activator","src":item.pathIcon},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"ml-2 body-2 bold"},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)],1),_vm._v(" "),_vm._l((item.resource.data),function(subItem){return _c('v-list-tile',{key:subItem.uri,staticClass:"resources-items",class:{ 'item-sidebar-active' : _vm.$route.name === subItem.uri },attrs:{"to":{ name: subItem.uri },"color":"secondary","active-class":"white--text"}},[_c('v-list-tile-action',{staticClass:"item-action-sidebar"},[_c('v-tooltip',{attrs:{"right":""}},[_c('img',{attrs:{"slot":"activator","src":subItem.iconUrl},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(subItem.name))])])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(subItem.name)+"\t")])],1)],1)})],2)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'job-profile',
	path: 'profile',
	component: function component() {
		return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 1330));
	},
	meta: {
		title: 'Perfil de Puestos'
	},
	props: true,
	children: [{
		name: 'new-profile',
		path: 'new-profile',
		component: function component() {
			return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1331));
		},
		meta: {
			title: 'Perfil de Puestos'
		}
	}, {
		name: 'job-description',
		path: 'job-description/:id',
		component: function component() {
			return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 1332));
		},
		meta: {
			title: 'Descripción de Puestos'
		},
		redirect: 'job-description/mission',
		children: [{
			name: 'job-mission',
			path: 'mission',
			component: function component() {
				return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1333));
			},
			meta: {
				title: 'Misión del Puesto'
			}
		}, {
			name: 'job-activities',
			path: 'activities',
			component: function component() {
				return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1334));
			},
			meta: {
				title: 'Actividades de Puesto'
			}
		}, {
			name: 'job-required-knowledge',
			path: 'required-knowledge',
			component: function component() {
				return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1335));
			},
			meta: {
				title: 'Conocimientos Requeridos'
			}
		}, {
			name: 'job-formal-instructions',
			path: 'formal-instructions',
			component: function component() {
				return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1336));
			},
			meta: {
				title: 'Instrucción Formal'
			}
		}, {
			name: 'job-required-experience',
			path: 'required-experience',
			component: function component() {
				return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1337));
			},
			meta: {
				title: 'Experiencia Laboral Requerida'
			}
		}, {
			name: 'job-measurable-commitments',
			path: 'measurable-commitments',
			component: function component() {
				return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1338));
			},
			meta: {
				title: 'Compromisos Medibles'
			}
		}, {
			name: 'job-required-skills',
			path: 'required-skills',
			component: function component() {
				return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1339));
			},
			meta: {
				title: 'Destrezas Requeridas'
			}
		}, {
			name: 'job-required-competencies',
			path: 'required-competencies',
			component: function component() {
				return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1340));
			},
			meta: {
				title: 'Competencias Requeridas'
			}
		}, {
			name: 'job-results-indicators',
			path: 'results-indicators',
			component: function component() {
				return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1341));
			},
			meta: {
				title: 'Indicadores de Resultado'
			}
		}]
	}, {
		name: 'job-description-details',
		path: 'description-details/:id',
		component: function component() {
			return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 1342));
		},
		meta: {
			title: 'Detalle Descripción de Puestos'
		},
		redirect: function redirect(to) {
			return {
				name: 'job-view-details',
				params: to.params
			};
		},

		children: [{
			name: 'job-view-details',
			path: 'view-details',
			component: function component() {
				return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1343));
			},
			meta: {
				title: 'Detalle'
			}
		}]
	}]
};
/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'profile',
	path: 'profile',
	component: function component() {
		return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1344));
	},
	meta: {
		title: 'Perfil',
		logo: '/static/img/sidebar/users.svg'
	},
	children: [{
		name: 'profile-edit',
		path: 'edit',
		components: {
			profileEdit: function profileEdit() {
				return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1345));
			}
		},
		meta: {
			title: 'Editar Perfil',
			logo: '/static/img/sidebar/users.svg'
		}
	}, {
		name: 'password-edit',
		path: 'password',
		components: {
			passwordEdit: function passwordEdit() {
				return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 1346));
			}
		},
		meta: {
			title: 'Contraseña',
			logo: '/static/img/sidebar/users.svg'
		}
	}]
};
/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var awardsRoute = {
	name: '',
	path: 'awards',
	component: function component() {
		return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 1347));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (awardsRoute);

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-evaluation',
	path: 'new-evaluation',
	component: function component() {
		return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 1348));
	},
	meta: {
		title: 'Evaluación 360'
	},
	props: true,
	redirect: '/new-evaluation/new',
	children: [{
		name: 'new-three-sixty-evaluation',
		path: 'new',
		component: function component() {
			return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1349));
		}
	}, {
		path: '*',
		redirect: '/new-evaluation'
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'recruitment',
	path: 'recruitment',
	component: function component() {
		return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 1350));
	},
	meta: {
		title: 'Reclutamiento'
	},
	props: true,
	redirect: '/recruitment/new-recruitment',
	children: [{
		name: 'new-recruitment',
		path: 'new-recruitment',
		component: function component() {
			return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1351));
		}
	}, {
		name: 'config-process-recruitment',
		path: 'config-process-recruitment',
		component: function component() {
			return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1352));
		}
	}, {
		name: 'config-activities-recruitment',
		path: 'config-activities-recruitment',
		component: function component() {
			return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1353));
		}
	}, {
		name: 'template-interview',
		path: 'template-interview',
		component: function component() {
			return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1354));
		}
	}, {
		name: 'list-process-recruitment',
		path: 'list-process-recruitment',
		component: function component() {
			return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1355));
		}
	}, {
		name: 'list-applicants',
		path: 'list-applicants/:id?',
		component: function component() {
			return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1356));
		}
	}, {
		name: 'conduct-interview',
		path: 'conduct-interview',
		component: function component() {
			return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1357));
		}
	}, {
		name: 'process-applicant-selection',
		path: 'process-applicant-selection',
		component: function component() {
			return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1358));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);




var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url) {
		var _ref2, records, headers;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get(url, { params: this.params });

					case 2:
						_ref2 = _context.sent;
						records = _ref2.data;
						headers = _ref2.headers;

						this.table.lastPage = Number(headers['x-last-page']);
						this.table.rows = records.map(function (record) {
							var newRecord = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, record);
							newRecord.isSelected = false;
							return newRecord;
						});
						return _context.abrupt('return', { records: records, headers: headers });

					case 8:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData(_x) {
		return _ref.apply(this, arguments);
	};
}();

function data() {
	return {
		params: {
			customerId: null,
			page: 1,
			limit: 20,
			search: null
		},
		table: {
			lastPage: 1,
			rows: []
		}
	};
}

function goTo(name, options) {
	this.$router.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ name: name }, options));
}

function goBack() {
	this.$router.go(-1);
}

function getImageUrl(imageUrl) {
	return this.$imageUrl + '/' + imageUrl;
}

function onSearch(value, url) {
	this.params.search = value || null;
	this.params.page = 1;
	this.loadData(url);
}

function replaceString(word, selectionStart, newWord) {
	if (word) {
		return word.slice(0, selectionStart) + newWord + word.slice(selectionStart + 0);
	}
	return newWord;
}

function showNotification(text) {
	var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
	var html = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	this.$store.dispatch('showSnackBar', { text: text, color: color, html: html });
}

function showGenericError() {
	var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Ups, ocurrió algún problema';

	this.showNotification(text, 'error');
}

function showRow(columns, columnId) {
	var column = columns.find(function (h) {
		return h.id === columnId;
	});
	return column.visible;
}

function token() {
	return this.$store.getters.token;
}

function stopClick() {
	return false;
}

function isAdmin() {
	return Number(this.$store.getters.user.flagAdmin) === 1;
}

var mixin = {
	data: data,
	computed: {
		isAdmin: isAdmin,
		token: token
	},
	methods: {
		getImageUrl: getImageUrl,
		goTo: goTo,
		goBack: goBack,
		loadData: loadData,
		onSearch: onSearch,
		replaceString: replaceString,
		showGenericError: showGenericError,
		showNotification: showNotification,
		showRow: showRow,
		stopClick: stopClick
	}
};

/* harmony default export */ __webpack_exports__["a"] = (mixin);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);


function round(value) {
	var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	var newValue = Number(value);
	return newValue.toFixed(decimals);
}

function limitTo(value) {
	var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

	var cutText = value.substring(0, length);
	return cutText + '...';
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

	var newDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(date), formatter);
	return newDate;
}

function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var splitBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var newDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(year, month, day), formatter);
		return newDate;
	}
	return '';
}

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.filter('round', round);
	Vue.filter('limitTo', limitTo);
	Vue.filter('exactDate', exactDate);
	Vue.filter('formatDate', formatDate);
});

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_layout_login__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_layout_admin__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_layout_dashboard__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_general_filter__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_app_date_mask__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_table_app_table__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_table_disenar_escala_app_table_disenar_escala__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_table_disenar_escala_app_table_disenar_escala_header__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_table_disenar_escala_app_table_disenar_escala_data__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_table_disenar_escala_app_table_disenar_escala_orange__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_table_disenar_escala_app_table_disenar_escala_Odata__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_table_disenar_escala_app_table_disenar_escala_grafico__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shared_app_tooltip_button__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_shared_app_btn__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_shared_components_ui_p_notification_bell__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_shared_header_page__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_shared_form_sidebar__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_shared_utils_modal_sidebar_button__ = __webpack_require__(1262);





















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('layout-login', __WEBPACK_IMPORTED_MODULE_1__layouts_layout_login__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('layout-admin', __WEBPACK_IMPORTED_MODULE_2__layouts_layout_admin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('layout-dashboard', __WEBPACK_IMPORTED_MODULE_3__layouts_layout_dashboard__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-date-mask', __WEBPACK_IMPORTED_MODULE_5__components_shared_app_date_mask__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-table', __WEBPACK_IMPORTED_MODULE_6__components_shared_table_app_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-table-disenar-escala', __WEBPACK_IMPORTED_MODULE_7__components_shared_table_disenar_escala_app_table_disenar_escala__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-table-disenar-escala-header', __WEBPACK_IMPORTED_MODULE_8__components_shared_table_disenar_escala_app_table_disenar_escala_header__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-table-disenar-escala-data', __WEBPACK_IMPORTED_MODULE_9__components_shared_table_disenar_escala_app_table_disenar_escala_data__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-table-disenar-escala-orange', __WEBPACK_IMPORTED_MODULE_10__components_shared_table_disenar_escala_app_table_disenar_escala_orange__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-table-disenar-escala-Odata', __WEBPACK_IMPORTED_MODULE_11__components_shared_table_disenar_escala_app_table_disenar_escala_Odata__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-table-disenar-escala-grafico', __WEBPACK_IMPORTED_MODULE_12__components_shared_table_disenar_escala_app_table_disenar_escala_grafico__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-tooltip-button', __WEBPACK_IMPORTED_MODULE_13__components_shared_app_tooltip_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('app-btn', __WEBPACK_IMPORTED_MODULE_14__components_shared_app_btn__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('p-notification-bell', __WEBPACK_IMPORTED_MODULE_15__modules_shared_components_ui_p_notification_bell__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('header-page', __WEBPACK_IMPORTED_MODULE_16__components_shared_header_page__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('general-filter', __WEBPACK_IMPORTED_MODULE_4__components_shared_general_filter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('form-sidebar', __WEBPACK_IMPORTED_MODULE_17__components_shared_form_sidebar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('modal-sidebar-button', __WEBPACK_IMPORTED_MODULE_18__components_shared_utils_modal_sidebar_button__["a" /* default */]);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__ = __webpack_require__(503);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2496fe80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__ = __webpack_require__(1209);
function injectStyle (ssrContext) {
  __webpack_require__(1208)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2496fe80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2496fe80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_admin_vue__ = __webpack_require__(504);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f8924a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_admin_vue__ = __webpack_require__(1214);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f8924a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_subheader_vue__ = __webpack_require__(505);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7446b61c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_subheader_vue__ = __webpack_require__(1213);
function injectStyle (ssrContext) {
  __webpack_require__(1212)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7446b61c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_subheader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7446b61c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_subheader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"media-print",attrs:{"app":"","height":_vm.heightToolbar}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","pa-0":""}},[_c('app-header',{attrs:{"title":_vm.$route.meta.title,"logo-url":_vm.logoUrl,"is-visible":!_vm.isVisible}}),_vm._v(" "),_c('app-sidebar',{attrs:{"toggle":_vm.isVisible,"is-visible":!_vm.isVisible},on:{"active-route":_vm.getRoutes,"toggle-sidebar":_vm.changeToggle,"open":_vm.toggleSidebar}}),_vm._v(" "),_c('section',{staticClass:"section-margin"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_dashboard_vue__ = __webpack_require__(506);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c833830_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_dashboard_vue__ = __webpack_require__(1217);
function injectStyle (ssrContext) {
  __webpack_require__(1216)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c833830"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c833830_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticClass:"dashboard-layout",attrs:{"fluid":"","pa-0":""}},[_c('app-header',{attrs:{"title":_vm.$route.meta.title,"logo-url":_vm.logoUrl,"is-visible":false}}),_vm._v(" "),_c('section',{staticClass:"dashboard-content"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_filter_vue__ = __webpack_require__(507);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb9b50f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_general_filter_vue__ = __webpack_require__(1220);
function injectStyle (ssrContext) {
  __webpack_require__(1219)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bb9b50f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb9b50f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_general_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-filter media-print"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_date_mask_vue__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a12b434a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_date_mask_vue__ = __webpack_require__(1223);
function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a12b434a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_date_mask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a12b434a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_date_mask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('v-text-field',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"background-color":"white","hide-details":"","label":_vm.label,"placeholder":"__/__/___","value":_vm.picker},on:{"input":_vm.onInput,"change":function($event){_vm.onChange($event, 'change')}}},'v-text-field',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_vue__ = __webpack_require__(509);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a329b92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_vue__ = __webpack_require__(1229);
function injectStyle (ssrContext) {
  __webpack_require__(1225)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a329b92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a329b92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_column_item_vue__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e466bf1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_column_item_vue__ = __webpack_require__(1228);
function injectStyle (ssrContext) {
  __webpack_require__(1227)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e466bf1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_column_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e466bf1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_column_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"id":'column-' + _vm.column.id}},[(_vm.column.isEditable)?_c('span',[(_vm.column.showInput)?_c('span',[_c('input',{ref:("colheader" + (_vm.column.id)),staticClass:"column-input",attrs:{"type":"text","placeholder":_vm.column.name},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.toggleInput(_vm.column)},"input":function($event){_vm.$emit('column-input', { event: $event, column: _vm.column })}}})]):(_vm.column.tooltip)?_c('span',{staticClass:"column-edit-container"},[_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.column.name))]),_vm._v("\n\t\t\t\t"+_vm._s(_vm.column.tooltip)+"\n\t\t\t")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.toggleInput(_vm.column)}}},[_c('img',{attrs:{"height":"11","title":"Editar todas las filas a la vez","width":"11","src":(_vm.$imageUrl + "/edit-table.svg")}})])],1):_c('span',{staticClass:"column-edit-container"},[_vm._v("\n\t\t\t"+_vm._s(_vm.column.name)+"\n\t\t\t"),_c('button',{on:{"click":function($event){_vm.toggleInput(_vm.column)}}},[_c('img',{attrs:{"height":"11","title":"Editar todas las filas a la vez","width":"11","src":(_vm.$imageUrl + "/edit-table.svg")}})])])]):(_vm.column.tooltip)?_c('span',[_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.column.name))]),_vm._v("\n\t\t\t"+_vm._s(_vm.column.tooltip)+"\n\t\t")])],1):_c('span',{staticClass:"tw-flex tw-justify-items-start tw-items-center"},[_vm._v("\n\t\t"+_vm._s(_vm.column.name)+" "),(_vm.column.sortCheck)?_c('v-icon',{attrs:{"color":_vm.column.color},on:{"click":function($event){_vm.changeStateSort(_vm.column.fieldName)}}},[_vm._v("swap_vert")]):_vm._e()],1),_vm._v(" "),(_vm.column.isSortable)?_c('button',{staticClass:"sortable-button",on:{"click":function($event){_vm.onColumnSortable(_vm.column)}}},[(_vm.column.isSortable.down)?_c('i',{staticClass:"sortable-icon material-icons icon"},[_vm._v("\n\t\t\tarrow_drop_down\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.column.isSortable.up)?_c('i',{staticClass:"sortable-icon material-icons icon"},[_vm._v("\n\t\t\tarrow_drop_up\n\t\t")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-auto app-table"},[_c('table',{staticClass:"table-list",attrs:{"border":"0","cellpadding":"0","cellspacing":"0"}},[_c('thead',{style:(("color:" + (_vm.$appColors.primary)))},[(_vm.inputSearch || _vm.filterColumns || _vm.includeFilter || _vm.addButton)?_c('tr',[_c('th',{class:("text-xs-" + _vm.direction),attrs:{"colspan":_vm.totalVisibleColumns}},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-space-between":""}},[_c('v-flex',{attrs:{"text-xs-left":""}},[(_vm.flagRoute)?_c('div',{staticClass:"table-title"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t\t")]):_c('div',{staticClass:"table-title info--text"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-end":""}},[(_vm.inputSearch && _vm.flagRoute)?_c('div',{staticClass:"search-input",style:(("border:1px solid " + (_vm.$appColors.success)))},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],style:(("color:" + (_vm.$appColors.info) + ";")),attrs:{"type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchRows($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.searchRows($event)}],"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('img',{attrs:{"src":(_vm.$imageUrl + "/magnifying-glass.svg"),"alt":"Buscador","height":"20","width":"20"}})]):_c('div',{staticClass:"search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],style:(("color:" + (_vm.$appColors.info))),attrs:{"type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchRows($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.searchRows($event)}],"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('img',{attrs:{"src":(_vm.$imageUrl + "/magnifying-glass.svg"),"alt":"Buscador","height":"20","width":"20"}})]),_vm._v(" "),(_vm.downloadEmployees)?_c('div',{staticClass:"new-area center",attrs:{"xs2":"","text-xs-center":""}},[_vm._t("excelEmployees")],2):_vm._e(),_vm._v(" "),(_vm.iconEmployee)?_c('div',{staticClass:"new-area center",attrs:{"xs2":""}},[_c('app-tooltip-button',{attrs:{"text":"Nuevo Empleado","icon":"person_add","color":"primary"},on:{"click-icon":function($event){_vm.$emit('open-modal')}}})],1):_vm._e(),_vm._v(" "),(_vm.iconArea)?_c('div',{staticClass:"d-flex new-area",attrs:{"xs2":""}},[_c('app-tooltip-button',{attrs:{"text":"Nueva Área","img":(_vm.$imageUrl + "/new-area.svg"),"color":"primary"},on:{"click-icon":function($event){_vm.$emit('open-area')}}})],1):_vm._e(),_vm._v(" "),(_vm.iconEmployee)?_c('div',{staticClass:"new-area center",attrs:{"xs2":""}},[_c('app-tooltip-button',{attrs:{"img":(_vm.$imageUrl + "/assign-area.svg"),"text":"Asignar Área","color":"info","disabled":_vm.disabledAssign},on:{"click-icon":function($event){_vm.$emit('open-area')}}})],1):_vm._e(),_vm._v(" "),(_vm.iconSave)?_c('div',{staticClass:"new-area center",attrs:{"xs2":""}},[_c('app-tooltip-button',{attrs:{"img":"/static/img/save.svg","text":"Guardar","color":"info","disabled":_vm.disabledAssign},on:{"click-icon":function($event){_vm.$emit('save-process')}}})],1):_vm._e(),_vm._v(" "),(_vm.iconEmail)?_c('div',{staticClass:"new-area center",attrs:{"xs2":"","text-xs-center":""}},[_vm._t("sendEmails")],2):_vm._e(),_vm._v(" "),(_vm.iconExcel)?_c('div',{staticClass:"new-area center",attrs:{"xs2":"","text-xs-center":""}},[_vm._t("applicant")],2):_vm._e(),_vm._v(" "),(_vm.iconExcel)?_c('div',{staticClass:"new-area center",attrs:{"xs2":"","text-xs-center":""}},[_vm._t("excel")],2):_vm._e(),_vm._v(" "),(_vm.iconExcel)?_c('div',{staticClass:"new-area center",attrs:{"xs2":"","text-xs-center":""}},[_vm._t("loadExcel")],2):_vm._e(),_vm._v(" "),(_vm.downloadFormat)?_c('div',{staticClass:"new-area center",attrs:{"xs2":"","text-xs-center":""}},[_vm._t("formatFile")],2):_vm._e(),_vm._v(" "),(_vm.btnActions)?_c('div',{staticClass:"new-action  centerbtn",attrs:{"xs2":"","text-xs-center":""}},[_vm._t("action")],2):_vm._e()])],1),_vm._v(" "),(_vm.filterColumns || _vm.includeFilter || _vm.addButton)?_c('v-flex',[(_vm.filterColumns)?_c('v-menu',{attrs:{"offset-y":"","nudge-left":97,"max-height":"300","content-class":"columns-menu","fixed":"","close-on-content-click":false},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}},[_c('button',{style:(("background-color: " + (_vm.$appColors.secondary) + ";")),attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',[_vm._v("view_column")])],1),_vm._v(" "),_c('div',[_vm._l((_vm.columns),function(column){return [(!column.flagVisible)?_c('v-checkbox',{key:column.id,staticStyle:{"background":"white"},attrs:{"label":column.name,"hide-details":"","color":"success"},model:{value:(column.checked),callback:function ($$v) {_vm.$set(column, "checked", $$v)},expression:"column.checked"}}):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"apply text-xs-center"},[_c('button',{style:(("background-color: " + (_vm.$appColors.success) + ";")),on:{"click":_vm.toggleColumns}},[_vm._v("Aplicar")])])],2)]):_vm._e(),_vm._v(" "),(_vm.includeFilter)?_c('button',{staticClass:"vertical-align-middle",style:(("background-color: " + (_vm.$appColors.success) + ";")),attrs:{"type":"button"},on:{"click":_vm.tableOption}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("filter_list")])],1):_vm._e(),_vm._v(" "),(_vm.addButton)?_c('button',{style:(("background-color: " + (_vm.$appColors.success) + ";")),attrs:{"type":"button"},on:{"click":_vm.addOption}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1):_vm._e()],1)],1)]):_vm._e(),_vm._v(" "),_c('tr',[(_vm.selectable)?_c('th',{staticClass:"text-xs-center td-check"},[_c('v-checkbox',{staticClass:"ma-0 pa-0 table-checkbox",attrs:{"input-value":_vm.checkAll,"hide-details":"","color":"primary"},on:{"change":_vm.selectedAll}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column){return _c("table-column-item",{directives:[{name:"show",rawName:"v-show",value:(column.visible),expression:"column.visible"}],key:column.id,tag:"th",staticClass:"primary--text text-xs-left",class:column.flagVisible ? 'text-xs-center' : 'text-xs-left',style:(column.size ? { width: column.size + '%' } : {}),attrs:{"column":column},on:{"changeSort":function($event){_vm.$emit('changeSort', $event)},"changeColor":function($event){_vm.$emit('changeColor', $event)}}})})],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.rows),function(row,indexRow){return _c('tr',{key:row[_vm.keyValue],staticClass:"info--text",class:[
					row.isSelected && _vm.selectable ? 'row-checked' : null,
					row.isChecked ? 'row-checked' : null ],attrs:{"tabindex":"0"},on:{"click":function($event){_vm.rowIsSelected(row, indexRow)}}},[(_vm.selectable)?_c('td',{staticClass:"td-check"},[_c('v-checkbox',{staticClass:"ma-0 pa-0 table-checkbox",attrs:{"input-value":row.isSelected,"hide-details":"","color":"primary","disabled":_vm.dispatchDetail && (row.flagDispatch > 0)},nativeOn:{"click":function($event){$event.stopPropagation();_vm.rowIsSelected(row, indexRow)}}})],1):_vm._e(),_vm._v(" "),_vm._t("rows",null,{row:row,index:indexRow})],2)})],2),_vm._v(" "),_vm._t("footerSemi"),_vm._v(" "),_c('tfoot',{staticClass:"table-pagination"},[(_vm.mainList && _vm.rows.length > 0)?_c('tr',[(!!_vm.totalQuantity)?_c('td',{class:{ 'total-quantity-label': _vm.totalQuantityLabel },attrs:{"colspan":_vm.beforeColumn('quantity')}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.totalQuantityLabel)+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),(!!_vm.totalQuantity)?_c('td',{staticClass:"total-quantity",class:{ 'total-quantity-input': _vm.totalQuantityLabel }},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.totalQuantity)+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-right",attrs:{"colspan":_vm.totalsOnFooter}},[(_vm.captionQuantity)?[_c('span',{staticClass:"caption-quantity pr-2"},[_vm._v(_vm._s(_vm.itemsQuantity)+" "),(_vm.captionQuantity)?_c('span',[_vm._v("de")]):_vm._e(),_vm._v(" "+_vm._s(_vm.itemsTotalQuantity))])]:_vm._e(),_vm._v(" "),_c('input',{staticClass:"search-input unique-input",attrs:{"type":"text"},domProps:{"value":_vm.currentPage},on:{"input":function($event){_vm.selectPage($event.target.value)}}}),_vm._v(" "),_vm._l((_vm.pages),function(page,index){return _c('a',{key:index,class:{ 'active-page': page === _vm.currentPage },on:{"click":function($event){_vm.selectPage(page)}}},[_vm._v(_vm._s(page))])}),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('a',{on:{"click":_vm.selectLastPage}},[_vm._v(">>")])],2)]):_vm._e(),_vm._v(" "),(_vm.rows.length === 0)?_c('tr',[_c('td',{attrs:{"colspan":_vm.totalVisibleColumns}},[_c('p',{staticStyle:{"text-align":"center","margin":"5px 0 0 5px"}},[_vm._v("\n\t\t\t\t\t\tNo hay información que mostrar\n\t\t\t\t\t")])])]):_vm._e(),_vm._v(" "),_vm._t("footer")],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_vue__ = __webpack_require__(511);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ae78c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_vue__ = __webpack_require__(1232);
function injectStyle (ssrContext) {
  __webpack_require__(1231)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58ae78c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ae78c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tablaHeaderTitulo)?_c('div',{staticClass:"Rectangle-12-Copy-2",attrs:{"xs2":""}},[_c('span',{staticClass:"DISEAR-ESCALA-PUE"},[_vm._v("DISEÑAR ESCALA |  PUESTOS VALORADOS")]),_vm._v(" "),_c('div',{staticClass:"Rectangle-5 back",on:{"click":_vm.goBackToValuation}},[_c('span',{staticClass:"Back"},[_vm._v("Atrás")])]),_vm._v(" "),(_vm.tablaHeaderButton__1)?_c('div',{staticClass:"Rectangle-5",attrs:{"xs2":""},on:{"click":function($event){_vm.$emit('showChartClick')}}},[_c('span',{staticClass:"Ver-Grfico"},[_vm._v("Ver Gráfico")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"Rectangle-5 orange",on:{"click":_vm.Regresar}},[_c('span',{staticClass:"Finalizar"},[_vm._v("Finalizar")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_header_vue__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5d9be3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_header_vue__ = __webpack_require__(1235);
function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b5d9be3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5d9be3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"Rectangle-12-Copy"},[_c('span',{staticClass:"Puestos t-header-green"},[_vm._v("Puestos")]),_vm._v(" "),_c('span',{staticClass:"Cant t-header-green"},[_vm._v("Cant")]),_vm._v(" "),_c('span',{staticClass:"Promedio t-header-green"},[_vm._v("Promedio")]),_vm._v(" "),_c('span',{staticClass:"Redondear-Prom t-header-green"},[_vm._v("Redondear Prom.")]),_vm._v(" "),_c('span',{staticClass:"Sueldo-Actual t-header-green"},[_vm._v("Sueldo Actual")]),_vm._v(" "),_c('span',{staticClass:"Sueldo-Actual-Total t-header-green"},[_vm._v("Sueldo Actual Total")]),_vm._v(" "),_c('span',{staticClass:"Sueldo-Ideal t-header-green"},[_vm._v("Sueldo Ideal")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_data_vue__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bccf456_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_data_vue__ = __webpack_require__(1238);
function injectStyle (ssrContext) {
  __webpack_require__(1237)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bccf456"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bccf456_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tbody',[_vm._l((_vm.rows),function(row){return _c('div',{key:row.id,staticClass:"Rectangle-12-Copy-2"},[_vm._t("rows",null,{row:row})],2)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_orange_vue__ = __webpack_require__(514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c67550_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_orange_vue__ = __webpack_require__(1241);
function injectStyle (ssrContext) {
  __webpack_require__(1240)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15c67550"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_orange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c67550_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_orange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"Rectangle-12-Copy-3"},[_vm._l((_vm.rows),function(row){return _vm._t("Orows",null,{row:row})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_Odata_vue__ = __webpack_require__(515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f9afbf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_Odata_vue__ = __webpack_require__(1244);
function injectStyle (ssrContext) {
  __webpack_require__(1243)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03f9afbf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_Odata_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f9afbf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_Odata_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tbody',[[_c('div',{staticClass:"Rectangle-12-Copy-2"},[_vm._l((_vm.rows),function(row){return _vm._t("ODrows",null,{row:row})})],2)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_grafico_vue__ = __webpack_require__(516);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50245d0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_grafico_vue__ = __webpack_require__(1247);
function injectStyle (ssrContext) {
  __webpack_require__(1246)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50245d0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_disenar_escala_grafico_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50245d0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_disenar_escala_grafico_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scale-chart-container"},[_c('canvas',{attrs:{"id":"scale-chart"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(517);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23db67c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(1250);
function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23db67c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"custom-tooltip",attrs:{"top":"","max-width":"250px"}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","flat":"","icon":"","small":"","color":_vm.color,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon($event)}},slot:"activator"},[(_vm.icon)?[_c('v-icon',{style:(_vm.isListAll),attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v(_vm._s(_vm.icon))])]:[_c('img',{style:(("cursor: " + _vm.cursor + ";")),attrs:{"src":_vm.img,"alt":"text","height":_vm.size}})]],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_btn_vue__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20396687_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_btn_vue__ = __webpack_require__(1252);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_btn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20396687_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_btn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('button',{staticClass:"tw-px-1",attrs:{"slot":"activator","color":_vm.color,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon($event)}},slot:"activator"},[(_vm.icon)?[_c('v-icon',{style:(_vm.isListAll),attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v(_vm._s(_vm.icon))])]:[_c('img',{attrs:{"src":_vm.img,"alt":"text","height":_vm.size}})]],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_notification_bell_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fcbd004_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_notification_bell_vue__ = __webpack_require__(1255);
function injectStyle (ssrContext) {
  __webpack_require__(1254)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fcbd004"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_notification_bell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fcbd004_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_notification_bell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-bell-container"},[_c('v-tooltip',{staticClass:"custom-tooltip",attrs:{"top":"","max-width":"250px"}},[_c('div',{staticClass:"notification-bell-wrapper",attrs:{"slot":"activator"},on:{"click":_vm.handleClick},slot:"activator"},[_c('v-icon',{staticClass:"notification-icon",style:(("color: " + _vm.iconColor + " !important")),attrs:{"color":_vm.iconColor,"size":_vm.iconSize}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.icon)+"\n\t\t\t")]),_vm._v(" "),(_vm.count >= 0)?_c('div',{staticClass:"notification-badge",class:_vm.badgeColorClass},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.displayCount)+"\n\t\t\t")]):_vm._e()],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_page_vue__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf64f49e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_page_vue__ = __webpack_require__(1258);
function injectStyle (ssrContext) {
  __webpack_require__(1257)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf64f49e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf64f49e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header-page pl-5 media-print",style:(("border-bottom: 2px solid " + (_vm.$appColors.success) + ";"))},[_c('h1',{staticClass:"header-page-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.toShow)?_c('div',{staticClass:"header-page-actions"},[(_vm.exportToPdf)?_c('v-btn',{staticClass:"header-page-download-document primary mr-2",on:{"click":function($event){$event.preventDefault();return _vm.downloadDispatch($event)}}},[_c('img',{staticClass:"align-img",attrs:{"src":(_vm.$imageUrl + "/icon-export-pdf.svg"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.showExcel)?_c('v-btn',{staticClass:"header-page-download-document primary",on:{"click":_vm.downloadDocument}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/fill-1.svg"),"alt":"download","height":"17"}})]):_vm._e(),_vm._v(" "),(_vm.showClean)?_c('v-btn',{staticClass:"btn-action",attrs:{"dark":""},on:{"click":function($event){_vm.$emit('on-clean')}}},[_vm._v("\n\t\t\tLimpiar\n\t\t")]):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.quotation || _vm.sale)?_c('div',{staticClass:"header-page-actions translate"},[_c('v-btn',{staticClass:"header-page-download-document",attrs:{"flat":""},on:{"click":_vm.downloadDocument}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/download.svg"),"alt":"download","height":"17"}})]),_vm._v(" "),_c('v-btn',{staticClass:"header-page-download-document",attrs:{"flat":""},on:{"click":_vm.print}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/print.svg"),"alt":"download","height":"17"}})])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_sidebar_vue__ = __webpack_require__(521);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505ab6c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_sidebar_vue__ = __webpack_require__(1261);
function injectStyle (ssrContext) {
  __webpack_require__(1260)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-505ab6c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505ab6c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-sidebar"},[_c('v-container',{staticClass:"grid-list-lg"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_sidebar_button_vue__ = __webpack_require__(522);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e8a360c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_sidebar_button_vue__ = __webpack_require__(1264);
function injectStyle (ssrContext) {
  __webpack_require__(1263)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e8a360c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_sidebar_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e8a360c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_sidebar_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"footer-modal"},[_c('div',{staticClass:"footer-container"},[(!_vm.hidden)?_c('v-btn',{staticClass:"btn-action mr-1",attrs:{"type":"button","color":"error"},on:{"click":_vm.cancelModal}},[_vm._v("\n\t\t\t"+_vm._s(_vm.cancelText)+"\n\t\t")]):_vm._e(),_vm._v(" "),(!_vm.hiddenSaveBtn)?_c('v-btn',{staticClass:"btn-action ml-1",attrs:{"type":"button","color":_vm.successColor,"disabled":_vm.isLoading},on:{"click":_vm.setInfo}},[_vm._v("\n\t\t\t"+_vm._s(_vm.successText)+"\n\t\t")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[550]);


// WEBPACK FOOTER //
// static/js/app.b5818aa26e24f041c048.js